export var Quan_ErrCode = function () {
  //__ENUM_IIFE__
  var Quan_ErrCode;

  (function (Quan_ErrCode) {
    Quan_ErrCode[Quan_ErrCode["Success"] = 0] = "Success";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidPermanentCode"] = 272000] = "ErrInvalidPermanentCode";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidAuth"] = 272001] = "ErrInvalidAuth";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidCode"] = 272002] = "ErrInvalidCode";
    Quan_ErrCode[Quan_ErrCode["ErrNotCorpStaff"] = 272003] = "ErrNotCorpStaff";
    Quan_ErrCode[Quan_ErrCode["ErrCorpNotAuth"] = 272004] = "ErrCorpNotAuth";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidOp"] = 272005] = "ErrInvalidOp";
    Quan_ErrCode[Quan_ErrCode["ErrNotPermitUpdateSelfRole"] = 272006] = "ErrNotPermitUpdateSelfRole";
    Quan_ErrCode[Quan_ErrCode["ErrUserNotFound"] = 272007] = "ErrUserNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrNotPermitUpdateCreator"] = 272008] = "ErrNotPermitUpdateCreator";
    Quan_ErrCode[Quan_ErrCode["ErrNotPermitUpdateToCreator"] = 272009] = "ErrNotPermitUpdateToCreator";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidUserRole"] = 272010] = "ErrInvalidUserRole";
    Quan_ErrCode[Quan_ErrCode["ErrNotPermit"] = 272011] = "ErrNotPermit";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidLossType"] = 272012] = "ErrInvalidLossType";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactNotFound"] = 272013] = "ErrExtContactNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCorpTagGroupNameDup"] = 272014] = "ErrCorpTagGroupNameDup";
    Quan_ErrCode[Quan_ErrCode["ErrCorpTagNameDup"] = 272015] = "ErrCorpTagNameDup";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidTagNameLen"] = 272016] = "ErrInvalidTagNameLen";
    Quan_ErrCode[Quan_ErrCode["ErrCorpTagNotFound"] = 272017] = "ErrCorpTagNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCorpTagNameExisted"] = 272018] = "ErrCorpTagNameExisted";
    Quan_ErrCode[Quan_ErrCode["ErrUserAttrDefNotFound"] = 272019] = "ErrUserAttrDefNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserAttrNameExisted"] = 272020] = "ErrUserAttrNameExisted";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidUserAttrFieldType"] = 272021] = "ErrInvalidUserAttrFieldType";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidFieldValue"] = 272022] = "ErrInvalidFieldValue";
    Quan_ErrCode[Quan_ErrCode["ErrUserAttrIdBothInEnableAndDisableList"] = 272023] = "ErrUserAttrIdBothInEnableAndDisableList";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactFollowNotFound"] = 272024] = "ErrExtContactFollowNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactBatchSendNotFound"] = 272025] = "ErrExtContactBatchSendNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidSchedulerTimeAtPast"] = 272026] = "ErrInvalidSchedulerTimeAtPast";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidSchedulerTimeExceedSysSupport"] = 272027] = "ErrInvalidSchedulerTimeExceedSysSupport";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactEventNotFound"] = 272028] = "ErrExtContactEventNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactBatchSendNotPermitEdit"] = 272029] = "ErrExtContactBatchSendNotPermitEdit";
    Quan_ErrCode[Quan_ErrCode["ErrGroupChatNotFound"] = 272030] = "ErrGroupChatNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrChannelNotFound"] = 272031] = "ErrChannelNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrGetWxAdminLoginQrUrlFailed"] = 272032] = "ErrGetWxAdminLoginQrUrlFailed";
    Quan_ErrCode[Quan_ErrCode["ErrGetWxAdminLoginStateFailed"] = 272033] = "ErrGetWxAdminLoginStateFailed";
    Quan_ErrCode[Quan_ErrCode["ErrUserDoesNotTheWxAdmin"] = 272034] = "ErrUserDoesNotTheWxAdmin";
    Quan_ErrCode[Quan_ErrCode["ErrChannelLiveCodeNotFound"] = 272035] = "ErrChannelLiveCodeNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrInviteGroupByTagNotFound"] = 272036] = "ErrInviteGroupByTagNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrAvailableGroupMemberNotEnough"] = 272037] = "ErrAvailableGroupMemberNotEnough";
    Quan_ErrCode[Quan_ErrCode["ErrSysUserAttrDefNotFound"] = 272038] = "ErrSysUserAttrDefNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrApplyInstallQuanNotFound"] = 272039] = "ErrApplyInstallQuanNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrSetUnauthAppScopeListEmptyList"] = 272040] = "ErrSetUnauthAppScopeListEmptyList";
    Quan_ErrCode[Quan_ErrCode["ErrSetUnauthAppScopeListFailed"] = 272041] = "ErrSetUnauthAppScopeListFailed";
    Quan_ErrCode[Quan_ErrCode["ErrCreateUnauthAppNoConfigInfo"] = 272042] = "ErrCreateUnauthAppNoConfigInfo";
    Quan_ErrCode[Quan_ErrCode["ErrCreateUnauthAppFailed"] = 272043] = "ErrCreateUnauthAppFailed";
    Quan_ErrCode[Quan_ErrCode["ErrModelCorpNotFound"] = 272044] = "ErrModelCorpNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrModelCorpCreateFailed"] = 272045] = "ErrModelCorpCreateFailed";
    Quan_ErrCode[Quan_ErrCode["ErrModelCorpUpdateFailed"] = 272046] = "ErrModelCorpUpdateFailed";
    Quan_ErrCode[Quan_ErrCode["ErrMissOpenId"] = 272047] = "ErrMissOpenId";
    Quan_ErrCode[Quan_ErrCode["ErrScanQuanQrcodeRecordNotFound"] = 272048] = "ErrScanQuanQrcodeRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrMissWwCorpId"] = 272049] = "ErrMissWwCorpId";
    Quan_ErrCode[Quan_ErrCode["ErrInstallQuanStepNotFound"] = 272050] = "ErrInstallQuanStepNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrAlreadyInstalledQuan"] = 272051] = "ErrAlreadyInstalledQuan";
    Quan_ErrCode[Quan_ErrCode["ErrInstallQuanStepUpdateFailed"] = 272052] = "ErrInstallQuanStepUpdateFailed";
    Quan_ErrCode[Quan_ErrCode["ErrCreateUnauthAppNotAllow"] = 272053] = "ErrCreateUnauthAppNotAllow";
    Quan_ErrCode[Quan_ErrCode["ErrGetDeptListFailed"] = 272054] = "ErrGetDeptListFailed";
    Quan_ErrCode[Quan_ErrCode["ErrGetDeptUserListFailed"] = 272055] = "ErrGetDeptUserListFailed";
    Quan_ErrCode[Quan_ErrCode["ErrInitNonAuthAppFailed"] = 272056] = "ErrInitNonAuthAppFailed";
    Quan_ErrCode[Quan_ErrCode["ErrApplyInstallNotFound"] = 272057] = "ErrApplyInstallNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrWxAdminNotLogin"] = 272058] = "ErrWxAdminNotLogin";
    Quan_ErrCode[Quan_ErrCode["ErrConfigNotFound"] = 272059] = "ErrConfigNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrGetWxAdminLoginCorpListFailed"] = 272060] = "ErrGetWxAdminLoginCorpListFailed";
    Quan_ErrCode[Quan_ErrCode["ErrWxAdminSelectCorp2LoginFailed"] = 272061] = "ErrWxAdminSelectCorp2LoginFailed";
    Quan_ErrCode[Quan_ErrCode["ErrWelcomeMsgNotFound"] = 272062] = "ErrWelcomeMsgNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrInstallConfigNotFound"] = 272063] = "ErrInstallConfigNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrAppNotFound"] = 272064] = "ErrAppNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrMissTaskId"] = 272065] = "ErrMissTaskId";
    Quan_ErrCode[Quan_ErrCode["ErrHelpDocNotFound"] = 272066] = "ErrHelpDocNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrHelpDocIdDoesNotExist"] = 272067] = "ErrHelpDocIdDoesNotExist";
    Quan_ErrCode[Quan_ErrCode["ErrSetHelpDocFailed"] = 272068] = "ErrSetHelpDocFailed";
    Quan_ErrCode[Quan_ErrCode["ErrAddHelpDocFailed"] = 272069] = "ErrAddHelpDocFailed";
    Quan_ErrCode[Quan_ErrCode["ErrChangeLogNotFound"] = 272071] = "ErrChangeLogNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrInstallFailed"] = 272072] = "ErrInstallFailed";
    Quan_ErrCode[Quan_ErrCode["ErrCustomizedCustomerClueNotFound"] = 272073] = "ErrCustomizedCustomerClueNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserNotInAuthAppScope"] = 272074] = "ErrUserNotInAuthAppScope";
    Quan_ErrCode[Quan_ErrCode["ErrCreatorNotFound"] = 272075] = "ErrCreatorNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserNotInAppScope"] = 272076] = "ErrUserNotInAppScope";
    Quan_ErrCode[Quan_ErrCode["ErrOverSendExceedLimit"] = 272077] = "ErrOverSendExceedLimit";
    Quan_ErrCode[Quan_ErrCode["ErrMaterialCategoryDupCreate"] = 272078] = "ErrMaterialCategoryDupCreate";
    Quan_ErrCode[Quan_ErrCode["ErrMaterialNotFound"] = 272079] = "ErrMaterialNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrMaterialCategoryNotFound"] = 272080] = "ErrMaterialCategoryNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrMaterialCategoryNameExisted"] = 272081] = "ErrMaterialCategoryNameExisted";
    Quan_ErrCode[Quan_ErrCode["ErrCorpNotFound"] = 272082] = "ErrCorpNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrAppOffSale"] = 272083] = "ErrAppOffSale";
    Quan_ErrCode[Quan_ErrCode["ErrInvoiceNotFound"] = 272084] = "ErrInvoiceNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrChannelStatNotFound"] = 272085] = "ErrChannelStatNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftNotFound"] = 272086] = "ErrSpeechcraftNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftCategoryNotFound"] = 272087] = "ErrSpeechcraftCategoryNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftCategoryNameExisted"] = 272088] = "ErrSpeechcraftCategoryNameExisted";
    Quan_ErrCode[Quan_ErrCode["ErrSidebarTabNotFound"] = 272089] = "ErrSidebarTabNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrOrderNotFound"] = 272090] = "ErrOrderNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrOrderHasBeenIssued"] = 272091] = "ErrOrderHasBeenIssued";
    Quan_ErrCode[Quan_ErrCode["ErrAppNeedPay"] = 272092] = "ErrAppNeedPay";
    Quan_ErrCode[Quan_ErrCode["ErrAppNotConfigured"] = 272093] = "ErrAppNotConfigured";
    Quan_ErrCode[Quan_ErrCode["ErrModelOrderNotFound"] = 272094] = "ErrModelOrderNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrValidityTypeInconsistency"] = 272095] = "ErrValidityTypeInconsistency";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidOrderState"] = 272096] = "ErrInvalidOrderState";
    Quan_ErrCode[Quan_ErrCode["ErrChangeOrderDup"] = 272097] = "ErrChangeOrderDup";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidImageUrl"] = 272098] = "ErrInvalidImageUrl";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidLink"] = 272099] = "ErrInvalidLink";
    Quan_ErrCode[Quan_ErrCode["ErrOrderCannotBeenIssued"] = 272100] = "ErrOrderCannotBeenIssued";
    Quan_ErrCode[Quan_ErrCode["ErrVersionNotFound"] = 272101] = "ErrVersionNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrAppScopeForbidden"] = 272102] = "ErrAppScopeForbidden";
    Quan_ErrCode[Quan_ErrCode["ErrWrongPassword"] = 272103] = "ErrWrongPassword";
    Quan_ErrCode[Quan_ErrCode["ErrExistReady2PayOrder"] = 272104] = "ErrExistReady2PayOrder";
    Quan_ErrCode[Quan_ErrCode["ErrPhoneNotExisted"] = 272105] = "ErrPhoneNotExisted";
    Quan_ErrCode[Quan_ErrCode["ErrVersionExpired"] = 272106] = "ErrVersionExpired";
    Quan_ErrCode[Quan_ErrCode["ErrUnknowVersionBuyType"] = 272107] = "ErrUnknowVersionBuyType";
    Quan_ErrCode[Quan_ErrCode["ErrUserNotActive"] = 272108] = "ErrUserNotActive";
    Quan_ErrCode[Quan_ErrCode["ErrResignedStaffNotFound"] = 272109] = "ErrResignedStaffNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrResignedStaffExtContactNotFound"] = 272110] = "ErrResignedStaffExtContactNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrResignedStaffGroupChatNotFound"] = 272111] = "ErrResignedStaffGroupChatNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrVersionDistributeMax"] = 272112] = "ErrVersionDistributeMax";
    Quan_ErrCode[Quan_ErrCode["ErrVersionNotExpire"] = 272113] = "ErrVersionNotExpire";
    Quan_ErrCode[Quan_ErrCode["ErrCorpVersionExpire"] = 272114] = "ErrCorpVersionExpire";
    Quan_ErrCode[Quan_ErrCode["ErrUserLoginNotDistribute"] = 272115] = "ErrUserLoginNotDistribute";
    Quan_ErrCode[Quan_ErrCode["ErrCorpIdDoesNotExisted"] = 272119] = "ErrCorpIdDoesNotExisted";
    Quan_ErrCode[Quan_ErrCode["ErrUnsupportedAccountType"] = 272120] = "ErrUnsupportedAccountType";
    Quan_ErrCode[Quan_ErrCode["ErrUnsupportedSenderType"] = 272121] = "ErrUnsupportedSenderType";
    Quan_ErrCode[Quan_ErrCode["ErrGetWwAdminLoginQrUrlFailed"] = 272122] = "ErrGetWwAdminLoginQrUrlFailed";
    Quan_ErrCode[Quan_ErrCode["ErrGetWwAdminLoginStateFailed"] = 272123] = "ErrGetWwAdminLoginStateFailed";
    Quan_ErrCode[Quan_ErrCode["ErrWwAdminSelectCorp2LoginFailed"] = 272124] = "ErrWwAdminSelectCorp2LoginFailed";
    Quan_ErrCode[Quan_ErrCode["ErrUserDoesNotTheWwAdmin"] = 272125] = "ErrUserDoesNotTheWwAdmin";
    Quan_ErrCode[Quan_ErrCode["ErrArgsInvalid"] = 272126] = "ErrArgsInvalid";
    Quan_ErrCode[Quan_ErrCode["ErrGetWxContactAppInfoFailed"] = 272127] = "ErrGetWxContactAppInfoFailed";
    Quan_ErrCode[Quan_ErrCode["ErrAddWxDeptFailed"] = 272128] = "ErrAddWxDeptFailed";
    Quan_ErrCode[Quan_ErrCode["ErrGetWxDeptFailed"] = 272129] = "ErrGetWxDeptFailed";
    Quan_ErrCode[Quan_ErrCode["ErrGetWxAppFailed"] = 272130] = "ErrGetWxAppFailed";
    Quan_ErrCode[Quan_ErrCode["ErrFeatureFlagExisted"] = 272131] = "ErrFeatureFlagExisted";
    Quan_ErrCode[Quan_ErrCode["ErrFeatureFlagDoesNotExisted"] = 272132] = "ErrFeatureFlagDoesNotExisted";
    Quan_ErrCode[Quan_ErrCode["ErrDelUserFailed"] = 272133] = "ErrDelUserFailed";
    Quan_ErrCode[Quan_ErrCode["ErrRobotUserDelRecordNotFound"] = 272134] = "ErrRobotUserDelRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUnsupportedActiveState"] = 272135] = "ErrUnsupportedActiveState";
    Quan_ErrCode[Quan_ErrCode["ErrWxAdminEditableContactApp"] = 272136] = "ErrWxAdminEditableContactApp";
    Quan_ErrCode[Quan_ErrCode["ErrWxAdminSetQuanNotifyAppVisitableScope"] = 272137] = "ErrWxAdminSetQuanNotifyAppVisitableScope";
    Quan_ErrCode[Quan_ErrCode["ErrWxAdminSetQuanHelperAppVisitableScope"] = 272138] = "ErrWxAdminSetQuanHelperAppVisitableScope";
    Quan_ErrCode[Quan_ErrCode["ErrWxAdminSetExtContactAppVisitableScope"] = 272139] = "ErrWxAdminSetExtContactAppVisitableScope";
    Quan_ErrCode[Quan_ErrCode["ErrWxAdminEarlyBindBizEmail"] = 272140] = "ErrWxAdminEarlyBindBizEmail";
    Quan_ErrCode[Quan_ErrCode["ErrUserNotExtContactsPermit"] = 272141] = "ErrUserNotExtContactsPermit";
    Quan_ErrCode[Quan_ErrCode["ErrGroupChatMemberNonFriendNotFound"] = 272142] = "ErrGroupChatMemberNonFriendNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrGroupChatMemberNotFound"] = 272143] = "ErrGroupChatMemberNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrModelMiniProgramNotFound"] = 272144] = "ErrModelMiniProgramNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExternalContactScope"] = 272145] = "ErrExternalContactScope";
    Quan_ErrCode[Quan_ErrCode["ErrUserRealNameDoesNotVerified"] = 272146] = "ErrUserRealNameDoesNotVerified";
    Quan_ErrCode[Quan_ErrCode["ErrHttpRequestError"] = 272147] = "ErrHttpRequestError";
    Quan_ErrCode[Quan_ErrCode["ErrCorpTagGroupReachLimit"] = 272148] = "ErrCorpTagGroupReachLimit";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidMiniProgram"] = 272149] = "ErrInvalidMiniProgram";
    Quan_ErrCode[Quan_ErrCode["ErrCorpTagReachLimit"] = 272150] = "ErrCorpTagReachLimit";
    Quan_ErrCode[Quan_ErrCode["ErrMissWwUserId"] = 272151] = "ErrMissWwUserId";
    Quan_ErrCode[Quan_ErrCode["ErrCorpVersionNotFound"] = 272152] = "ErrCorpVersionNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrModelMessageAuditorConfigNotFound"] = 272154] = "ErrModelMessageAuditorConfigNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrModelMessageAuditSwitchNotFound"] = 272155] = "ErrModelMessageAuditSwitchNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactPhoneNotFound"] = 272156] = "ErrExtContactPhoneNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrMessageAuditStateException"] = 272157] = "ErrMessageAuditStateException";
    Quan_ErrCode[Quan_ErrCode["ErrModelMessageAuditNotFound"] = 272158] = "ErrModelMessageAuditNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrMessageAuditExpired"] = 272159] = "ErrMessageAuditExpired";
    Quan_ErrCode[Quan_ErrCode["ErrMiniProgramPathRepeat"] = 272160] = "ErrMiniProgramPathRepeat";
    Quan_ErrCode[Quan_ErrCode["ErrCorpTagGroupNotFound"] = 272161] = "ErrCorpTagGroupNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactEventTimelineNotFound"] = 272162] = "ErrExtContactEventTimelineNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactStatNotFound"] = 272163] = "ErrExtContactStatNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrGroupChatStatNotFound"] = 272164] = "ErrGroupChatStatNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactBatchSendExtNotFound"] = 272165] = "ErrExtContactBatchSendExtNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserInstallAppNotPermit"] = 272166] = "ErrUserInstallAppNotPermit";
    Quan_ErrCode[Quan_ErrCode["ErrUserInstallAppIncomplete"] = 272167] = "ErrUserInstallAppIncomplete";
    Quan_ErrCode[Quan_ErrCode["ErrWeworkNoPrivilege"] = 272168] = "ErrWeworkNoPrivilege";
    Quan_ErrCode[Quan_ErrCode["ErrDeptNotFound"] = 272169] = "ErrDeptNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserRobotMapNotFound"] = 272170] = "ErrUserRobotMapNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrPermissionNotFound"] = 272171] = "ErrPermissionNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrRoleNotFound"] = 272172] = "ErrRoleNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserRoleNotFound"] = 272173] = "ErrUserRoleNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrRoleNameExist"] = 272174] = "ErrRoleNameExist";
    Quan_ErrCode[Quan_ErrCode["ErrRoleNotAllowEdit"] = 272175] = "ErrRoleNotAllowEdit";
    Quan_ErrCode[Quan_ErrCode["ErrModelPermissionNotFound"] = 272176] = "ErrModelPermissionNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrPermissionConstIdExist"] = 272177] = "ErrPermissionConstIdExist";
    Quan_ErrCode[Quan_ErrCode["ErrRoleRobotMapNotFound"] = 272178] = "ErrRoleRobotMapNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrFollowTaggingTaskInProgress"] = 272179] = "ErrFollowTaggingTaskInProgress";
    Quan_ErrCode[Quan_ErrCode["ErrModelPayConfigNotFound"] = 272180] = "ErrModelPayConfigNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrPhoneHasRegister"] = 272181] = "ErrPhoneHasRegister";
    Quan_ErrCode[Quan_ErrCode["ErrAccountNotFound"] = 272182] = "ErrAccountNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCorpAccessDeny"] = 272183] = "ErrCorpAccessDeny";
    Quan_ErrCode[Quan_ErrCode["ErrWeworkInvalidToken"] = 272184] = "ErrWeworkInvalidToken";
    Quan_ErrCode[Quan_ErrCode["ErrModelUserDeptNotFound"] = 272185] = "ErrModelUserDeptNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrModelMenuNotFound"] = 272186] = "ErrModelMenuNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrModelRoleNotFound"] = 272187] = "ErrModelRoleNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrImportRecordNotFound"] = 272188] = "ErrImportRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserNotInDataScope"] = 272189] = "ErrUserNotInDataScope";
    Quan_ErrCode[Quan_ErrCode["ErrSyncExtContactRecordNotFound"] = 272190] = "ErrSyncExtContactRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrModelInvoiceNotFound"] = 272191] = "ErrModelInvoiceNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrNotifyConfigNotFound"] = 272192] = "ErrNotifyConfigNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidParam"] = 272193] = "ErrInvalidParam";
    Quan_ErrCode[Quan_ErrCode["ErrCorpGroupNumConfigNotFound"] = 272194] = "ErrCorpGroupNumConfigNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactTransferCustomerTaskNotFound"] = 272195] = "ErrExtContactTransferCustomerTaskNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactTransferCustomerRecordNotFound"] = 272196] = "ErrExtContactTransferCustomerRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrChannelLiveCodeUserNotFound"] = 272197] = "ErrChannelLiveCodeUserNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrFeatureFlagIsOld"] = 272198] = "ErrFeatureFlagIsOld";
    Quan_ErrCode[Quan_ErrCode["ErrNonAuthAppNotInstall"] = 272199] = "ErrNonAuthAppNotInstall";
    Quan_ErrCode[Quan_ErrCode["ErrMaterialYcPagePathNotFound"] = 272200] = "ErrMaterialYcPagePathNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrMiniProgramPagePathNotFound"] = 272201] = "ErrMiniProgramPagePathNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCountOutOfRange"] = 272202] = "ErrCountOutOfRange";
    Quan_ErrCode[Quan_ErrCode["ErrDeDupChannelLiveCodeNotFound"] = 272203] = "ErrDeDupChannelLiveCodeNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCombinedBusinessAppNotFound"] = 272204] = "ErrCombinedBusinessAppNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCombinedBusinessAppDupCreate"] = 272205] = "ErrCombinedBusinessAppDupCreate";
    Quan_ErrCode[Quan_ErrCode["ErrCombinedBusinessAppGenerateAppCode"] = 272206] = "ErrCombinedBusinessAppGenerateAppCode";
    Quan_ErrCode[Quan_ErrCode["ErrSysUserAttrFieldNameDuplicate"] = 272207] = "ErrSysUserAttrFieldNameDuplicate";
    Quan_ErrCode[Quan_ErrCode["ErrPhoneNumberAlreadyUsed"] = 272208] = "ErrPhoneNumberAlreadyUsed";
    Quan_ErrCode[Quan_ErrCode["ErrBatchSetWelcomeMsg4ChannelLiveCodeNotFound"] = 272209] = "ErrBatchSetWelcomeMsg4ChannelLiveCodeNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCountBatchSetWelcomeMsg4ChannelLiveCodeNotFound"] = 272210] = "ErrCountBatchSetWelcomeMsg4ChannelLiveCodeNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrBindPhoneNumberVerifyCodeExceedLimit"] = 272211] = "ErrBindPhoneNumberVerifyCodeExceedLimit";
    Quan_ErrCode[Quan_ErrCode["ErrAccountSourceDetailNotFound"] = 272212] = "ErrAccountSourceDetailNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidVerifyCode4BindPhone"] = 272213] = "ErrInvalidVerifyCode4BindPhone";
    Quan_ErrCode[Quan_ErrCode["ErrCustomizedTplAuthQrCodeImageNotSet"] = 272214] = "ErrCustomizedTplAuthQrCodeImageNotSet";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftNameRequired"] = 272215] = "ErrSpeechcraftNameRequired";
    Quan_ErrCode[Quan_ErrCode["ErrSameTitleSpeechcraftOverflowMaxCount"] = 272216] = "ErrSameTitleSpeechcraftOverflowMaxCount";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftShareCodeExisted"] = 272217] = "ErrSpeechcraftShareCodeExisted";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftShareCodeNotFound"] = 272218] = "ErrSpeechcraftShareCodeNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrAbnormalData"] = 272219] = "ErrAbnormalData";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftShareCodeExpired"] = 272220] = "ErrSpeechcraftShareCodeExpired";
    Quan_ErrCode[Quan_ErrCode["ErrCacheExpired"] = 272221] = "ErrCacheExpired";
    Quan_ErrCode[Quan_ErrCode["ErrNotAllowImportSelfSpeechcraftShareCode"] = 272222] = "ErrNotAllowImportSelfSpeechcraftShareCode";
    Quan_ErrCode[Quan_ErrCode["ErrOtherCategoryExistsSameTitleSpeechcraft"] = 272223] = "ErrOtherCategoryExistsSameTitleSpeechcraft";
    Quan_ErrCode[Quan_ErrCode["ErrPlatNoticeNotFound"] = 272224] = "ErrPlatNoticeNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserHasBindOtherPersonalAccount"] = 272225] = "ErrUserHasBindOtherPersonalAccount";
    Quan_ErrCode[Quan_ErrCode["ErrPlatNoticeReadRecordNotFound"] = 272226] = "ErrPlatNoticeReadRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrPlatNoticeAlreadyRead"] = 272227] = "ErrPlatNoticeAlreadyRead";
    Quan_ErrCode[Quan_ErrCode["ErrBizOperationRecordNotFound"] = 272228] = "ErrBizOperationRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftShareCodeInvalid"] = 272229] = "ErrSpeechcraftShareCodeInvalid";
    Quan_ErrCode[Quan_ErrCode["ErrBizNotifyNotFound"] = 272230] = "ErrBizNotifyNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrSpeechcraftTitleNotFound"] = 272231] = "ErrSpeechcraftTitleNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrPhoneHasBindOtherAccount"] = 272232] = "ErrPhoneHasBindOtherAccount";
    Quan_ErrCode[Quan_ErrCode["ErrCorpVersionLogNotFound"] = 272233] = "ErrCorpVersionLogNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCorpAliasNameIsExist"] = 272234] = "ErrCorpAliasNameIsExist";
    Quan_ErrCode[Quan_ErrCode["ErrCustomerComplaintNotFound"] = 272235] = "ErrCustomerComplaintNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactAttrNotFound"] = 272236] = "ErrExtContactAttrNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrMiniProgramNotFound"] = 272237] = "ErrMiniProgramNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrLockFollow4SetCorpTagFailed"] = 272238] = "ErrLockFollow4SetCorpTagFailed";
    Quan_ErrCode[Quan_ErrCode["ErrSetCorpTag2FollowFailed"] = 272239] = "ErrSetCorpTag2FollowFailed";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactBatchSendGroupNotFound"] = 272240] = "ErrExtContactBatchSendGroupNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactSecretIncorrect"] = 272241] = "ErrExtContactSecretIncorrect";
    Quan_ErrCode[Quan_ErrCode["ErrContactSecretIncorrect"] = 272242] = "ErrContactSecretIncorrect";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactSecretNotFound"] = 272243] = "ErrExtContactSecretNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrContactSecretNotFound"] = 272244] = "ErrContactSecretNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidExtContactSecret"] = 272245] = "ErrInvalidExtContactSecret";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidContactSecret"] = 272246] = "ErrInvalidContactSecret";
    Quan_ErrCode[Quan_ErrCode["ErrAccountBindCorpOtherUser"] = 272247] = "ErrAccountBindCorpOtherUser";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactBatchSendStaffNotFound"] = 272248] = "ErrExtContactBatchSendStaffNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactBatchSendReqNotFound"] = 272249] = "ErrExtContactBatchSendReqNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExportExtContactFollowListFreqLimit"] = 272250] = "ErrExportExtContactFollowListFreqLimit";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactBatchSendNotExtContact"] = 272251] = "ErrExtContactBatchSendNotExtContact";
    Quan_ErrCode[Quan_ErrCode["ErrChannelLiveCodeAlreadyRelease"] = 272252] = "ErrChannelLiveCodeAlreadyRelease";
    Quan_ErrCode[Quan_ErrCode["ErrChannelImportRecordNotFound"] = 272253] = "ErrChannelImportRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrSyncExtContactFreqLimit"] = 272254] = "ErrSyncExtContactFreqLimit";
    Quan_ErrCode[Quan_ErrCode["ErrExceededFreqLimit"] = 272255] = "ErrExceededFreqLimit";
    Quan_ErrCode[Quan_ErrCode["ErrUnActiveLicenseAccount"] = 272256] = "ErrUnActiveLicenseAccount";
    Quan_ErrCode[Quan_ErrCode["ErrCorpTrialExpired"] = 272257] = "ErrCorpTrialExpired";
    Quan_ErrCode[Quan_ErrCode["ErrWwCorpIdUnknown"] = 272258] = "ErrWwCorpIdUnknown";
    Quan_ErrCode[Quan_ErrCode["ErrFileFormatNotCorrect"] = 272259] = "ErrFileFormatNotCorrect";
    Quan_ErrCode[Quan_ErrCode["ErrFileNotData"] = 272260] = "ErrFileNotData";
    Quan_ErrCode[Quan_ErrCode["ErrWebConfigNotFound"] = 272261] = "ErrWebConfigNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrInvalidVerifyCode"] = 272262] = "ErrInvalidVerifyCode";
    Quan_ErrCode[Quan_ErrCode["ErrVerifyCodeExceedLimit"] = 272263] = "ErrVerifyCodeExceedLimit";
    Quan_ErrCode[Quan_ErrCode["ErrExtUserIdConvertRecordNotFound"] = 272264] = "ErrExtUserIdConvertRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrAccountNotBindPhone"] = 272265] = "ErrAccountNotBindPhone";
    Quan_ErrCode[Quan_ErrCode["ErrSysVersionNotFound"] = 272266] = "ErrSysVersionNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrWxAppBizUseInfoReqNotFound"] = 272267] = "ErrWxAppBizUseInfoReqNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrWxAppBindedBiz"] = 272268] = "ErrWxAppBindedBiz";
    Quan_ErrCode[Quan_ErrCode["ErrWxAppNoOnlined"] = 272269] = "ErrWxAppNoOnlined";
    Quan_ErrCode[Quan_ErrCode["ErrWxAppWebviewDomainOverflow"] = 272270] = "ErrWxAppWebviewDomainOverflow";
    Quan_ErrCode[Quan_ErrCode["ErrSetCorpVersionLess"] = 272271] = "ErrSetCorpVersionLess";
    Quan_ErrCode[Quan_ErrCode["ErrBadWxAppWebviewDomain"] = 272272] = "ErrBadWxAppWebviewDomain";
    Quan_ErrCode[Quan_ErrCode["ErrWatermarkSettingNotFound"] = 272273] = "ErrWatermarkSettingNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactCountNotFound"] = 272274] = "ErrExtContactCountNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrRequiredRole"] = 272275] = "ErrRequiredRole";
    Quan_ErrCode[Quan_ErrCode["ErrTempExtContactUnionIdNotFound"] = 272276] = "ErrTempExtContactUnionIdNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrUserIdConvertRecordNotFound"] = 272277] = "ErrUserIdConvertRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrDeDupChannelLiveCodeScanRecordNotFound"] = 272278] = "ErrDeDupChannelLiveCodeScanRecordNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrCorpRegionConfigNotFound"] = 272279] = "ErrCorpRegionConfigNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrNotifyGroupNotFound"] = 272280] = "ErrNotifyGroupNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrNotifyGroupUserNotFound"] = 272281] = "ErrNotifyGroupUserNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrRobotApplyWwTaskNotFound"] = 272282] = "ErrRobotApplyWwTaskNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExportOverLimit"] = 272283] = "ErrExportOverLimit";
    Quan_ErrCode[Quan_ErrCode["ErrNotifyGroupContentNotFound"] = 272284] = "ErrNotifyGroupContentNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrExtContactBatchSendChangedLogNotFound"] = 272285] = "ErrExtContactBatchSendChangedLogNotFound";
    Quan_ErrCode[Quan_ErrCode["ErrRobotGroupNumConfigNotFound"] = 272286] = "ErrRobotGroupNumConfigNotFound";
  })(Quan_ErrCode || (Quan_ErrCode = {}));

  return Quan_ErrCode;
}();
export var Quan_UserRole = function () {
  //__ENUM_IIFE__
  var Quan_UserRole;

  (function (Quan_UserRole) {
    Quan_UserRole[Quan_UserRole["UserRoleNil"] = 0] = "UserRoleNil";
    Quan_UserRole[Quan_UserRole["UserRoleCreator"] = 1] = "UserRoleCreator";
    Quan_UserRole[Quan_UserRole["UserRoleAdmin"] = 2] = "UserRoleAdmin";
    Quan_UserRole[Quan_UserRole["UserRoleNormalStaff"] = 3] = "UserRoleNormalStaff";
  })(Quan_UserRole || (Quan_UserRole = {}));

  return Quan_UserRole;
}();
export var Quan_UserStatus = function () {
  //__ENUM_IIFE__
  var Quan_UserStatus;

  (function (Quan_UserStatus) {
    Quan_UserStatus[Quan_UserStatus["UserStatusNil"] = 0] = "UserStatusNil";
    Quan_UserStatus[Quan_UserStatus["UserStatusActive"] = 1] = "UserStatusActive";
    Quan_UserStatus[Quan_UserStatus["UserStatusBan"] = 2] = "UserStatusBan";
    Quan_UserStatus[Quan_UserStatus["UserStatusNotActive"] = 4] = "UserStatusNotActive";
    Quan_UserStatus[Quan_UserStatus["UserStatusExit"] = 5] = "UserStatusExit";
  })(Quan_UserStatus || (Quan_UserStatus = {}));

  return Quan_UserStatus;
}(); // @desc: 企业微信端app类型

export var Quan_WxAppType = function () {
  //__ENUM_IIFE__
  var Quan_WxAppType;

  (function (Quan_WxAppType) {
    Quan_WxAppType[Quan_WxAppType["WxAppTypeNil"] = 0] = "WxAppTypeNil";
    Quan_WxAppType[Quan_WxAppType["WxAppTypeExtContactApp"] = 1] = "WxAppTypeExtContactApp";
    Quan_WxAppType[Quan_WxAppType["WxAppTypeContactApp"] = 2] = "WxAppTypeContactApp";
  })(Quan_WxAppType || (Quan_WxAppType = {}));

  return Quan_WxAppType;
}(); // @desc: 渠道活码创建状态

export var Quan_ChannelLiveCodeCreateState = function () {
  //__ENUM_IIFE__
  var Quan_ChannelLiveCodeCreateState;

  (function (Quan_ChannelLiveCodeCreateState) {
    Quan_ChannelLiveCodeCreateState[Quan_ChannelLiveCodeCreateState["ChannelLiveCodeCreateStateNil"] = 0] = "ChannelLiveCodeCreateStateNil";
    Quan_ChannelLiveCodeCreateState[Quan_ChannelLiveCodeCreateState["ChannelLiveCodeCreateStateProcessing"] = 1] = "ChannelLiveCodeCreateStateProcessing";
    Quan_ChannelLiveCodeCreateState[Quan_ChannelLiveCodeCreateState["ChannelLiveCodeCreateStateFinish"] = 2] = "ChannelLiveCodeCreateStateFinish";
  })(Quan_ChannelLiveCodeCreateState || (Quan_ChannelLiveCodeCreateState = {}));

  return Quan_ChannelLiveCodeCreateState;
}(); // @desc: 圈量后台版本
// 如 1.0 / 2.0 等大版本迭代

export var Quan_AppVersion = function () {
  //__ENUM_IIFE__
  var Quan_AppVersion;

  (function (Quan_AppVersion) {
    Quan_AppVersion[Quan_AppVersion["AppVersionNil"] = 0] = "AppVersionNil";
    Quan_AppVersion[Quan_AppVersion["AppVersionV1"] = 1] = "AppVersionV1";
    Quan_AppVersion[Quan_AppVersion["AppVersionV2"] = 2] = "AppVersionV2";
  })(Quan_AppVersion || (Quan_AppVersion = {}));

  return Quan_AppVersion;
}(); // @desc: 外部联系人类型

export var Quan_ExtContactUserType = function () {
  //__ENUM_IIFE__
  var Quan_ExtContactUserType;

  (function (Quan_ExtContactUserType) {
    Quan_ExtContactUserType[Quan_ExtContactUserType["UserTypeNil"] = 0] = "UserTypeNil";
    Quan_ExtContactUserType[Quan_ExtContactUserType["UserTypeWx"] = 1] = "UserTypeWx";
    Quan_ExtContactUserType[Quan_ExtContactUserType["UserTypeWework"] = 2] = "UserTypeWework";
  })(Quan_ExtContactUserType || (Quan_ExtContactUserType = {}));

  return Quan_ExtContactUserType;
}(); // @desc: 添加方式

export var Quan_ModelExtContactFollow_AddWay = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactFollow_AddWay;

  (function (Quan_ModelExtContactFollow_AddWay) {
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayNil"] = 0] = "AddWayNil";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayScanQrCode"] = 1] = "AddWayScanQrCode";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWaySearchPhoneNum"] = 2] = "AddWaySearchPhoneNum";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayCardShare"] = 3] = "AddWayCardShare";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayGroupChat"] = 4] = "AddWayGroupChat";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayDialHistory"] = 5] = "AddWayDialHistory";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayWxContact"] = 6] = "AddWayWxContact";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayWxFriendReq"] = 7] = "AddWayWxFriendReq";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayAuthAppRobot"] = 8] = "AddWayAuthAppRobot";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWaySearchEmail"] = 9] = "AddWaySearchEmail";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayVideoNumberIndex"] = 10] = "AddWayVideoNumberIndex";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayInterMemberShare"] = 201] = "AddWayInterMemberShare";
    Quan_ModelExtContactFollow_AddWay[Quan_ModelExtContactFollow_AddWay["AddWayAdminAlloc"] = 202] = "AddWayAdminAlloc";
  })(Quan_ModelExtContactFollow_AddWay || (Quan_ModelExtContactFollow_AddWay = {}));

  return Quan_ModelExtContactFollow_AddWay;
}();
export var Quan_ModelRobotApplyWwTask_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelRobotApplyWwTask_State;

  (function (Quan_ModelRobotApplyWwTask_State) {
    Quan_ModelRobotApplyWwTask_State[Quan_ModelRobotApplyWwTask_State["StateNil"] = 0] = "StateNil";
    Quan_ModelRobotApplyWwTask_State[Quan_ModelRobotApplyWwTask_State["StateProcess"] = 1] = "StateProcess";
    Quan_ModelRobotApplyWwTask_State[Quan_ModelRobotApplyWwTask_State["StateSuccess"] = 2] = "StateSuccess";
    Quan_ModelRobotApplyWwTask_State[Quan_ModelRobotApplyWwTask_State["StateFail"] = 3] = "StateFail";
  })(Quan_ModelRobotApplyWwTask_State || (Quan_ModelRobotApplyWwTask_State = {}));

  return Quan_ModelRobotApplyWwTask_State;
}();
export var Quan_ModelRobotApplyWwTask_Source = function () {
  //__ENUM_IIFE__
  var Quan_ModelRobotApplyWwTask_Source;

  (function (Quan_ModelRobotApplyWwTask_Source) {
    Quan_ModelRobotApplyWwTask_Source[Quan_ModelRobotApplyWwTask_Source["SourceNil"] = 0] = "SourceNil";
    Quan_ModelRobotApplyWwTask_Source[Quan_ModelRobotApplyWwTask_Source["SourcePhoneImport"] = 1] = "SourcePhoneImport";
    Quan_ModelRobotApplyWwTask_Source[Quan_ModelRobotApplyWwTask_Source["SourceTool"] = 2] = "SourceTool";
  })(Quan_ModelRobotApplyWwTask_Source || (Quan_ModelRobotApplyWwTask_Source = {}));

  return Quan_ModelRobotApplyWwTask_Source;
}();
export var Quan_UserAttrBizType = function () {
  //__ENUM_IIFE__
  var Quan_UserAttrBizType;

  (function (Quan_UserAttrBizType) {
    Quan_UserAttrBizType[Quan_UserAttrBizType["UserAttrBizTypeNil"] = 0] = "UserAttrBizTypeNil";
    Quan_UserAttrBizType[Quan_UserAttrBizType["UserAttrBizTypeExtContact"] = 1] = "UserAttrBizTypeExtContact";
  })(Quan_UserAttrBizType || (Quan_UserAttrBizType = {}));

  return Quan_UserAttrBizType;
}(); // @desc: 自定义用户信息类型

export var Quan_UserAttrFieldType = function () {
  //__ENUM_IIFE__
  var Quan_UserAttrFieldType;

  (function (Quan_UserAttrFieldType) {
    Quan_UserAttrFieldType[Quan_UserAttrFieldType["UserAttrFieldTypeNil"] = 0] = "UserAttrFieldTypeNil";
    Quan_UserAttrFieldType[Quan_UserAttrFieldType["UserAttrFieldTypeText"] = 1] = "UserAttrFieldTypeText";
    Quan_UserAttrFieldType[Quan_UserAttrFieldType["UserAttrFieldTypeSingleChoice"] = 2] = "UserAttrFieldTypeSingleChoice";
    Quan_UserAttrFieldType[Quan_UserAttrFieldType["UserAttrFieldTypeDate"] = 3] = "UserAttrFieldTypeDate";
    Quan_UserAttrFieldType[Quan_UserAttrFieldType["UserAttrFieldTypeLocation"] = 4] = "UserAttrFieldTypeLocation";
  })(Quan_UserAttrFieldType || (Quan_UserAttrFieldType = {}));

  return Quan_UserAttrFieldType;
}();
export var Quan_ExtraMsgType = function () {
  //__ENUM_IIFE__
  var Quan_ExtraMsgType;

  (function (Quan_ExtraMsgType) {
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeNil"] = 0] = "ExtraMsgTypeNil";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeDisable"] = 1] = "ExtraMsgTypeDisable";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeImage"] = 2] = "ExtraMsgTypeImage";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeLink"] = 3] = "ExtraMsgTypeLink";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeMiniProgram"] = 4] = "ExtraMsgTypeMiniProgram";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeText"] = 5] = "ExtraMsgTypeText";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeVideo"] = 6] = "ExtraMsgTypeVideo";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeFile"] = 7] = "ExtraMsgTypeFile";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeVoice"] = 8] = "ExtraMsgTypeVoice";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeFriendCard"] = 9] = "ExtraMsgTypeFriendCard";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypePostImage"] = 10] = "ExtraMsgTypePostImage";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeChannelMsg"] = 11] = "ExtraMsgTypeChannelMsg";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeLocation"] = 12] = "ExtraMsgTypeLocation";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeRecall"] = 13] = "ExtraMsgTypeRecall";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeInviteJoinGroup"] = 14] = "ExtraMsgTypeInviteJoinGroup";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeChatRecord"] = 15] = "ExtraMsgTypeChatRecord";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeStoreProduct"] = 16] = "ExtraMsgTypeStoreProduct";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeChannelLiveMsg"] = 17] = "ExtraMsgTypeChannelLiveMsg";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeCall"] = 18] = "ExtraMsgTypeCall";
    Quan_ExtraMsgType[Quan_ExtraMsgType["ExtraMsgTypeSys"] = 10000] = "ExtraMsgTypeSys";
  })(Quan_ExtraMsgType || (Quan_ExtraMsgType = {}));

  return Quan_ExtraMsgType;
}();
export var Quan_ExtContactFilter_FilterSex = function () {
  //__ENUM_IIFE__
  var Quan_ExtContactFilter_FilterSex;

  (function (Quan_ExtContactFilter_FilterSex) {
    Quan_ExtContactFilter_FilterSex[Quan_ExtContactFilter_FilterSex["FilterSexNil"] = 0] = "FilterSexNil";
    Quan_ExtContactFilter_FilterSex[Quan_ExtContactFilter_FilterSex["FilterSexAll"] = 1] = "FilterSexAll";
    Quan_ExtContactFilter_FilterSex[Quan_ExtContactFilter_FilterSex["FilterSexMale"] = 2] = "FilterSexMale";
    Quan_ExtContactFilter_FilterSex[Quan_ExtContactFilter_FilterSex["FilterSexFemale"] = 3] = "FilterSexFemale";
    Quan_ExtContactFilter_FilterSex[Quan_ExtContactFilter_FilterSex["FilterSexUnknown"] = 4] = "FilterSexUnknown";
  })(Quan_ExtContactFilter_FilterSex || (Quan_ExtContactFilter_FilterSex = {}));

  return Quan_ExtContactFilter_FilterSex;
}();
export var Quan_ExtContactFilter_DeleteStatus = function () {
  //__ENUM_IIFE__
  var Quan_ExtContactFilter_DeleteStatus;

  (function (Quan_ExtContactFilter_DeleteStatus) {
    Quan_ExtContactFilter_DeleteStatus[Quan_ExtContactFilter_DeleteStatus["DeleteStatusNil"] = 0] = "DeleteStatusNil";
    Quan_ExtContactFilter_DeleteStatus[Quan_ExtContactFilter_DeleteStatus["DeleteStatusEither"] = 1] = "DeleteStatusEither";
  })(Quan_ExtContactFilter_DeleteStatus || (Quan_ExtContactFilter_DeleteStatus = {}));

  return Quan_ExtContactFilter_DeleteStatus;
}(); // @desc: 选择类型

export var Quan_SelectType = function () {
  //__ENUM_IIFE__
  var Quan_SelectType;

  (function (Quan_SelectType) {
    Quan_SelectType[Quan_SelectType["SelectTypeNil"] = 0] = "SelectTypeNil";
    Quan_SelectType[Quan_SelectType["SelectTypeAll"] = 1] = "SelectTypeAll";
    Quan_SelectType[Quan_SelectType["SelectTypeAssign"] = 2] = "SelectTypeAssign";
    Quan_SelectType[Quan_SelectType["SelectTypeExcept"] = 3] = "SelectTypeExcept";
  })(Quan_SelectType || (Quan_SelectType = {}));

  return Quan_SelectType;
}(); // @desc: 筛选外部联系人的条件类型

export var Quan_AdvanceExtContactFilter_ExtContactCondition = function () {
  //__ENUM_IIFE__
  var Quan_AdvanceExtContactFilter_ExtContactCondition;

  (function (Quan_AdvanceExtContactFilter_ExtContactCondition) {
    Quan_AdvanceExtContactFilter_ExtContactCondition[Quan_AdvanceExtContactFilter_ExtContactCondition["ExtContactConditionNil"] = 0] = "ExtContactConditionNil";
    Quan_AdvanceExtContactFilter_ExtContactCondition[Quan_AdvanceExtContactFilter_ExtContactCondition["ExtContactConditionAll"] = 1] = "ExtContactConditionAll";
    Quan_AdvanceExtContactFilter_ExtContactCondition[Quan_AdvanceExtContactFilter_ExtContactCondition["ExtContactConditionFilter"] = 2] = "ExtContactConditionFilter";
    Quan_AdvanceExtContactFilter_ExtContactCondition[Quan_AdvanceExtContactFilter_ExtContactCondition["ExtContactConditionAssign"] = 3] = "ExtContactConditionAssign";
    Quan_AdvanceExtContactFilter_ExtContactCondition[Quan_AdvanceExtContactFilter_ExtContactCondition["ExtContactConditionCrowdCluster"] = 10] = "ExtContactConditionCrowdCluster";
  })(Quan_AdvanceExtContactFilter_ExtContactCondition || (Quan_AdvanceExtContactFilter_ExtContactCondition = {}));

  return Quan_AdvanceExtContactFilter_ExtContactCondition;
}();
export var Quan_AdvanceExtContactFilter_FilterNoDelete = function () {
  //__ENUM_IIFE__
  var Quan_AdvanceExtContactFilter_FilterNoDelete;

  (function (Quan_AdvanceExtContactFilter_FilterNoDelete) {
    Quan_AdvanceExtContactFilter_FilterNoDelete[Quan_AdvanceExtContactFilter_FilterNoDelete["FilterNoDeleteNil"] = 0] = "FilterNoDeleteNil";
    Quan_AdvanceExtContactFilter_FilterNoDelete[Quan_AdvanceExtContactFilter_FilterNoDelete["FilterNoDeleteBoth"] = 1] = "FilterNoDeleteBoth";
  })(Quan_AdvanceExtContactFilter_FilterNoDelete || (Quan_AdvanceExtContactFilter_FilterNoDelete = {}));

  return Quan_AdvanceExtContactFilter_FilterNoDelete;
}();
export var Quan_AdvanceExtContactFilter_FilterTag_FilterTagType = function () {
  //__ENUM_IIFE__
  var Quan_AdvanceExtContactFilter_FilterTag_FilterTagType;

  (function (Quan_AdvanceExtContactFilter_FilterTag_FilterTagType) {
    Quan_AdvanceExtContactFilter_FilterTag_FilterTagType[Quan_AdvanceExtContactFilter_FilterTag_FilterTagType["FilterTagTypeNil"] = 0] = "FilterTagTypeNil";
    Quan_AdvanceExtContactFilter_FilterTag_FilterTagType[Quan_AdvanceExtContactFilter_FilterTag_FilterTagType["FilterTagTypeArbitrarily"] = 1] = "FilterTagTypeArbitrarily";
    Quan_AdvanceExtContactFilter_FilterTag_FilterTagType[Quan_AdvanceExtContactFilter_FilterTag_FilterTagType["FilterTagTypeAllContain"] = 2] = "FilterTagTypeAllContain";
    Quan_AdvanceExtContactFilter_FilterTag_FilterTagType[Quan_AdvanceExtContactFilter_FilterTag_FilterTagType["FilterTagTypeAllMatch"] = 3] = "FilterTagTypeAllMatch";
  })(Quan_AdvanceExtContactFilter_FilterTag_FilterTagType || (Quan_AdvanceExtContactFilter_FilterTag_FilterTagType = {}));

  return Quan_AdvanceExtContactFilter_FilterTag_FilterTagType;
}();
export var Quan_AdvanceExtContactFilter_Status = function () {
  //__ENUM_IIFE__
  var Quan_AdvanceExtContactFilter_Status;

  (function (Quan_AdvanceExtContactFilter_Status) {
    Quan_AdvanceExtContactFilter_Status[Quan_AdvanceExtContactFilter_Status["StatusNil"] = 0] = "StatusNil";
    Quan_AdvanceExtContactFilter_Status[Quan_AdvanceExtContactFilter_Status["StatusTrue"] = 1] = "StatusTrue";
    Quan_AdvanceExtContactFilter_Status[Quan_AdvanceExtContactFilter_Status["StatusFalse"] = 2] = "StatusFalse";
  })(Quan_AdvanceExtContactFilter_Status || (Quan_AdvanceExtContactFilter_Status = {}));

  return Quan_AdvanceExtContactFilter_Status;
}(); // @desc: 性别

export var Quan_AdvanceExtContactFilter_FilterGender = function () {
  //__ENUM_IIFE__
  var Quan_AdvanceExtContactFilter_FilterGender;

  (function (Quan_AdvanceExtContactFilter_FilterGender) {
    Quan_AdvanceExtContactFilter_FilterGender[Quan_AdvanceExtContactFilter_FilterGender["FilterGenderNil"] = 0] = "FilterGenderNil";
    Quan_AdvanceExtContactFilter_FilterGender[Quan_AdvanceExtContactFilter_FilterGender["FilterGenderAll"] = 1] = "FilterGenderAll";
    Quan_AdvanceExtContactFilter_FilterGender[Quan_AdvanceExtContactFilter_FilterGender["FilterGenderMale"] = 2] = "FilterGenderMale";
    Quan_AdvanceExtContactFilter_FilterGender[Quan_AdvanceExtContactFilter_FilterGender["FilterGenderFemale"] = 3] = "FilterGenderFemale";
    Quan_AdvanceExtContactFilter_FilterGender[Quan_AdvanceExtContactFilter_FilterGender["FilterGenderUnknown"] = 4] = "FilterGenderUnknown";
  })(Quan_AdvanceExtContactFilter_FilterGender || (Quan_AdvanceExtContactFilter_FilterGender = {}));

  return Quan_AdvanceExtContactFilter_FilterGender;
}();
export var Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay = function () {
  //__ENUM_IIFE__
  var Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay;

  (function (Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay) {
    Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay[Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay["CalcWayNil"] = 0] = "CalcWayNil";
    Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay[Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay["CalcWayUnion"] = 1] = "CalcWayUnion";
  })(Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay || (Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay = {}));

  return Quan_AdvanceExtContactFilter_FilterCrowdCluster_CalcWay;
}(); // @desc: 业务类型

export var Quan_ModelExtContactBatchSend_BizType = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_BizType;

  (function (Quan_ModelExtContactBatchSend_BizType) {
    Quan_ModelExtContactBatchSend_BizType[Quan_ModelExtContactBatchSend_BizType["BizTypeNil"] = 0] = "BizTypeNil";
    Quan_ModelExtContactBatchSend_BizType[Quan_ModelExtContactBatchSend_BizType["BizTypeUserCreate"] = 1] = "BizTypeUserCreate";
    Quan_ModelExtContactBatchSend_BizType[Quan_ModelExtContactBatchSend_BizType["BizTypeInvite2GroupByTag"] = 2] = "BizTypeInvite2GroupByTag";
  })(Quan_ModelExtContactBatchSend_BizType || (Quan_ModelExtContactBatchSend_BizType = {}));

  return Quan_ModelExtContactBatchSend_BizType;
}();
export var Quan_ModelExtContactBatchSend_ChatType = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_ChatType;

  (function (Quan_ModelExtContactBatchSend_ChatType) {
    Quan_ModelExtContactBatchSend_ChatType[Quan_ModelExtContactBatchSend_ChatType["ChatTypeNil"] = 0] = "ChatTypeNil";
    Quan_ModelExtContactBatchSend_ChatType[Quan_ModelExtContactBatchSend_ChatType["ChatTypeSingle"] = 1] = "ChatTypeSingle";
    Quan_ModelExtContactBatchSend_ChatType[Quan_ModelExtContactBatchSend_ChatType["ChatTypeGroup"] = 2] = "ChatTypeGroup";
  })(Quan_ModelExtContactBatchSend_ChatType || (Quan_ModelExtContactBatchSend_ChatType = {}));

  return Quan_ModelExtContactBatchSend_ChatType;
}();
export var Quan_ModelExtContactBatchSend_SendType = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_SendType;

  (function (Quan_ModelExtContactBatchSend_SendType) {
    Quan_ModelExtContactBatchSend_SendType[Quan_ModelExtContactBatchSend_SendType["SendTypeNil"] = 0] = "SendTypeNil";
    Quan_ModelExtContactBatchSend_SendType[Quan_ModelExtContactBatchSend_SendType["SendTypeNow"] = 1] = "SendTypeNow";
    Quan_ModelExtContactBatchSend_SendType[Quan_ModelExtContactBatchSend_SendType["SendTypeSpecTime"] = 2] = "SendTypeSpecTime";
    Quan_ModelExtContactBatchSend_SendType[Quan_ModelExtContactBatchSend_SendType["SendTypeLoop"] = 3] = "SendTypeLoop";
  })(Quan_ModelExtContactBatchSend_SendType || (Quan_ModelExtContactBatchSend_SendType = {}));

  return Quan_ModelExtContactBatchSend_SendType;
}();
export var Quan_ModelExtContactBatchSend_SenderType = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_SenderType;

  (function (Quan_ModelExtContactBatchSend_SenderType) {
    Quan_ModelExtContactBatchSend_SenderType[Quan_ModelExtContactBatchSend_SenderType["SenderTypeNil"] = 0] = "SenderTypeNil";
    Quan_ModelExtContactBatchSend_SenderType[Quan_ModelExtContactBatchSend_SenderType["SenderTypeAll"] = 1] = "SenderTypeAll";
    Quan_ModelExtContactBatchSend_SenderType[Quan_ModelExtContactBatchSend_SenderType["SenderTypeSpec"] = 2] = "SenderTypeSpec";
  })(Quan_ModelExtContactBatchSend_SenderType || (Quan_ModelExtContactBatchSend_SenderType = {}));

  return Quan_ModelExtContactBatchSend_SenderType;
}();
export var Quan_ModelExtContactBatchSend_ReceiverType = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_ReceiverType;

  (function (Quan_ModelExtContactBatchSend_ReceiverType) {
    Quan_ModelExtContactBatchSend_ReceiverType[Quan_ModelExtContactBatchSend_ReceiverType["ReceiverTypeNil"] = 0] = "ReceiverTypeNil";
    Quan_ModelExtContactBatchSend_ReceiverType[Quan_ModelExtContactBatchSend_ReceiverType["ReceiverTypeAll"] = 1] = "ReceiverTypeAll";
    Quan_ModelExtContactBatchSend_ReceiverType[Quan_ModelExtContactBatchSend_ReceiverType["ReceiverTypeFilter"] = 2] = "ReceiverTypeFilter";
    Quan_ModelExtContactBatchSend_ReceiverType[Quan_ModelExtContactBatchSend_ReceiverType["ReceiverTypeCrowdCluster"] = 3] = "ReceiverTypeCrowdCluster";
  })(Quan_ModelExtContactBatchSend_ReceiverType || (Quan_ModelExtContactBatchSend_ReceiverType = {}));

  return Quan_ModelExtContactBatchSend_ReceiverType;
}();
export var Quan_ModelExtContactBatchSend_FilterSex = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_FilterSex;

  (function (Quan_ModelExtContactBatchSend_FilterSex) {
    Quan_ModelExtContactBatchSend_FilterSex[Quan_ModelExtContactBatchSend_FilterSex["FilterSexNil"] = 0] = "FilterSexNil";
    Quan_ModelExtContactBatchSend_FilterSex[Quan_ModelExtContactBatchSend_FilterSex["FilterSexAll"] = 1] = "FilterSexAll";
    Quan_ModelExtContactBatchSend_FilterSex[Quan_ModelExtContactBatchSend_FilterSex["FilterSexMale"] = 2] = "FilterSexMale";
    Quan_ModelExtContactBatchSend_FilterSex[Quan_ModelExtContactBatchSend_FilterSex["FilterSexFemale"] = 3] = "FilterSexFemale";
    Quan_ModelExtContactBatchSend_FilterSex[Quan_ModelExtContactBatchSend_FilterSex["FilterSexUnknown"] = 4] = "FilterSexUnknown";
  })(Quan_ModelExtContactBatchSend_FilterSex || (Quan_ModelExtContactBatchSend_FilterSex = {}));

  return Quan_ModelExtContactBatchSend_FilterSex;
}();
export var Quan_ModelExtContactBatchSend_SendState = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_SendState;

  (function (Quan_ModelExtContactBatchSend_SendState) {
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateNil"] = 0] = "SendStateNil";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateInit"] = 1] = "SendStateInit";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateSending"] = 2] = "SendStateSending";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateSent"] = 3] = "SendStateSent";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateCancel"] = 4] = "SendStateCancel";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateFailed"] = 5] = "SendStateFailed";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStatePartialSent"] = 6] = "SendStatePartialSent";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateLoopProcessing"] = 7] = "SendStateLoopProcessing";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateLoopPaused"] = 8] = "SendStateLoopPaused";
    Quan_ModelExtContactBatchSend_SendState[Quan_ModelExtContactBatchSend_SendState["SendStateAbort"] = 9] = "SendStateAbort";
  })(Quan_ModelExtContactBatchSend_SendState || (Quan_ModelExtContactBatchSend_SendState = {}));

  return Quan_ModelExtContactBatchSend_SendState;
}();
export var Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay;

  (function (Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay) {
    Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay[Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay["CalcWayNil"] = 0] = "CalcWayNil";
    Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay[Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay["CalcWayUnion"] = 1] = "CalcWayUnion";
  })(Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay || (Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay = {}));

  return Quan_ModelExtContactBatchSend_FilterCrowdCluster_CalcWay;
}();
export var Quan_ModelExtContactBatchSend_LoopConfig_LoopType = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSend_LoopConfig_LoopType;

  (function (Quan_ModelExtContactBatchSend_LoopConfig_LoopType) {
    Quan_ModelExtContactBatchSend_LoopConfig_LoopType[Quan_ModelExtContactBatchSend_LoopConfig_LoopType["LoopTypeNil"] = 0] = "LoopTypeNil";
    Quan_ModelExtContactBatchSend_LoopConfig_LoopType[Quan_ModelExtContactBatchSend_LoopConfig_LoopType["LoopTypeMonth"] = 1] = "LoopTypeMonth";
    Quan_ModelExtContactBatchSend_LoopConfig_LoopType[Quan_ModelExtContactBatchSend_LoopConfig_LoopType["LoopTypeWeek"] = 2] = "LoopTypeWeek";
  })(Quan_ModelExtContactBatchSend_LoopConfig_LoopType || (Quan_ModelExtContactBatchSend_LoopConfig_LoopType = {}));

  return Quan_ModelExtContactBatchSend_LoopConfig_LoopType;
}();
export var Quan_ModelExtContactBatchSendChangedLog_Type = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSendChangedLog_Type;

  (function (Quan_ModelExtContactBatchSendChangedLog_Type) {
    Quan_ModelExtContactBatchSendChangedLog_Type[Quan_ModelExtContactBatchSendChangedLog_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ModelExtContactBatchSendChangedLog_Type[Quan_ModelExtContactBatchSendChangedLog_Type["TypeCreate"] = 1] = "TypeCreate";
    Quan_ModelExtContactBatchSendChangedLog_Type[Quan_ModelExtContactBatchSendChangedLog_Type["TypeEdit"] = 2] = "TypeEdit";
    Quan_ModelExtContactBatchSendChangedLog_Type[Quan_ModelExtContactBatchSendChangedLog_Type["TypeUpdateState"] = 3] = "TypeUpdateState";
  })(Quan_ModelExtContactBatchSendChangedLog_Type || (Quan_ModelExtContactBatchSendChangedLog_Type = {}));

  return Quan_ModelExtContactBatchSendChangedLog_Type;
}();
export var Quan_ModelExtContactBatchSendReq_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSendReq_State;

  (function (Quan_ModelExtContactBatchSendReq_State) {
    Quan_ModelExtContactBatchSendReq_State[Quan_ModelExtContactBatchSendReq_State["StateNil"] = 0] = "StateNil";
    Quan_ModelExtContactBatchSendReq_State[Quan_ModelExtContactBatchSendReq_State["StateFinish"] = 1] = "StateFinish";
    Quan_ModelExtContactBatchSendReq_State[Quan_ModelExtContactBatchSendReq_State["StateFailed"] = 2] = "StateFailed";
  })(Quan_ModelExtContactBatchSendReq_State || (Quan_ModelExtContactBatchSendReq_State = {}));

  return Quan_ModelExtContactBatchSendReq_State;
}();
export var Quan_ModelExtContactBatchSendExt_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSendExt_State;

  (function (Quan_ModelExtContactBatchSendExt_State) {
    Quan_ModelExtContactBatchSendExt_State[Quan_ModelExtContactBatchSendExt_State["StateNil"] = 0] = "StateNil";
    Quan_ModelExtContactBatchSendExt_State[Quan_ModelExtContactBatchSendExt_State["StateSent"] = 1] = "StateSent";
    Quan_ModelExtContactBatchSendExt_State[Quan_ModelExtContactBatchSendExt_State["StateNotFriend"] = 2] = "StateNotFriend";
    Quan_ModelExtContactBatchSendExt_State[Quan_ModelExtContactBatchSendExt_State["StateExceedLimit"] = 3] = "StateExceedLimit";
    Quan_ModelExtContactBatchSendExt_State[Quan_ModelExtContactBatchSendExt_State["StateUnknownErr"] = 4] = "StateUnknownErr";
    Quan_ModelExtContactBatchSendExt_State[Quan_ModelExtContactBatchSendExt_State["StateTemplateSent"] = 5] = "StateTemplateSent";
    Quan_ModelExtContactBatchSendExt_State[Quan_ModelExtContactBatchSendExt_State["StateAborted"] = 6] = "StateAborted";
  })(Quan_ModelExtContactBatchSendExt_State || (Quan_ModelExtContactBatchSendExt_State = {}));

  return Quan_ModelExtContactBatchSendExt_State;
}();
export var Quan_ModelExtContactBatchSendGroup_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactBatchSendGroup_State;

  (function (Quan_ModelExtContactBatchSendGroup_State) {
    Quan_ModelExtContactBatchSendGroup_State[Quan_ModelExtContactBatchSendGroup_State["StateNil"] = 0] = "StateNil";
    Quan_ModelExtContactBatchSendGroup_State[Quan_ModelExtContactBatchSendGroup_State["StateSent"] = 1] = "StateSent";
    Quan_ModelExtContactBatchSendGroup_State[Quan_ModelExtContactBatchSendGroup_State["StateSendFail"] = 2] = "StateSendFail";
    Quan_ModelExtContactBatchSendGroup_State[Quan_ModelExtContactBatchSendGroup_State["StateTemplateSent"] = 5] = "StateTemplateSent";
  })(Quan_ModelExtContactBatchSendGroup_State || (Quan_ModelExtContactBatchSendGroup_State = {}));

  return Quan_ModelExtContactBatchSendGroup_State;
}();
export var Quan_ModelExtContactEventTimeline_SubType = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactEventTimeline_SubType;

  (function (Quan_ModelExtContactEventTimeline_SubType) {
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeNil"] = 0] = "SubTypeNil";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeAddExtContact"] = 1] = "SubTypeAddExtContact";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeDelExtContact"] = 2] = "SubTypeDelExtContact";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeDelByExtContact"] = 3] = "SubTypeDelByExtContact";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeSetTag"] = 4] = "SubTypeSetTag";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeCustom"] = 5] = "SubTypeCustom";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeExtContactPaidOrder"] = 6] = "SubTypeExtContactPaidOrder";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeRedPacket"] = 7] = "SubTypeRedPacket";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeRadarEvent"] = 8] = "SubTypeRadarEvent";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeRadarEventTag"] = 9] = "SubTypeRadarEventTag";
    Quan_ModelExtContactEventTimeline_SubType[Quan_ModelExtContactEventTimeline_SubType["SubTypeSetOrderAchievementUser"] = 10] = "SubTypeSetOrderAchievementUser";
  })(Quan_ModelExtContactEventTimeline_SubType || (Quan_ModelExtContactEventTimeline_SubType = {}));

  return Quan_ModelExtContactEventTimeline_SubType;
}();
export var Quan_ModelExtContactEventTimeline_SetTagType = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactEventTimeline_SetTagType;

  (function (Quan_ModelExtContactEventTimeline_SetTagType) {
    Quan_ModelExtContactEventTimeline_SetTagType[Quan_ModelExtContactEventTimeline_SetTagType["SetTagTypeNil"] = 0] = "SetTagTypeNil";
    Quan_ModelExtContactEventTimeline_SetTagType[Quan_ModelExtContactEventTimeline_SetTagType["SetTagTypeAdd"] = 1] = "SetTagTypeAdd";
    Quan_ModelExtContactEventTimeline_SetTagType[Quan_ModelExtContactEventTimeline_SetTagType["SetTagTypeDel"] = 2] = "SetTagTypeDel";
  })(Quan_ModelExtContactEventTimeline_SetTagType || (Quan_ModelExtContactEventTimeline_SetTagType = {}));

  return Quan_ModelExtContactEventTimeline_SetTagType;
}();
export var Quan_ModelGroupChat_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelGroupChat_State;

  (function (Quan_ModelGroupChat_State) {
    Quan_ModelGroupChat_State[Quan_ModelGroupChat_State["StateNil"] = 0] = "StateNil";
    Quan_ModelGroupChat_State[Quan_ModelGroupChat_State["StateNormal"] = 1] = "StateNormal";
    Quan_ModelGroupChat_State[Quan_ModelGroupChat_State["StateFollowerLeave"] = 2] = "StateFollowerLeave";
    Quan_ModelGroupChat_State[Quan_ModelGroupChat_State["StateLeaveInheriting"] = 3] = "StateLeaveInheriting";
    Quan_ModelGroupChat_State[Quan_ModelGroupChat_State["StateLeaveInheritCompleted"] = 4] = "StateLeaveInheritCompleted";
    Quan_ModelGroupChat_State[Quan_ModelGroupChat_State["StateUnknown"] = 5] = "StateUnknown";
  })(Quan_ModelGroupChat_State || (Quan_ModelGroupChat_State = {}));

  return Quan_ModelGroupChat_State;
}();
export var Quan_ModelGroupChatMember_JoinScene = function () {
  //__ENUM_IIFE__
  var Quan_ModelGroupChatMember_JoinScene;

  (function (Quan_ModelGroupChatMember_JoinScene) {
    Quan_ModelGroupChatMember_JoinScene[Quan_ModelGroupChatMember_JoinScene["JoinSceneNil"] = 0] = "JoinSceneNil";
    Quan_ModelGroupChatMember_JoinScene[Quan_ModelGroupChatMember_JoinScene["JoinSceneInvite"] = 1] = "JoinSceneInvite";
    Quan_ModelGroupChatMember_JoinScene[Quan_ModelGroupChatMember_JoinScene["JoinSceneInviteLink"] = 2] = "JoinSceneInviteLink";
    Quan_ModelGroupChatMember_JoinScene[Quan_ModelGroupChatMember_JoinScene["JoinSceneScanQrCode"] = 3] = "JoinSceneScanQrCode";
  })(Quan_ModelGroupChatMember_JoinScene || (Quan_ModelGroupChatMember_JoinScene = {}));

  return Quan_ModelGroupChatMember_JoinScene;
}();
export var Quan_ModelGroupChatMember_Type = function () {
  //__ENUM_IIFE__
  var Quan_ModelGroupChatMember_Type;

  (function (Quan_ModelGroupChatMember_Type) {
    Quan_ModelGroupChatMember_Type[Quan_ModelGroupChatMember_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ModelGroupChatMember_Type[Quan_ModelGroupChatMember_Type["TypeStaff"] = 1] = "TypeStaff";
    Quan_ModelGroupChatMember_Type[Quan_ModelGroupChatMember_Type["TypeExtContact"] = 2] = "TypeExtContact";
  })(Quan_ModelGroupChatMember_Type || (Quan_ModelGroupChatMember_Type = {}));

  return Quan_ModelGroupChatMember_Type;
}();
export var Quan_ModelChannelLiveCode_EnableType = function () {
  //__ENUM_IIFE__
  var Quan_ModelChannelLiveCode_EnableType;

  (function (Quan_ModelChannelLiveCode_EnableType) {
    Quan_ModelChannelLiveCode_EnableType[Quan_ModelChannelLiveCode_EnableType["EnableTypeNil"] = 0] = "EnableTypeNil";
    Quan_ModelChannelLiveCode_EnableType[Quan_ModelChannelLiveCode_EnableType["EnableTypeAllDay"] = 1] = "EnableTypeAllDay";
    Quan_ModelChannelLiveCode_EnableType[Quan_ModelChannelLiveCode_EnableType["EnableTypeSpecRange"] = 2] = "EnableTypeSpecRange";
  })(Quan_ModelChannelLiveCode_EnableType || (Quan_ModelChannelLiveCode_EnableType = {}));

  return Quan_ModelChannelLiveCode_EnableType;
}();
export var Quan_ModelChannelLiveCode_WelcomeMsgType = function () {
  //__ENUM_IIFE__
  var Quan_ModelChannelLiveCode_WelcomeMsgType;

  (function (Quan_ModelChannelLiveCode_WelcomeMsgType) {
    Quan_ModelChannelLiveCode_WelcomeMsgType[Quan_ModelChannelLiveCode_WelcomeMsgType["WelcomeMsgTypeNil"] = 0] = "WelcomeMsgTypeNil";
    Quan_ModelChannelLiveCode_WelcomeMsgType[Quan_ModelChannelLiveCode_WelcomeMsgType["WelcomeMsgTypeCustom"] = 1] = "WelcomeMsgTypeCustom";
    Quan_ModelChannelLiveCode_WelcomeMsgType[Quan_ModelChannelLiveCode_WelcomeMsgType["WelcomeMsgTypeDefault"] = 2] = "WelcomeMsgTypeDefault";
    Quan_ModelChannelLiveCode_WelcomeMsgType[Quan_ModelChannelLiveCode_WelcomeMsgType["WelcomeMsgTypeDisable"] = 3] = "WelcomeMsgTypeDisable";
  })(Quan_ModelChannelLiveCode_WelcomeMsgType || (Quan_ModelChannelLiveCode_WelcomeMsgType = {}));

  return Quan_ModelChannelLiveCode_WelcomeMsgType;
}();
export var Quan_ModelChannelLiveCode_Type = function () {
  //__ENUM_IIFE__
  var Quan_ModelChannelLiveCode_Type;

  (function (Quan_ModelChannelLiveCode_Type) {
    Quan_ModelChannelLiveCode_Type[Quan_ModelChannelLiveCode_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ModelChannelLiveCode_Type[Quan_ModelChannelLiveCode_Type["TypeMultiplayer"] = 1] = "TypeMultiplayer";
    Quan_ModelChannelLiveCode_Type[Quan_ModelChannelLiveCode_Type["TypeBatchSingle"] = 2] = "TypeBatchSingle";
    Quan_ModelChannelLiveCode_Type[Quan_ModelChannelLiveCode_Type["TypeDeDup"] = 3] = "TypeDeDup";
  })(Quan_ModelChannelLiveCode_Type || (Quan_ModelChannelLiveCode_Type = {}));

  return Quan_ModelChannelLiveCode_Type;
}();
export var Quan_ModelChannelLiveCode_LiveCodeState = function () {
  //__ENUM_IIFE__
  var Quan_ModelChannelLiveCode_LiveCodeState;

  (function (Quan_ModelChannelLiveCode_LiveCodeState) {
    Quan_ModelChannelLiveCode_LiveCodeState[Quan_ModelChannelLiveCode_LiveCodeState["LiveCodeStateNil"] = 0] = "LiveCodeStateNil";
    Quan_ModelChannelLiveCode_LiveCodeState[Quan_ModelChannelLiveCode_LiveCodeState["LiveCodeStateProcessing"] = 1] = "LiveCodeStateProcessing";
    Quan_ModelChannelLiveCode_LiveCodeState[Quan_ModelChannelLiveCode_LiveCodeState["LiveCodeStatePartRelease"] = 2] = "LiveCodeStatePartRelease";
    Quan_ModelChannelLiveCode_LiveCodeState[Quan_ModelChannelLiveCode_LiveCodeState["LiveCodeStateRelease"] = 3] = "LiveCodeStateRelease";
  })(Quan_ModelChannelLiveCode_LiveCodeState || (Quan_ModelChannelLiveCode_LiveCodeState = {}));

  return Quan_ModelChannelLiveCode_LiveCodeState;
}();
export var Quan_ModelUserInstall_CorpInstallState = function () {
  //__ENUM_IIFE__
  var Quan_ModelUserInstall_CorpInstallState;

  (function (Quan_ModelUserInstall_CorpInstallState) {
    Quan_ModelUserInstall_CorpInstallState[Quan_ModelUserInstall_CorpInstallState["CorpInstallStateNil"] = 0] = "CorpInstallStateNil";
    Quan_ModelUserInstall_CorpInstallState[Quan_ModelUserInstall_CorpInstallState["CorpInstallStateInstalling"] = 1] = "CorpInstallStateInstalling";
    Quan_ModelUserInstall_CorpInstallState[Quan_ModelUserInstall_CorpInstallState["CorpInstallStateSuccess"] = 2] = "CorpInstallStateSuccess";
  })(Quan_ModelUserInstall_CorpInstallState || (Quan_ModelUserInstall_CorpInstallState = {}));

  return Quan_ModelUserInstall_CorpInstallState;
}();
export var Quan_ModelApplyInstall_QYWXVerifiedState = function () {
  //__ENUM_IIFE__
  var Quan_ModelApplyInstall_QYWXVerifiedState;

  (function (Quan_ModelApplyInstall_QYWXVerifiedState) {
    Quan_ModelApplyInstall_QYWXVerifiedState[Quan_ModelApplyInstall_QYWXVerifiedState["QYWXVerifiedStateNil"] = 0] = "QYWXVerifiedStateNil";
    Quan_ModelApplyInstall_QYWXVerifiedState[Quan_ModelApplyInstall_QYWXVerifiedState["QYWXVerifiedStateVerified"] = 1] = "QYWXVerifiedStateVerified";
    Quan_ModelApplyInstall_QYWXVerifiedState[Quan_ModelApplyInstall_QYWXVerifiedState["QYWXVerifiedStateUnverified"] = 2] = "QYWXVerifiedStateUnverified";
    Quan_ModelApplyInstall_QYWXVerifiedState[Quan_ModelApplyInstall_QYWXVerifiedState["QYWXVerifiedStateUnregistered"] = 3] = "QYWXVerifiedStateUnregistered";
  })(Quan_ModelApplyInstall_QYWXVerifiedState || (Quan_ModelApplyInstall_QYWXVerifiedState = {}));

  return Quan_ModelApplyInstall_QYWXVerifiedState;
}();
export var Quan_InstallQuanFailReasonType = function () {
  //__ENUM_IIFE__
  var Quan_InstallQuanFailReasonType;

  (function (Quan_InstallQuanFailReasonType) {
    Quan_InstallQuanFailReasonType[Quan_InstallQuanFailReasonType["InstallQuanFailReasonTypeNil"] = 0] = "InstallQuanFailReasonTypeNil";
    Quan_InstallQuanFailReasonType[Quan_InstallQuanFailReasonType["InstallQuanFailReasonTypePermissionDeny"] = 1] = "InstallQuanFailReasonTypePermissionDeny";
    Quan_InstallQuanFailReasonType[Quan_InstallQuanFailReasonType["InstallQuanFailReasonTypeSystemErr"] = 2] = "InstallQuanFailReasonTypeSystemErr";
    Quan_InstallQuanFailReasonType[Quan_InstallQuanFailReasonType["InstallQuanFailReasonTypeNotMatch"] = 3] = "InstallQuanFailReasonTypeNotMatch";
    Quan_InstallQuanFailReasonType[Quan_InstallQuanFailReasonType["InstallQuanFailReasonTypeAlreadyInstalled"] = 4] = "InstallQuanFailReasonTypeAlreadyInstalled";
    Quan_InstallQuanFailReasonType[Quan_InstallQuanFailReasonType["InstallQuanFailReasonTypeMissConfig"] = 5] = "InstallQuanFailReasonTypeMissConfig";
  })(Quan_InstallQuanFailReasonType || (Quan_InstallQuanFailReasonType = {}));

  return Quan_InstallQuanFailReasonType;
}();
export var Quan_ModelCustomizedCustomerClue_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelCustomizedCustomerClue_State;

  (function (Quan_ModelCustomizedCustomerClue_State) {
    Quan_ModelCustomizedCustomerClue_State[Quan_ModelCustomizedCustomerClue_State["StateNil"] = 0] = "StateNil";
    Quan_ModelCustomizedCustomerClue_State[Quan_ModelCustomizedCustomerClue_State["StateUserSubmit"] = 1] = "StateUserSubmit";
    Quan_ModelCustomizedCustomerClue_State[Quan_ModelCustomizedCustomerClue_State["StateStaffFollowing"] = 2] = "StateStaffFollowing";
    Quan_ModelCustomizedCustomerClue_State[Quan_ModelCustomizedCustomerClue_State["StateFinish"] = 3] = "StateFinish";
  })(Quan_ModelCustomizedCustomerClue_State || (Quan_ModelCustomizedCustomerClue_State = {}));

  return Quan_ModelCustomizedCustomerClue_State;
}();
export var Quan_ModelMaterialCategory_CategoryType = function () {
  //__ENUM_IIFE__
  var Quan_ModelMaterialCategory_CategoryType;

  (function (Quan_ModelMaterialCategory_CategoryType) {
    Quan_ModelMaterialCategory_CategoryType[Quan_ModelMaterialCategory_CategoryType["CategoryTypeNil"] = 0] = "CategoryTypeNil";
    Quan_ModelMaterialCategory_CategoryType[Quan_ModelMaterialCategory_CategoryType["CategoryTypeAll"] = 1] = "CategoryTypeAll";
    Quan_ModelMaterialCategory_CategoryType[Quan_ModelMaterialCategory_CategoryType["CategoryTypeAssign"] = 2] = "CategoryTypeAssign";
  })(Quan_ModelMaterialCategory_CategoryType || (Quan_ModelMaterialCategory_CategoryType = {}));

  return Quan_ModelMaterialCategory_CategoryType;
}();
export var Quan_ModelMaterialCategory_SideBarRoleType = function () {
  //__ENUM_IIFE__
  var Quan_ModelMaterialCategory_SideBarRoleType;

  (function (Quan_ModelMaterialCategory_SideBarRoleType) {
    Quan_ModelMaterialCategory_SideBarRoleType[Quan_ModelMaterialCategory_SideBarRoleType["SSideBarRoleTypeNil"] = 0] = "SSideBarRoleTypeNil";
    Quan_ModelMaterialCategory_SideBarRoleType[Quan_ModelMaterialCategory_SideBarRoleType["SideBarRoleTypeAll"] = 1] = "SideBarRoleTypeAll";
    Quan_ModelMaterialCategory_SideBarRoleType[Quan_ModelMaterialCategory_SideBarRoleType["SideBarRoleTypeAssign"] = 2] = "SideBarRoleTypeAssign";
    Quan_ModelMaterialCategory_SideBarRoleType[Quan_ModelMaterialCategory_SideBarRoleType["SideBarRoleTypeSelf"] = 3] = "SideBarRoleTypeSelf";
  })(Quan_ModelMaterialCategory_SideBarRoleType || (Quan_ModelMaterialCategory_SideBarRoleType = {}));

  return Quan_ModelMaterialCategory_SideBarRoleType;
}();
export var Quan_ModelMaterial_Type = function () {
  //__ENUM_IIFE__
  var Quan_ModelMaterial_Type;

  (function (Quan_ModelMaterial_Type) {
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeText"] = 1] = "TypeText";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeWeb"] = 2] = "TypeWeb";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypePicture"] = 3] = "TypePicture";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeVideo"] = 4] = "TypeVideo";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeFile"] = 5] = "TypeFile";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeAudio"] = 6] = "TypeAudio";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeMiniProgram"] = 7] = "TypeMiniProgram";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeYcMiniProgram"] = 8] = "TypeYcMiniProgram";
    Quan_ModelMaterial_Type[Quan_ModelMaterial_Type["TypeChannelMsg"] = 11] = "TypeChannelMsg";
  })(Quan_ModelMaterial_Type || (Quan_ModelMaterial_Type = {}));

  return Quan_ModelMaterial_Type;
}();
export var Quan_ModelMaterial_Detail_UserType = function () {
  //__ENUM_IIFE__
  var Quan_ModelMaterial_Detail_UserType;

  (function (Quan_ModelMaterial_Detail_UserType) {
    Quan_ModelMaterial_Detail_UserType[Quan_ModelMaterial_Detail_UserType["UserTypeNil"] = 0] = "UserTypeNil";
    Quan_ModelMaterial_Detail_UserType[Quan_ModelMaterial_Detail_UserType["UserTypeQwhale"] = 1] = "UserTypeQwhale";
  })(Quan_ModelMaterial_Detail_UserType || (Quan_ModelMaterial_Detail_UserType = {}));

  return Quan_ModelMaterial_Detail_UserType;
}();
export var Quan_ModelMaterial_ChannelType = function () {
  //__ENUM_IIFE__
  var Quan_ModelMaterial_ChannelType;

  (function (Quan_ModelMaterial_ChannelType) {
    Quan_ModelMaterial_ChannelType[Quan_ModelMaterial_ChannelType["ChannelTypeVideo"] = 0] = "ChannelTypeVideo";
    Quan_ModelMaterial_ChannelType[Quan_ModelMaterial_ChannelType["ChannelTypeLive"] = 2] = "ChannelTypeLive";
  })(Quan_ModelMaterial_ChannelType || (Quan_ModelMaterial_ChannelType = {}));

  return Quan_ModelMaterial_ChannelType;
}();
export var Quan_ModelMaterial_SubType = function () {
  //__ENUM_IIFE__
  var Quan_ModelMaterial_SubType;

  (function (Quan_ModelMaterial_SubType) {
    Quan_ModelMaterial_SubType[Quan_ModelMaterial_SubType["SubTypeNil"] = 0] = "SubTypeNil";
    Quan_ModelMaterial_SubType[Quan_ModelMaterial_SubType["SubTypeLive"] = 1] = "SubTypeLive";
  })(Quan_ModelMaterial_SubType || (Quan_ModelMaterial_SubType = {}));

  return Quan_ModelMaterial_SubType;
}();
export var Quan_ModelSpeechcraftCategory_SideBarRoleType = function () {
  //__ENUM_IIFE__
  var Quan_ModelSpeechcraftCategory_SideBarRoleType;

  (function (Quan_ModelSpeechcraftCategory_SideBarRoleType) {
    Quan_ModelSpeechcraftCategory_SideBarRoleType[Quan_ModelSpeechcraftCategory_SideBarRoleType["SSideBarRoleTypeNil"] = 0] = "SSideBarRoleTypeNil";
    Quan_ModelSpeechcraftCategory_SideBarRoleType[Quan_ModelSpeechcraftCategory_SideBarRoleType["SideBarRoleTypeAll"] = 1] = "SideBarRoleTypeAll";
    Quan_ModelSpeechcraftCategory_SideBarRoleType[Quan_ModelSpeechcraftCategory_SideBarRoleType["SideBarRoleTypeAssign"] = 2] = "SideBarRoleTypeAssign";
    Quan_ModelSpeechcraftCategory_SideBarRoleType[Quan_ModelSpeechcraftCategory_SideBarRoleType["SideBarRoleTypeSelf"] = 3] = "SideBarRoleTypeSelf";
  })(Quan_ModelSpeechcraftCategory_SideBarRoleType || (Quan_ModelSpeechcraftCategory_SideBarRoleType = {}));

  return Quan_ModelSpeechcraftCategory_SideBarRoleType;
}();
export var Quan_ModelSpeechcraft_ContentType = function () {
  //__ENUM_IIFE__
  var Quan_ModelSpeechcraft_ContentType;

  (function (Quan_ModelSpeechcraft_ContentType) {
    Quan_ModelSpeechcraft_ContentType[Quan_ModelSpeechcraft_ContentType["ContentTypeText"] = 0] = "ContentTypeText";
    Quan_ModelSpeechcraft_ContentType[Quan_ModelSpeechcraft_ContentType["ContentTypeWebLink"] = 1] = "ContentTypeWebLink";
    Quan_ModelSpeechcraft_ContentType[Quan_ModelSpeechcraft_ContentType["ContentTypeImage"] = 2] = "ContentTypeImage";
    Quan_ModelSpeechcraft_ContentType[Quan_ModelSpeechcraft_ContentType["ContentTypeVideo"] = 3] = "ContentTypeVideo";
    Quan_ModelSpeechcraft_ContentType[Quan_ModelSpeechcraft_ContentType["ContentTypeFile"] = 4] = "ContentTypeFile";
    Quan_ModelSpeechcraft_ContentType[Quan_ModelSpeechcraft_ContentType["ContentTypeVoice"] = 5] = "ContentTypeVoice";
  })(Quan_ModelSpeechcraft_ContentType || (Quan_ModelSpeechcraft_ContentType = {}));

  return Quan_ModelSpeechcraft_ContentType;
}();
export var Quan_ModelSpeechcraftShareCode_Status = function () {
  //__ENUM_IIFE__
  var Quan_ModelSpeechcraftShareCode_Status;

  (function (Quan_ModelSpeechcraftShareCode_Status) {
    Quan_ModelSpeechcraftShareCode_Status[Quan_ModelSpeechcraftShareCode_Status["StatusNil"] = 0] = "StatusNil";
    Quan_ModelSpeechcraftShareCode_Status[Quan_ModelSpeechcraftShareCode_Status["StatusNormal"] = 1] = "StatusNormal";
    Quan_ModelSpeechcraftShareCode_Status[Quan_ModelSpeechcraftShareCode_Status["StatusInvalid"] = 2] = "StatusInvalid";
  })(Quan_ModelSpeechcraftShareCode_Status || (Quan_ModelSpeechcraftShareCode_Status = {}));

  return Quan_ModelSpeechcraftShareCode_Status;
}();
export var Quan_ModelPermission_MenuLabel = function () {
  //__ENUM_IIFE__
  var Quan_ModelPermission_MenuLabel;

  (function (Quan_ModelPermission_MenuLabel) {
    Quan_ModelPermission_MenuLabel[Quan_ModelPermission_MenuLabel["MenuLabelNil"] = 0] = "MenuLabelNil";
    Quan_ModelPermission_MenuLabel[Quan_ModelPermission_MenuLabel["MenuLabelNew"] = 1] = "MenuLabelNew";
    Quan_ModelPermission_MenuLabel[Quan_ModelPermission_MenuLabel["MenuLabelRecommend"] = 2] = "MenuLabelRecommend";
    Quan_ModelPermission_MenuLabel[Quan_ModelPermission_MenuLabel["MenuLabelInternalTest"] = 3] = "MenuLabelInternalTest";
  })(Quan_ModelPermission_MenuLabel || (Quan_ModelPermission_MenuLabel = {}));

  return Quan_ModelPermission_MenuLabel;
}();
export var Quan_ModelRole_RoleType = function () {
  //__ENUM_IIFE__
  var Quan_ModelRole_RoleType;

  (function (Quan_ModelRole_RoleType) {
    Quan_ModelRole_RoleType[Quan_ModelRole_RoleType["RoleTypeNil"] = 0] = "RoleTypeNil";
    Quan_ModelRole_RoleType[Quan_ModelRole_RoleType["RoleTypeCreator"] = 1] = "RoleTypeCreator";
    Quan_ModelRole_RoleType[Quan_ModelRole_RoleType["RoleTypeAdmin"] = 2] = "RoleTypeAdmin";
    Quan_ModelRole_RoleType[Quan_ModelRole_RoleType["RoleTypeDefault"] = 3] = "RoleTypeDefault";
    Quan_ModelRole_RoleType[Quan_ModelRole_RoleType["RoleTypeNormal"] = 4] = "RoleTypeNormal";
  })(Quan_ModelRole_RoleType || (Quan_ModelRole_RoleType = {}));

  return Quan_ModelRole_RoleType;
}();
export var Quan_ModelRole_DataScope_Scope = function () {
  //__ENUM_IIFE__
  var Quan_ModelRole_DataScope_Scope;

  (function (Quan_ModelRole_DataScope_Scope) {
    Quan_ModelRole_DataScope_Scope[Quan_ModelRole_DataScope_Scope["ScopeNil"] = 0] = "ScopeNil";
    Quan_ModelRole_DataScope_Scope[Quan_ModelRole_DataScope_Scope["ScopeAll"] = 1] = "ScopeAll";
    Quan_ModelRole_DataScope_Scope[Quan_ModelRole_DataScope_Scope["ScopeSelf"] = 2] = "ScopeSelf";
    Quan_ModelRole_DataScope_Scope[Quan_ModelRole_DataScope_Scope["ScopeDept"] = 3] = "ScopeDept";
  })(Quan_ModelRole_DataScope_Scope || (Quan_ModelRole_DataScope_Scope = {}));

  return Quan_ModelRole_DataScope_Scope;
}(); // @desc: 版本
// @see: https://pinfire.feishu.cn/wiki/wikcnMFp7Wpj2fejxnKQE7BOJlg

export var Quan_VersionSpuType = function () {
  //__ENUM_IIFE__
  var Quan_VersionSpuType;

  (function (Quan_VersionSpuType) {
    Quan_VersionSpuType[Quan_VersionSpuType["VersionNil"] = 0] = "VersionNil";
    Quan_VersionSpuType[Quan_VersionSpuType["VersionBase"] = 1] = "VersionBase";
    Quan_VersionSpuType[Quan_VersionSpuType["VersionAdvance"] = 2] = "VersionAdvance";
    Quan_VersionSpuType[Quan_VersionSpuType["VersionFlagship"] = 3] = "VersionFlagship";
    Quan_VersionSpuType[Quan_VersionSpuType["VersionAdvanceProbation"] = 4] = "VersionAdvanceProbation";
    Quan_VersionSpuType[Quan_VersionSpuType["VersionBaseTrial"] = 100001] = "VersionBaseTrial";
    Quan_VersionSpuType[Quan_VersionSpuType["VersionFlagshipTrial"] = 100002] = "VersionFlagshipTrial";
  })(Quan_VersionSpuType || (Quan_VersionSpuType = {}));

  return Quan_VersionSpuType;
}();
export var Quan_VersionSkuType = function () {
  //__ENUM_IIFE__
  var Quan_VersionSkuType;

  (function (Quan_VersionSkuType) {
    Quan_VersionSkuType[Quan_VersionSkuType["VersionSkuNil"] = 0] = "VersionSkuNil";
    Quan_VersionSkuType[Quan_VersionSkuType["VersionSkuBaseFirst"] = 11] = "VersionSkuBaseFirst";
    Quan_VersionSkuType[Quan_VersionSkuType["VersionSkuBaseSecond"] = 12] = "VersionSkuBaseSecond";
    Quan_VersionSkuType[Quan_VersionSkuType["VersionSkuBaseThird"] = 13] = "VersionSkuBaseThird";
    Quan_VersionSkuType[Quan_VersionSkuType["VersionSkuAdvanceFirst"] = 21] = "VersionSkuAdvanceFirst";
    Quan_VersionSkuType[Quan_VersionSkuType["VersionSkuAdvanceSecond"] = 22] = "VersionSkuAdvanceSecond";
    Quan_VersionSkuType[Quan_VersionSkuType["VersionSkuAdvanceThird"] = 23] = "VersionSkuAdvanceThird";
  })(Quan_VersionSkuType || (Quan_VersionSkuType = {}));

  return Quan_VersionSkuType;
}();
export var Quan_VersionConfig_Plan_Type = function () {
  //__ENUM_IIFE__
  var Quan_VersionConfig_Plan_Type;

  (function (Quan_VersionConfig_Plan_Type) {
    Quan_VersionConfig_Plan_Type[Quan_VersionConfig_Plan_Type["TypeNil"] = 0] = "TypeNil";
    Quan_VersionConfig_Plan_Type[Quan_VersionConfig_Plan_Type["TypeFirst"] = 1] = "TypeFirst";
    Quan_VersionConfig_Plan_Type[Quan_VersionConfig_Plan_Type["TypeSecond"] = 2] = "TypeSecond";
    Quan_VersionConfig_Plan_Type[Quan_VersionConfig_Plan_Type["TypeThird"] = 3] = "TypeThird";
  })(Quan_VersionConfig_Plan_Type || (Quan_VersionConfig_Plan_Type = {}));

  return Quan_VersionConfig_Plan_Type;
}();
export var Quan_OperLogType = function () {
  //__ENUM_IIFE__
  var Quan_OperLogType;

  (function (Quan_OperLogType) {
    Quan_OperLogType[Quan_OperLogType["OperLogTypeNil"] = 0] = "OperLogTypeNil";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeSetUserRole"] = 1] = "OperLogTypeSetUserRole";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeAddExtContactBatchSend"] = 3] = "OperLogTypeAddExtContactBatchSend";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeAddExtContactGroupBatchSend"] = 4] = "OperLogTypeAddExtContactGroupBatchSend";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeExtContactLoss"] = 5] = "OperLogTypeExtContactLoss";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeDeletedExtContact"] = 6] = "OperLogTypeDeletedExtContact";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeInviteGroupByTag"] = 7] = "OperLogTypeInviteGroupByTag";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeAddFriend"] = 9] = "OperLogTypeAddFriend";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeJoinGroup"] = 10] = "OperLogTypeJoinGroup";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeQuitGroup"] = 11] = "OperLogTypeQuitGroup";
    Quan_OperLogType[Quan_OperLogType["OperLogTypSetExtContactCorpTag"] = 12] = "OperLogTypSetExtContactCorpTag";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeMessageAuditBatchSendApproved"] = 13] = "OperLogTypeMessageAuditBatchSendApproved";
    Quan_OperLogType[Quan_OperLogType["OperLogTypeMessageAuditBatchSendRejected"] = 14] = "OperLogTypeMessageAuditBatchSendRejected";
  })(Quan_OperLogType || (Quan_OperLogType = {}));

  return Quan_OperLogType;
}();
export var Quan_ModelSysVersion_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelSysVersion_State;

  (function (Quan_ModelSysVersion_State) {
    Quan_ModelSysVersion_State[Quan_ModelSysVersion_State["StateNil"] = 0] = "StateNil";
    Quan_ModelSysVersion_State[Quan_ModelSysVersion_State["StateEnable"] = 1] = "StateEnable";
    Quan_ModelSysVersion_State[Quan_ModelSysVersion_State["StateDisable"] = 2] = "StateDisable";
  })(Quan_ModelSysVersion_State || (Quan_ModelSysVersion_State = {}));

  return Quan_ModelSysVersion_State;
}();
export var Quan_AppType = function () {
  //__ENUM_IIFE__
  var Quan_AppType;

  (function (Quan_AppType) {
    Quan_AppType[Quan_AppType["AppNil"] = 0] = "AppNil";
    Quan_AppType[Quan_AppType["AppBiLin"] = 1] = "AppBiLin";
    Quan_AppType[Quan_AppType["AppQRobot"] = 2] = "AppQRobot";
    Quan_AppType[Quan_AppType["AppQOrder"] = 3] = "AppQOrder";
    Quan_AppType[Quan_AppType["AppQWhale"] = 4] = "AppQWhale";
    Quan_AppType[Quan_AppType["AppQTk"] = 5] = "AppQTk";
    Quan_AppType[Quan_AppType["AppQAICaller"] = 6] = "AppQAICaller";
    Quan_AppType[Quan_AppType["AppRedPacket"] = 7] = "AppRedPacket";
    Quan_AppType[Quan_AppType["AppGroupCredit"] = 8] = "AppGroupCredit";
    Quan_AppType[Quan_AppType["AppJQT"] = 9] = "AppJQT";
    Quan_AppType[Quan_AppType["AppQMsg"] = 10] = "AppQMsg";
    Quan_AppType[Quan_AppType["AppClient"] = 11] = "AppClient";
    Quan_AppType[Quan_AppType["AppXiaoYaTong"] = 12] = "AppXiaoYaTong";
    Quan_AppType[Quan_AppType["AppScrmV2"] = 13] = "AppScrmV2";
    Quan_AppType[Quan_AppType["AppWechatUrlLink"] = 14] = "AppWechatUrlLink";
    Quan_AppType[Quan_AppType["AppTencentCloudMall"] = 15] = "AppTencentCloudMall";
    Quan_AppType[Quan_AppType["AppBasic"] = 16] = "AppBasic";
    Quan_AppType[Quan_AppType["AppEcRetail"] = 17] = "AppEcRetail";
  })(Quan_AppType || (Quan_AppType = {}));

  return Quan_AppType;
}();
export var Quan_AppInfo_ValidityType = function () {
  //__ENUM_IIFE__
  var Quan_AppInfo_ValidityType;

  (function (Quan_AppInfo_ValidityType) {
    Quan_AppInfo_ValidityType[Quan_AppInfo_ValidityType["ValidityTypeNil"] = 0] = "ValidityTypeNil";
    Quan_AppInfo_ValidityType[Quan_AppInfo_ValidityType["ValidityTypePerpetual"] = 1] = "ValidityTypePerpetual";
    Quan_AppInfo_ValidityType[Quan_AppInfo_ValidityType["ValidityTypeYear"] = 2] = "ValidityTypeYear";
    Quan_AppInfo_ValidityType[Quan_AppInfo_ValidityType["ValidityTypeMonth"] = 3] = "ValidityTypeMonth";
    Quan_AppInfo_ValidityType[Quan_AppInfo_ValidityType["ValidityTypeDay"] = 4] = "ValidityTypeDay";
    Quan_AppInfo_ValidityType[Quan_AppInfo_ValidityType["ValidityTypeSecond"] = 5] = "ValidityTypeSecond";
  })(Quan_AppInfo_ValidityType || (Quan_AppInfo_ValidityType = {}));

  return Quan_AppInfo_ValidityType;
}();
export var Quan_AppInfo_ChargeType = function () {
  //__ENUM_IIFE__
  var Quan_AppInfo_ChargeType;

  (function (Quan_AppInfo_ChargeType) {
    Quan_AppInfo_ChargeType[Quan_AppInfo_ChargeType["ChargeTypeNil"] = 0] = "ChargeTypeNil";
    Quan_AppInfo_ChargeType[Quan_AppInfo_ChargeType["ChargeTypeNegotiate"] = 1] = "ChargeTypeNegotiate";
  })(Quan_AppInfo_ChargeType || (Quan_AppInfo_ChargeType = {}));

  return Quan_AppInfo_ChargeType;
}(); // @desc: 账单类型

export var Quan_OrderType = function () {
  //__ENUM_IIFE__
  var Quan_OrderType;

  (function (Quan_OrderType) {
    Quan_OrderType[Quan_OrderType["OrderTypeNil"] = 0] = "OrderTypeNil";
    Quan_OrderType[Quan_OrderType["OrderTypeApp"] = 1] = "OrderTypeApp";
    Quan_OrderType[Quan_OrderType["OrderTypeAccount"] = 2] = "OrderTypeAccount";
  })(Quan_OrderType || (Quan_OrderType = {}));

  return Quan_OrderType;
}();
export var Quan_ModelInvoice_InvoiceType = function () {
  //__ENUM_IIFE__
  var Quan_ModelInvoice_InvoiceType;

  (function (Quan_ModelInvoice_InvoiceType) {
    Quan_ModelInvoice_InvoiceType[Quan_ModelInvoice_InvoiceType["InvoiceTypeNil"] = 0] = "InvoiceTypeNil";
    Quan_ModelInvoice_InvoiceType[Quan_ModelInvoice_InvoiceType["InvoiceTypeValueAddedTaxInvoice"] = 1] = "InvoiceTypeValueAddedTaxInvoice";
    Quan_ModelInvoice_InvoiceType[Quan_ModelInvoice_InvoiceType["InvoiceTypeValueAddedTaxTicket"] = 2] = "InvoiceTypeValueAddedTaxTicket";
  })(Quan_ModelInvoice_InvoiceType || (Quan_ModelInvoice_InvoiceType = {}));

  return Quan_ModelInvoice_InvoiceType;
}();
export var Quan_ModelInvoice_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelInvoice_State;

  (function (Quan_ModelInvoice_State) {
    Quan_ModelInvoice_State[Quan_ModelInvoice_State["StateNil"] = 0] = "StateNil";
    Quan_ModelInvoice_State[Quan_ModelInvoice_State["StateSubmit"] = 1] = "StateSubmit";
    Quan_ModelInvoice_State[Quan_ModelInvoice_State["StateAuditPassed"] = 2] = "StateAuditPassed";
    Quan_ModelInvoice_State[Quan_ModelInvoice_State["StateAuditRefuse"] = 3] = "StateAuditRefuse";
    Quan_ModelInvoice_State[Quan_ModelInvoice_State["StateInvoiceIssued"] = 4] = "StateInvoiceIssued";
    Quan_ModelInvoice_State[Quan_ModelInvoice_State["StateInvoiceShipped"] = 5] = "StateInvoiceShipped";
    Quan_ModelInvoice_State[Quan_ModelInvoice_State["StateUserCancel"] = 6] = "StateUserCancel";
  })(Quan_ModelInvoice_State || (Quan_ModelInvoice_State = {}));

  return Quan_ModelInvoice_State;
}();
export var Quan_SidebarTabType = function () {
  //__ENUM_IIFE__
  var Quan_SidebarTabType;

  (function (Quan_SidebarTabType) {
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypeNil"] = 0] = "SidebarTabTypeNil";
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypeTalkScriptLibrary"] = 1] = "SidebarTabTypeTalkScriptLibrary";
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypeCorpTalkScript"] = 2] = "SidebarTabTypeCorpTalkScript";
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypePersonalTalkScript"] = 3] = "SidebarTabTypePersonalTalkScript";
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypeCustomerInfo"] = 4] = "SidebarTabTypeCustomerInfo";
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypeArtLibrary"] = 5] = "SidebarTabTypeArtLibrary";
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypeQuicklyReply"] = 6] = "SidebarTabTypeQuicklyReply";
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypeQOrder"] = 7] = "SidebarTabTypeQOrder";
    Quan_SidebarTabType[Quan_SidebarTabType["SidebarTabTypeQStore"] = 8] = "SidebarTabTypeQStore";
  })(Quan_SidebarTabType || (Quan_SidebarTabType = {}));

  return Quan_SidebarTabType;
}();
export var Quan_SidebarTabState = function () {
  //__ENUM_IIFE__
  var Quan_SidebarTabState;

  (function (Quan_SidebarTabState) {
    Quan_SidebarTabState[Quan_SidebarTabState["SidebarTabStateNil"] = 0] = "SidebarTabStateNil";
    Quan_SidebarTabState[Quan_SidebarTabState["SidebarTabStateOn"] = 1] = "SidebarTabStateOn";
    Quan_SidebarTabState[Quan_SidebarTabState["SidebarTabStateOff"] = 2] = "SidebarTabStateOff";
  })(Quan_SidebarTabState || (Quan_SidebarTabState = {}));

  return Quan_SidebarTabState;
}();
export var Quan_OrderState = function () {
  //__ENUM_IIFE__
  var Quan_OrderState;

  (function (Quan_OrderState) {
    Quan_OrderState[Quan_OrderState["OrderStateNil"] = 0] = "OrderStateNil";
    Quan_OrderState[Quan_OrderState["OrderStateInit"] = 1] = "OrderStateInit";
    Quan_OrderState[Quan_OrderState["OrderStateReady2Pay"] = 2] = "OrderStateReady2Pay";
    Quan_OrderState[Quan_OrderState["OrderStatePaid"] = 3] = "OrderStatePaid";
    Quan_OrderState[Quan_OrderState["OrderStateCancelled"] = 8] = "OrderStateCancelled";
  })(Quan_OrderState || (Quan_OrderState = {}));

  return Quan_OrderState;
}();
export var Quan_BuyType = function () {
  //__ENUM_IIFE__
  var Quan_BuyType;

  (function (Quan_BuyType) {
    Quan_BuyType[Quan_BuyType["BuyTypeNil"] = 0] = "BuyTypeNil";
    Quan_BuyType[Quan_BuyType["BuyTypeNew"] = 1] = "BuyTypeNew";
    Quan_BuyType[Quan_BuyType["BuyTypeRenew"] = 2] = "BuyTypeRenew";
    Quan_BuyType[Quan_BuyType["BuyTypeCount"] = 3] = "BuyTypeCount";
    Quan_BuyType[Quan_BuyType["BuyTypeUpgrade"] = 4] = "BuyTypeUpgrade";
    Quan_BuyType[Quan_BuyType["BuyTypeStaff"] = 5] = "BuyTypeStaff";
  })(Quan_BuyType || (Quan_BuyType = {}));

  return Quan_BuyType;
}();
export var Quan_ModelCorpVersion_ValidityType = function () {
  //__ENUM_IIFE__
  var Quan_ModelCorpVersion_ValidityType;

  (function (Quan_ModelCorpVersion_ValidityType) {
    Quan_ModelCorpVersion_ValidityType[Quan_ModelCorpVersion_ValidityType["ValidityTypeNil"] = 0] = "ValidityTypeNil";
    Quan_ModelCorpVersion_ValidityType[Quan_ModelCorpVersion_ValidityType["ValidityTypePerpetual"] = 1] = "ValidityTypePerpetual";
    Quan_ModelCorpVersion_ValidityType[Quan_ModelCorpVersion_ValidityType["ValidityTypeYear"] = 2] = "ValidityTypeYear";
    Quan_ModelCorpVersion_ValidityType[Quan_ModelCorpVersion_ValidityType["ValidityTypeMonth"] = 3] = "ValidityTypeMonth";
    Quan_ModelCorpVersion_ValidityType[Quan_ModelCorpVersion_ValidityType["ValidityTypeDay"] = 4] = "ValidityTypeDay";
  })(Quan_ModelCorpVersion_ValidityType || (Quan_ModelCorpVersion_ValidityType = {}));

  return Quan_ModelCorpVersion_ValidityType;
}(); // @desc: 尽量不看这个
// 留意 VersionSpuType

export var Quan_ModelCorpVersion_Type = function () {
  //__ENUM_IIFE__
  var Quan_ModelCorpVersion_Type;

  (function (Quan_ModelCorpVersion_Type) {
    Quan_ModelCorpVersion_Type[Quan_ModelCorpVersion_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ModelCorpVersion_Type[Quan_ModelCorpVersion_Type["TypeBase"] = 1] = "TypeBase";
    Quan_ModelCorpVersion_Type[Quan_ModelCorpVersion_Type["TypeAdvance"] = 2] = "TypeAdvance";
    Quan_ModelCorpVersion_Type[Quan_ModelCorpVersion_Type["TypeFlagship"] = 3] = "TypeFlagship";
    Quan_ModelCorpVersion_Type[Quan_ModelCorpVersion_Type["TypeAdvanceProbation"] = 4] = "TypeAdvanceProbation";
  })(Quan_ModelCorpVersion_Type || (Quan_ModelCorpVersion_Type = {}));

  return Quan_ModelCorpVersion_Type;
}();
export var Quan_AuditType = function () {
  //__ENUM_IIFE__
  var Quan_AuditType;

  (function (Quan_AuditType) {
    Quan_AuditType[Quan_AuditType["AuditTypeNil"] = 0] = "AuditTypeNil";
    Quan_AuditType[Quan_AuditType["AuditTypeQRobotBatchSend"] = 1] = "AuditTypeQRobotBatchSend";
  })(Quan_AuditType || (Quan_AuditType = {}));

  return Quan_AuditType;
}();
export var Quan_AuditSubType = function () {
  //__ENUM_IIFE__
  var Quan_AuditSubType;

  (function (Quan_AuditSubType) {
    Quan_AuditSubType[Quan_AuditSubType["AuditSubTypeNil"] = 0] = "AuditSubTypeNil";
    Quan_AuditSubType[Quan_AuditSubType["AuditSubTypeQRobotBatchSendGroup"] = 1] = "AuditSubTypeQRobotBatchSendGroup";
    Quan_AuditSubType[Quan_AuditSubType["AuditSubTypeQRobotBatchSendSingle"] = 2] = "AuditSubTypeQRobotBatchSendSingle";
  })(Quan_AuditSubType || (Quan_AuditSubType = {}));

  return Quan_AuditSubType;
}();
export var Quan_ModelMessageAuditorConfig_AuditeeType = function () {
  //__ENUM_IIFE__
  var Quan_ModelMessageAuditorConfig_AuditeeType;

  (function (Quan_ModelMessageAuditorConfig_AuditeeType) {
    Quan_ModelMessageAuditorConfig_AuditeeType[Quan_ModelMessageAuditorConfig_AuditeeType["AuditeeTypeNil"] = 0] = "AuditeeTypeNil";
    Quan_ModelMessageAuditorConfig_AuditeeType[Quan_ModelMessageAuditorConfig_AuditeeType["AuditeeTypeAll"] = 1] = "AuditeeTypeAll";
    Quan_ModelMessageAuditorConfig_AuditeeType[Quan_ModelMessageAuditorConfig_AuditeeType["AuditeeTypeSpec"] = 2] = "AuditeeTypeSpec";
  })(Quan_ModelMessageAuditorConfig_AuditeeType || (Quan_ModelMessageAuditorConfig_AuditeeType = {}));

  return Quan_ModelMessageAuditorConfig_AuditeeType;
}();
export var Quan_ModelMessageAudit_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelMessageAudit_State;

  (function (Quan_ModelMessageAudit_State) {
    Quan_ModelMessageAudit_State[Quan_ModelMessageAudit_State["StateNil"] = 0] = "StateNil";
    Quan_ModelMessageAudit_State[Quan_ModelMessageAudit_State["StatePending"] = 1] = "StatePending";
    Quan_ModelMessageAudit_State[Quan_ModelMessageAudit_State["StateApproved"] = 2] = "StateApproved";
    Quan_ModelMessageAudit_State[Quan_ModelMessageAudit_State["StateRejected"] = 3] = "StateRejected";
  })(Quan_ModelMessageAudit_State || (Quan_ModelMessageAudit_State = {}));

  return Quan_ModelMessageAudit_State;
}(); // @desc: 注册设备

export var Quan_ModelAccount_RegisteredDevice = function () {
  //__ENUM_IIFE__
  var Quan_ModelAccount_RegisteredDevice;

  (function (Quan_ModelAccount_RegisteredDevice) {
    Quan_ModelAccount_RegisteredDevice[Quan_ModelAccount_RegisteredDevice["RegisteredDeviceNil"] = 0] = "RegisteredDeviceNil";
    Quan_ModelAccount_RegisteredDevice[Quan_ModelAccount_RegisteredDevice["RegisteredDeviceMobile"] = 1] = "RegisteredDeviceMobile";
    Quan_ModelAccount_RegisteredDevice[Quan_ModelAccount_RegisteredDevice["RegisteredDevicePc"] = 2] = "RegisteredDevicePc";
  })(Quan_ModelAccount_RegisteredDevice || (Quan_ModelAccount_RegisteredDevice = {}));

  return Quan_ModelAccount_RegisteredDevice;
}(); // @desc: 操作系统

export var Quan_ModelAccount_OperatingSystem = function () {
  //__ENUM_IIFE__
  var Quan_ModelAccount_OperatingSystem;

  (function (Quan_ModelAccount_OperatingSystem) {
    Quan_ModelAccount_OperatingSystem[Quan_ModelAccount_OperatingSystem["OperatingSystemNil"] = 0] = "OperatingSystemNil";
    Quan_ModelAccount_OperatingSystem[Quan_ModelAccount_OperatingSystem["OperatingSystemWindows"] = 1] = "OperatingSystemWindows";
    Quan_ModelAccount_OperatingSystem[Quan_ModelAccount_OperatingSystem["OperatingSystemMac"] = 2] = "OperatingSystemMac";
    Quan_ModelAccount_OperatingSystem[Quan_ModelAccount_OperatingSystem["OperatingSystemAndroid"] = 3] = "OperatingSystemAndroid";
    Quan_ModelAccount_OperatingSystem[Quan_ModelAccount_OperatingSystem["OperatingSystemIos"] = 4] = "OperatingSystemIos";
  })(Quan_ModelAccount_OperatingSystem || (Quan_ModelAccount_OperatingSystem = {}));

  return Quan_ModelAccount_OperatingSystem;
}();
export var Quan_ModelImportRecord_Type = function () {
  //__ENUM_IIFE__
  var Quan_ModelImportRecord_Type;

  (function (Quan_ModelImportRecord_Type) {
    Quan_ModelImportRecord_Type[Quan_ModelImportRecord_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ModelImportRecord_Type[Quan_ModelImportRecord_Type["TypeExtContactFollow"] = 1] = "TypeExtContactFollow";
    Quan_ModelImportRecord_Type[Quan_ModelImportRecord_Type["TypeCustomerInfo"] = 2] = "TypeCustomerInfo";
    Quan_ModelImportRecord_Type[Quan_ModelImportRecord_Type["TypeAccountClue"] = 3] = "TypeAccountClue";
    Quan_ModelImportRecord_Type[Quan_ModelImportRecord_Type["TypeUpperNumberActiveLicence"] = 4] = "TypeUpperNumberActiveLicence";
    Quan_ModelImportRecord_Type[Quan_ModelImportRecord_Type["TypeChannel"] = 5] = "TypeChannel";
    Quan_ModelImportRecord_Type[Quan_ModelImportRecord_Type["TypeDeDupChannelLiveCode"] = 6] = "TypeDeDupChannelLiveCode";
  })(Quan_ModelImportRecord_Type || (Quan_ModelImportRecord_Type = {}));

  return Quan_ModelImportRecord_Type;
}();
export var Quan_ModelImportRecord_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelImportRecord_State;

  (function (Quan_ModelImportRecord_State) {
    Quan_ModelImportRecord_State[Quan_ModelImportRecord_State["StateNil"] = 0] = "StateNil";
    Quan_ModelImportRecord_State[Quan_ModelImportRecord_State["StateProcessing"] = 1] = "StateProcessing";
    Quan_ModelImportRecord_State[Quan_ModelImportRecord_State["StateDone"] = 2] = "StateDone";
  })(Quan_ModelImportRecord_State || (Quan_ModelImportRecord_State = {}));

  return Quan_ModelImportRecord_State;
}();
export var Quan_ModelChannelImportRecord_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelChannelImportRecord_State;

  (function (Quan_ModelChannelImportRecord_State) {
    Quan_ModelChannelImportRecord_State[Quan_ModelChannelImportRecord_State["StateNil"] = 0] = "StateNil";
    Quan_ModelChannelImportRecord_State[Quan_ModelChannelImportRecord_State["StateProcessing"] = 1] = "StateProcessing";
    Quan_ModelChannelImportRecord_State[Quan_ModelChannelImportRecord_State["StateDone"] = 2] = "StateDone";
  })(Quan_ModelChannelImportRecord_State || (Quan_ModelChannelImportRecord_State = {}));

  return Quan_ModelChannelImportRecord_State;
}();
export var Quan_ModelSyncExtContactRecord_Status = function () {
  //__ENUM_IIFE__
  var Quan_ModelSyncExtContactRecord_Status;

  (function (Quan_ModelSyncExtContactRecord_Status) {
    Quan_ModelSyncExtContactRecord_Status[Quan_ModelSyncExtContactRecord_Status["StatusNil"] = 0] = "StatusNil";
    Quan_ModelSyncExtContactRecord_Status[Quan_ModelSyncExtContactRecord_Status["StatusAppend"] = 1] = "StatusAppend";
    Quan_ModelSyncExtContactRecord_Status[Quan_ModelSyncExtContactRecord_Status["StatusFinish"] = 2] = "StatusFinish";
  })(Quan_ModelSyncExtContactRecord_Status || (Quan_ModelSyncExtContactRecord_Status = {}));

  return Quan_ModelSyncExtContactRecord_Status;
}();
export var Quan_ModelNotifyConfig_Type = function () {
  //__ENUM_IIFE__
  var Quan_ModelNotifyConfig_Type;

  (function (Quan_ModelNotifyConfig_Type) {
    Quan_ModelNotifyConfig_Type[Quan_ModelNotifyConfig_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ModelNotifyConfig_Type[Quan_ModelNotifyConfig_Type["TypeExtContactLoss"] = 1] = "TypeExtContactLoss";
    Quan_ModelNotifyConfig_Type[Quan_ModelNotifyConfig_Type["TypeUserRoleChange"] = 2] = "TypeUserRoleChange";
    Quan_ModelNotifyConfig_Type[Quan_ModelNotifyConfig_Type["TypeDailyExtContactStat"] = 3] = "TypeDailyExtContactStat";
    Quan_ModelNotifyConfig_Type[Quan_ModelNotifyConfig_Type["TypeUserExtContactExpandTip"] = 4] = "TypeUserExtContactExpandTip";
    Quan_ModelNotifyConfig_Type[Quan_ModelNotifyConfig_Type["TypeHostAccountLoginOrLogoutTip"] = 5] = "TypeHostAccountLoginOrLogoutTip";
  })(Quan_ModelNotifyConfig_Type || (Quan_ModelNotifyConfig_Type = {}));

  return Quan_ModelNotifyConfig_Type;
}();
export var Quan_ModelNotifyConfig_ReceiverType = function () {
  //__ENUM_IIFE__
  var Quan_ModelNotifyConfig_ReceiverType;

  (function (Quan_ModelNotifyConfig_ReceiverType) {
    Quan_ModelNotifyConfig_ReceiverType[Quan_ModelNotifyConfig_ReceiverType["ReceiverTypeNil"] = 0] = "ReceiverTypeNil";
    Quan_ModelNotifyConfig_ReceiverType[Quan_ModelNotifyConfig_ReceiverType["ReceiverTypeSelf"] = 1] = "ReceiverTypeSelf";
    Quan_ModelNotifyConfig_ReceiverType[Quan_ModelNotifyConfig_ReceiverType["ReceiverTypeAdminAndSelf"] = 2] = "ReceiverTypeAdminAndSelf";
    Quan_ModelNotifyConfig_ReceiverType[Quan_ModelNotifyConfig_ReceiverType["ReceiverTypeSpecAndSelf"] = 3] = "ReceiverTypeSpecAndSelf";
  })(Quan_ModelNotifyConfig_ReceiverType || (Quan_ModelNotifyConfig_ReceiverType = {}));

  return Quan_ModelNotifyConfig_ReceiverType;
}();
export var Quan_ModelNotifyConfig_Freq = function () {
  //__ENUM_IIFE__
  var Quan_ModelNotifyConfig_Freq;

  (function (Quan_ModelNotifyConfig_Freq) {
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqNil"] = 0] = "FreqNil";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactLossEach"] = 1] = "FreqExtContactLossEach";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactLossDaily8Clock"] = 2] = "FreqExtContactLossDaily8Clock";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqRoleChangeEach"] = 3] = "FreqRoleChangeEach";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactStatDaily8Clock"] = 4] = "FreqExtContactStatDaily8Clock";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactStatDaily18Clock"] = 5] = "FreqExtContactStatDaily18Clock";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactExpandTip5000"] = 6] = "FreqExtContactExpandTip5000";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactExpandTip10000"] = 7] = "FreqExtContactExpandTip10000";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactExpandTip20000"] = 8] = "FreqExtContactExpandTip20000";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactExpandTip50000"] = 9] = "FreqExtContactExpandTip50000";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqHostAccountLoginEach"] = 10] = "FreqHostAccountLoginEach";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqHostAccountLogoutEach"] = 11] = "FreqHostAccountLogoutEach";
    Quan_ModelNotifyConfig_Freq[Quan_ModelNotifyConfig_Freq["FreqExtContactExpandTip15000"] = 12] = "FreqExtContactExpandTip15000";
  })(Quan_ModelNotifyConfig_Freq || (Quan_ModelNotifyConfig_Freq = {}));

  return Quan_ModelNotifyConfig_Freq;
}(); // @desc: 1-接替完毕 2-等待接替 3-客户拒绝 4-接替成员客户达到上限 5-无接替记录

export var Quan_ModelExtContactTransferCustomerRecord_Status = function () {
  //__ENUM_IIFE__
  var Quan_ModelExtContactTransferCustomerRecord_Status;

  (function (Quan_ModelExtContactTransferCustomerRecord_Status) {
    Quan_ModelExtContactTransferCustomerRecord_Status[Quan_ModelExtContactTransferCustomerRecord_Status["StatusNil"] = 0] = "StatusNil";
    Quan_ModelExtContactTransferCustomerRecord_Status[Quan_ModelExtContactTransferCustomerRecord_Status["StatusDone"] = 1] = "StatusDone";
    Quan_ModelExtContactTransferCustomerRecord_Status[Quan_ModelExtContactTransferCustomerRecord_Status["StatusWaiting"] = 2] = "StatusWaiting";
    Quan_ModelExtContactTransferCustomerRecord_Status[Quan_ModelExtContactTransferCustomerRecord_Status["StatusRefuse"] = 3] = "StatusRefuse";
    Quan_ModelExtContactTransferCustomerRecord_Status[Quan_ModelExtContactTransferCustomerRecord_Status["StatusLimit"] = 4] = "StatusLimit";
    Quan_ModelExtContactTransferCustomerRecord_Status[Quan_ModelExtContactTransferCustomerRecord_Status["StatusNotFound"] = 5] = "StatusNotFound";
    Quan_ModelExtContactTransferCustomerRecord_Status[Quan_ModelExtContactTransferCustomerRecord_Status["StatusFailure"] = 6] = "StatusFailure";
  })(Quan_ModelExtContactTransferCustomerRecord_Status || (Quan_ModelExtContactTransferCustomerRecord_Status = {}));

  return Quan_ModelExtContactTransferCustomerRecord_Status;
}(); // @desc: 1-跳转链接 2-显示已添加成员

export var Quan_ModelDeDupChannelLiveCode_JumpType = function () {
  //__ENUM_IIFE__
  var Quan_ModelDeDupChannelLiveCode_JumpType;

  (function (Quan_ModelDeDupChannelLiveCode_JumpType) {
    Quan_ModelDeDupChannelLiveCode_JumpType[Quan_ModelDeDupChannelLiveCode_JumpType["TypeNil"] = 0] = "TypeNil";
    Quan_ModelDeDupChannelLiveCode_JumpType[Quan_ModelDeDupChannelLiveCode_JumpType["TypeLink"] = 1] = "TypeLink";
    Quan_ModelDeDupChannelLiveCode_JumpType[Quan_ModelDeDupChannelLiveCode_JumpType["TypeWaiting"] = 2] = "TypeWaiting";
  })(Quan_ModelDeDupChannelLiveCode_JumpType || (Quan_ModelDeDupChannelLiveCode_JumpType = {}));

  return Quan_ModelDeDupChannelLiveCode_JumpType;
}();
export var Quan_ModelDeDupChannelLiveCode_LiveCodeState = function () {
  //__ENUM_IIFE__
  var Quan_ModelDeDupChannelLiveCode_LiveCodeState;

  (function (Quan_ModelDeDupChannelLiveCode_LiveCodeState) {
    Quan_ModelDeDupChannelLiveCode_LiveCodeState[Quan_ModelDeDupChannelLiveCode_LiveCodeState["LiveCodeStateNil"] = 0] = "LiveCodeStateNil";
    Quan_ModelDeDupChannelLiveCode_LiveCodeState[Quan_ModelDeDupChannelLiveCode_LiveCodeState["LiveCodeStateProcessing"] = 1] = "LiveCodeStateProcessing";
    Quan_ModelDeDupChannelLiveCode_LiveCodeState[Quan_ModelDeDupChannelLiveCode_LiveCodeState["LiveCodeStatePartRelease"] = 2] = "LiveCodeStatePartRelease";
    Quan_ModelDeDupChannelLiveCode_LiveCodeState[Quan_ModelDeDupChannelLiveCode_LiveCodeState["LiveCodeStateRelease"] = 3] = "LiveCodeStateRelease";
  })(Quan_ModelDeDupChannelLiveCode_LiveCodeState || (Quan_ModelDeDupChannelLiveCode_LiveCodeState = {}));

  return Quan_ModelDeDupChannelLiveCode_LiveCodeState;
}();
export var Quan_ModelPlatNotice_PubWay = function () {
  //__ENUM_IIFE__
  var Quan_ModelPlatNotice_PubWay;

  (function (Quan_ModelPlatNotice_PubWay) {
    Quan_ModelPlatNotice_PubWay[Quan_ModelPlatNotice_PubWay["PubWayNil"] = 0] = "PubWayNil";
    Quan_ModelPlatNotice_PubWay[Quan_ModelPlatNotice_PubWay["PubWayImmediately"] = 1] = "PubWayImmediately";
    Quan_ModelPlatNotice_PubWay[Quan_ModelPlatNotice_PubWay["PubWaySched"] = 2] = "PubWaySched";
  })(Quan_ModelPlatNotice_PubWay || (Quan_ModelPlatNotice_PubWay = {}));

  return Quan_ModelPlatNotice_PubWay;
}();
export var Quan_ModelPlatNotice_VisibleType = function () {
  //__ENUM_IIFE__
  var Quan_ModelPlatNotice_VisibleType;

  (function (Quan_ModelPlatNotice_VisibleType) {
    Quan_ModelPlatNotice_VisibleType[Quan_ModelPlatNotice_VisibleType["VisibleTypeNil"] = 0] = "VisibleTypeNil";
    Quan_ModelPlatNotice_VisibleType[Quan_ModelPlatNotice_VisibleType["VisibleTypeVersion"] = 1] = "VisibleTypeVersion";
    Quan_ModelPlatNotice_VisibleType[Quan_ModelPlatNotice_VisibleType["VisibleTypeCorp"] = 2] = "VisibleTypeCorp";
  })(Quan_ModelPlatNotice_VisibleType || (Quan_ModelPlatNotice_VisibleType = {}));

  return Quan_ModelPlatNotice_VisibleType;
}();
export var Quan_ModelPlatNotice_NoticeType = function () {
  //__ENUM_IIFE__
  var Quan_ModelPlatNotice_NoticeType;

  (function (Quan_ModelPlatNotice_NoticeType) {
    Quan_ModelPlatNotice_NoticeType[Quan_ModelPlatNotice_NoticeType["NoticeTypeNil"] = 0] = "NoticeTypeNil";
    Quan_ModelPlatNotice_NoticeType[Quan_ModelPlatNotice_NoticeType["NoticeTypeCommon"] = 1] = "NoticeTypeCommon";
    Quan_ModelPlatNotice_NoticeType[Quan_ModelPlatNotice_NoticeType["NoticeTypeUpdate"] = 2] = "NoticeTypeUpdate";
  })(Quan_ModelPlatNotice_NoticeType || (Quan_ModelPlatNotice_NoticeType = {}));

  return Quan_ModelPlatNotice_NoticeType;
}();
export var Quan_ModelCustomerComplaint_ComplainedType = function () {
  //__ENUM_IIFE__
  var Quan_ModelCustomerComplaint_ComplainedType;

  (function (Quan_ModelCustomerComplaint_ComplainedType) {
    Quan_ModelCustomerComplaint_ComplainedType[Quan_ModelCustomerComplaint_ComplainedType["ComplainedTypeNil"] = 0] = "ComplainedTypeNil";
    Quan_ModelCustomerComplaint_ComplainedType[Quan_ModelCustomerComplaint_ComplainedType["ComplainedTypeSpam"] = 1] = "ComplainedTypeSpam";
    Quan_ModelCustomerComplaint_ComplainedType[Quan_ModelCustomerComplaint_ComplainedType["ComplainedTypeFraud"] = 2] = "ComplainedTypeFraud";
    Quan_ModelCustomerComplaint_ComplainedType[Quan_ModelCustomerComplaint_ComplainedType["ComplainedTypeContentPron"] = 3] = "ComplainedTypeContentPron";
    Quan_ModelCustomerComplaint_ComplainedType[Quan_ModelCustomerComplaint_ComplainedType["ComplainedTypeFakeMsg"] = 4] = "ComplainedTypeFakeMsg";
    Quan_ModelCustomerComplaint_ComplainedType[Quan_ModelCustomerComplaint_ComplainedType["ComplainedTypeIllegalCrime"] = 5] = "ComplainedTypeIllegalCrime";
    Quan_ModelCustomerComplaint_ComplainedType[Quan_ModelCustomerComplaint_ComplainedType["ComplainedTypePlagiarism"] = 6] = "ComplainedTypePlagiarism";
    Quan_ModelCustomerComplaint_ComplainedType[Quan_ModelCustomerComplaint_ComplainedType["ComplainedTypeOther"] = 7] = "ComplainedTypeOther";
  })(Quan_ModelCustomerComplaint_ComplainedType || (Quan_ModelCustomerComplaint_ComplainedType = {}));

  return Quan_ModelCustomerComplaint_ComplainedType;
}(); // @desc: 选择作用的账号类型

export var Quan_UserSelectType = function () {
  //__ENUM_IIFE__
  var Quan_UserSelectType;

  (function (Quan_UserSelectType) {
    Quan_UserSelectType[Quan_UserSelectType["UserSelectTypeNil"] = 0] = "UserSelectTypeNil";
    Quan_UserSelectType[Quan_UserSelectType["UserSelectTypeAll"] = 1] = "UserSelectTypeAll";
    Quan_UserSelectType[Quan_UserSelectType["UserSelectTypeNormal"] = 2] = "UserSelectTypeNormal";
    Quan_UserSelectType[Quan_UserSelectType["UserSelectTypeRobot"] = 3] = "UserSelectTypeRobot";
  })(Quan_UserSelectType || (Quan_UserSelectType = {}));

  return Quan_UserSelectType;
}(); // @desc: 新增许可账号激活状态字段

export var Quan_LicenseState = function () {
  //__ENUM_IIFE__
  var Quan_LicenseState;

  (function (Quan_LicenseState) {
    Quan_LicenseState[Quan_LicenseState["LicenseStateNil"] = 0] = "LicenseStateNil";
    Quan_LicenseState[Quan_LicenseState["LicenseStateActive"] = 1] = "LicenseStateActive";
    Quan_LicenseState[Quan_LicenseState["LicenseStateUnActivated"] = 2] = "LicenseStateUnActivated";
    Quan_LicenseState[Quan_LicenseState["LicenseStateFreeTrial"] = 3] = "LicenseStateFreeTrial";
  })(Quan_LicenseState || (Quan_LicenseState = {}));

  return Quan_LicenseState;
}();
export var Quan_GetUserListReq_AppScopeType = function () {
  //__ENUM_IIFE__
  var Quan_GetUserListReq_AppScopeType;

  (function (Quan_GetUserListReq_AppScopeType) {
    Quan_GetUserListReq_AppScopeType[Quan_GetUserListReq_AppScopeType["AppScopeTypeNil"] = 0] = "AppScopeTypeNil";
    Quan_GetUserListReq_AppScopeType[Quan_GetUserListReq_AppScopeType["AppScopeTypeNotMatch"] = 1] = "AppScopeTypeNotMatch";
  })(Quan_GetUserListReq_AppScopeType || (Quan_GetUserListReq_AppScopeType = {}));

  return Quan_GetUserListReq_AppScopeType;
}();
export var Quan_GetUserListReq_AccountType = function () {
  //__ENUM_IIFE__
  var Quan_GetUserListReq_AccountType;

  (function (Quan_GetUserListReq_AccountType) {
    Quan_GetUserListReq_AccountType[Quan_GetUserListReq_AccountType["AccountTypeNil"] = 0] = "AccountTypeNil";
    Quan_GetUserListReq_AccountType[Quan_GetUserListReq_AccountType["AccountTypeAll"] = 1] = "AccountTypeAll";
    Quan_GetUserListReq_AccountType[Quan_GetUserListReq_AccountType["AccountTypeNormal"] = 2] = "AccountTypeNormal";
    Quan_GetUserListReq_AccountType[Quan_GetUserListReq_AccountType["AccountTypePlatform"] = 3] = "AccountTypePlatform";
    Quan_GetUserListReq_AccountType[Quan_GetUserListReq_AccountType["AccountTypeScanCode"] = 4] = "AccountTypeScanCode";
  })(Quan_GetUserListReq_AccountType || (Quan_GetUserListReq_AccountType = {}));

  return Quan_GetUserListReq_AccountType;
}(); // @desc: 字段调整为 应用可见范围

export var Quan_GetUserListReq_ActiveState = function () {
  //__ENUM_IIFE__
  var Quan_GetUserListReq_ActiveState;

  (function (Quan_GetUserListReq_ActiveState) {
    Quan_GetUserListReq_ActiveState[Quan_GetUserListReq_ActiveState["ActiveStateNil"] = 0] = "ActiveStateNil";
    Quan_GetUserListReq_ActiveState[Quan_GetUserListReq_ActiveState["ActiveStateAll"] = 1] = "ActiveStateAll";
    Quan_GetUserListReq_ActiveState[Quan_GetUserListReq_ActiveState["ActiveStateActivated"] = 2] = "ActiveStateActivated";
    Quan_GetUserListReq_ActiveState[Quan_GetUserListReq_ActiveState["ActiveStateInactivated"] = 3] = "ActiveStateInactivated";
  })(Quan_GetUserListReq_ActiveState || (Quan_GetUserListReq_ActiveState = {}));

  return Quan_GetUserListReq_ActiveState;
}();
export var Quan_GetUserListReq_BasicAccountState = function () {
  //__ENUM_IIFE__
  var Quan_GetUserListReq_BasicAccountState;

  (function (Quan_GetUserListReq_BasicAccountState) {
    Quan_GetUserListReq_BasicAccountState[Quan_GetUserListReq_BasicAccountState["BasicAccountStateNil"] = 0] = "BasicAccountStateNil";
    Quan_GetUserListReq_BasicAccountState[Quan_GetUserListReq_BasicAccountState["BasicAccountStateNormal"] = 1] = "BasicAccountStateNormal";
    Quan_GetUserListReq_BasicAccountState[Quan_GetUserListReq_BasicAccountState["BasicAccountStateUnBind"] = 2] = "BasicAccountStateUnBind";
    Quan_GetUserListReq_BasicAccountState[Quan_GetUserListReq_BasicAccountState["BasicAccountStateExpired"] = 3] = "BasicAccountStateExpired";
  })(Quan_GetUserListReq_BasicAccountState || (Quan_GetUserListReq_BasicAccountState = {}));

  return Quan_GetUserListReq_BasicAccountState;
}();
export var Quan_GetUserListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetUserListReq_ListOption;

  (function (Quan_GetUserListReq_ListOption) {
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionAppScopeType"] = 1] = "ListOptionAppScopeType";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionUserRole"] = 2] = "ListOptionUserRole";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionName"] = 3] = "ListOptionName";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionInAppScope"] = 4] = "ListOptionInAppScope";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionInAppAndAuthApp"] = 5] = "ListOptionInAppAndAuthApp";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionUidList"] = 6] = "ListOptionUidList";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionUserIdList"] = 7] = "ListOptionUserIdList";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionYcSerialNoNotEmpty"] = 8] = "ListOptionYcSerialNoNotEmpty";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionIsDistribute"] = 9] = "ListOptionIsDistribute";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionAccountType"] = 10] = "ListOptionAccountType";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionActiveState"] = 11] = "ListOptionActiveState";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionWwUserName"] = 12] = "ListOptionWwUserName";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionExcludeMessageAuditor"] = 13] = "ListOptionExcludeMessageAuditor";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionRoleId"] = 14] = "ListOptionRoleId";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionUserRoleList"] = 15] = "ListOptionUserRoleList";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionWwDeptId"] = 16] = "ListOptionWwDeptId";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionExcludeRoleId"] = 17] = "ListOptionExcludeRoleId";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionHasRole"] = 18] = "ListOptionHasRole";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionNewAccountTypeList"] = 19] = "ListOptionNewAccountTypeList";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionChannelLiveCodeId"] = 20] = "ListOptionChannelLiveCodeId";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionAppTypeRole"] = 21] = "ListOptionAppTypeRole";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionIncludeDeletedUser"] = 22] = "ListOptionIncludeDeletedUser";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionHasAdminRole"] = 23] = "ListOptionHasAdminRole";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionOnlyDataScope"] = 24] = "ListOptionOnlyDataScope";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionAppType"] = 25] = "ListOptionAppType";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionMobile"] = 26] = "ListOptionMobile";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionLicenseState"] = 27] = "ListOptionLicenseState";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionRoleTypeList"] = 28] = "ListOptionRoleTypeList";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionBasicAccountState"] = 29] = "ListOptionBasicAccountState";
    Quan_GetUserListReq_ListOption[Quan_GetUserListReq_ListOption["ListOptionLicenseExpiredAt"] = 30] = "ListOptionLicenseExpiredAt";
  })(Quan_GetUserListReq_ListOption || (Quan_GetUserListReq_ListOption = {}));

  return Quan_GetUserListReq_ListOption;
}();
export var Quan_OpUserReq_OpType = function () {
  //__ENUM_IIFE__
  var Quan_OpUserReq_OpType;

  (function (Quan_OpUserReq_OpType) {
    Quan_OpUserReq_OpType[Quan_OpUserReq_OpType["OpTypeNil"] = 0] = "OpTypeNil";
    Quan_OpUserReq_OpType[Quan_OpUserReq_OpType["OpTypeSetRole"] = 1] = "OpTypeSetRole";
  })(Quan_OpUserReq_OpType || (Quan_OpUserReq_OpType = {}));

  return Quan_OpUserReq_OpType;
}();
export var Quan_SyncState = function () {
  //__ENUM_IIFE__
  var Quan_SyncState;

  (function (Quan_SyncState) {
    Quan_SyncState[Quan_SyncState["SyncStateNil"] = 0] = "SyncStateNil";
    Quan_SyncState[Quan_SyncState["SyncStateInProgress"] = 1] = "SyncStateInProgress";
    Quan_SyncState[Quan_SyncState["SyncStateInSuccess"] = 2] = "SyncStateInSuccess";
  })(Quan_SyncState || (Quan_SyncState = {}));

  return Quan_SyncState;
}();
export var Quan_GetAppScopeNotMatchUserCountReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_GetAppScopeNotMatchUserCountReq_Type;

  (function (Quan_GetAppScopeNotMatchUserCountReq_Type) {
    Quan_GetAppScopeNotMatchUserCountReq_Type[Quan_GetAppScopeNotMatchUserCountReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_GetAppScopeNotMatchUserCountReq_Type[Quan_GetAppScopeNotMatchUserCountReq_Type["TypeRobot"] = 1] = "TypeRobot";
  })(Quan_GetAppScopeNotMatchUserCountReq_Type || (Quan_GetAppScopeNotMatchUserCountReq_Type = {}));

  return Quan_GetAppScopeNotMatchUserCountReq_Type;
}();
export var Quan_GetExtContactFollowListReq_AccountType = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactFollowListReq_AccountType;

  (function (Quan_GetExtContactFollowListReq_AccountType) {
    Quan_GetExtContactFollowListReq_AccountType[Quan_GetExtContactFollowListReq_AccountType["AccountTypeNil"] = 0] = "AccountTypeNil";
    Quan_GetExtContactFollowListReq_AccountType[Quan_GetExtContactFollowListReq_AccountType["AccountTypeAll"] = 1] = "AccountTypeAll";
    Quan_GetExtContactFollowListReq_AccountType[Quan_GetExtContactFollowListReq_AccountType["AccountTypeNormal"] = 2] = "AccountTypeNormal";
    Quan_GetExtContactFollowListReq_AccountType[Quan_GetExtContactFollowListReq_AccountType["AccountTypePlatform"] = 3] = "AccountTypePlatform";
    Quan_GetExtContactFollowListReq_AccountType[Quan_GetExtContactFollowListReq_AccountType["AccountTypeHostAccount"] = 4] = "AccountTypeHostAccount";
  })(Quan_GetExtContactFollowListReq_AccountType || (Quan_GetExtContactFollowListReq_AccountType = {}));

  return Quan_GetExtContactFollowListReq_AccountType;
}();
export var Quan_GetExtContactFollowListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactFollowListReq_ListOption;

  (function (Quan_GetExtContactFollowListReq_ListOption) {
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionUid"] = 1] = "ListOptionUid";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionSearchName"] = 2] = "ListOptionSearchName";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionGender"] = 3] = "ListOptionGender";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionAddTime"] = 5] = "ListOptionAddTime";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionCorpTag"] = 6] = "ListOptionCorpTag";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionDeletedByStaff"] = 7] = "ListOptionDeletedByStaff";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionDeletedByExtContact"] = 8] = "ListOptionDeletedByExtContact";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionUserDeletedAt"] = 9] = "ListOptionUserDeletedAt";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionChannelId"] = 10] = "ListOptionChannelId";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionRemarkPhone"] = 11] = "ListOptionRemarkPhone";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionUidList"] = 12] = "ListOptionUidList";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionHasYcSerialNo"] = 13] = "ListOptionHasYcSerialNo";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionAccountType"] = 14] = "ListOptionAccountType";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionAddWay"] = 15] = "ListOptionAddWay";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionExtUidList"] = 16] = "ListOptionExtUidList";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionCorpTagIsUnion"] = 17] = "ListOptionCorpTagIsUnion";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionIdList"] = 18] = "ListOptionIdList";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionRfmTag"] = 19] = "ListOptionRfmTag";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionRfmTagIsUnion"] = 20] = "ListOptionRfmTagIsUnion";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionExcludeCorpTag"] = 21] = "ListOptionExcludeCorpTag";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionAchievementUidList"] = 22] = "ListOptionAchievementUidList";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["TimeTagValueAndList"] = 35] = "TimeTagValueAndList";
    Quan_GetExtContactFollowListReq_ListOption[Quan_GetExtContactFollowListReq_ListOption["ListOptionChannelIdList"] = 36] = "ListOptionChannelIdList";
  })(Quan_GetExtContactFollowListReq_ListOption || (Quan_GetExtContactFollowListReq_ListOption = {}));

  return Quan_GetExtContactFollowListReq_ListOption;
}();
export var Quan_GetUserList4SelectorReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetUserList4SelectorReq_ListOption;

  (function (Quan_GetUserList4SelectorReq_ListOption) {
    Quan_GetUserList4SelectorReq_ListOption[Quan_GetUserList4SelectorReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetUserList4SelectorReq_ListOption[Quan_GetUserList4SelectorReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetUserList4SelectorReq_ListOption[Quan_GetUserList4SelectorReq_ListOption["ListOptionIsAchievementUser"] = 2] = "ListOptionIsAchievementUser";
  })(Quan_GetUserList4SelectorReq_ListOption || (Quan_GetUserList4SelectorReq_ListOption = {}));

  return Quan_GetUserList4SelectorReq_ListOption;
}();
export var Quan_GetExtContactReq_UserType = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactReq_UserType;

  (function (Quan_GetExtContactReq_UserType) {
    Quan_GetExtContactReq_UserType[Quan_GetExtContactReq_UserType["UserTypeNil"] = 0] = "UserTypeNil";
    Quan_GetExtContactReq_UserType[Quan_GetExtContactReq_UserType["UserTypeNormal"] = 1] = "UserTypeNormal";
    Quan_GetExtContactReq_UserType[Quan_GetExtContactReq_UserType["UserTypeRobot"] = 2] = "UserTypeRobot";
  })(Quan_GetExtContactReq_UserType || (Quan_GetExtContactReq_UserType = {}));

  return Quan_GetExtContactReq_UserType;
}();
export var Quan_GetOperLogListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetOperLogListReq_ListOption;

  (function (Quan_GetOperLogListReq_ListOption) {
    Quan_GetOperLogListReq_ListOption[Quan_GetOperLogListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetOperLogListReq_ListOption[Quan_GetOperLogListReq_ListOption["ListOptionOperLogType"] = 1] = "ListOptionOperLogType";
    Quan_GetOperLogListReq_ListOption[Quan_GetOperLogListReq_ListOption["ListOptionUid"] = 2] = "ListOptionUid";
    Quan_GetOperLogListReq_ListOption[Quan_GetOperLogListReq_ListOption["ListOptionCreatedAt"] = 3] = "ListOptionCreatedAt";
  })(Quan_GetOperLogListReq_ListOption || (Quan_GetOperLogListReq_ListOption = {}));

  return Quan_GetOperLogListReq_ListOption;
}();
export var Quan_BatchSetCorpTag2FollowReq_ActionType = function () {
  //__ENUM_IIFE__
  var Quan_BatchSetCorpTag2FollowReq_ActionType;

  (function (Quan_BatchSetCorpTag2FollowReq_ActionType) {
    Quan_BatchSetCorpTag2FollowReq_ActionType[Quan_BatchSetCorpTag2FollowReq_ActionType["ActionTypeAddTag"] = 0] = "ActionTypeAddTag";
    Quan_BatchSetCorpTag2FollowReq_ActionType[Quan_BatchSetCorpTag2FollowReq_ActionType["ActionTypeDelTag"] = 1] = "ActionTypeDelTag";
  })(Quan_BatchSetCorpTag2FollowReq_ActionType || (Quan_BatchSetCorpTag2FollowReq_ActionType = {}));

  return Quan_BatchSetCorpTag2FollowReq_ActionType;
}();
export var Quan_GetDupExtContactFollowListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetDupExtContactFollowListReq_ListOption;

  (function (Quan_GetDupExtContactFollowListReq_ListOption) {
    Quan_GetDupExtContactFollowListReq_ListOption[Quan_GetDupExtContactFollowListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetDupExtContactFollowListReq_ListOption[Quan_GetDupExtContactFollowListReq_ListOption["ListOptionSearchName"] = 1] = "ListOptionSearchName";
  })(Quan_GetDupExtContactFollowListReq_ListOption || (Quan_GetDupExtContactFollowListReq_ListOption = {}));

  return Quan_GetDupExtContactFollowListReq_ListOption;
}();
export var Quan_GetExtContactBatchSendListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactBatchSendListReq_ListOption;

  (function (Quan_GetExtContactBatchSendListReq_ListOption) {
    Quan_GetExtContactBatchSendListReq_ListOption[Quan_GetExtContactBatchSendListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactBatchSendListReq_ListOption[Quan_GetExtContactBatchSendListReq_ListOption["ListOptionTitle"] = 1] = "ListOptionTitle";
    Quan_GetExtContactBatchSendListReq_ListOption[Quan_GetExtContactBatchSendListReq_ListOption["ListOptionCreatorUid"] = 2] = "ListOptionCreatorUid";
    Quan_GetExtContactBatchSendListReq_ListOption[Quan_GetExtContactBatchSendListReq_ListOption["ListOptionSendType"] = 3] = "ListOptionSendType";
    Quan_GetExtContactBatchSendListReq_ListOption[Quan_GetExtContactBatchSendListReq_ListOption["ListOptionCreatedAt"] = 4] = "ListOptionCreatedAt";
    Quan_GetExtContactBatchSendListReq_ListOption[Quan_GetExtContactBatchSendListReq_ListOption["ListOptionSchedulerAt"] = 5] = "ListOptionSchedulerAt";
    Quan_GetExtContactBatchSendListReq_ListOption[Quan_GetExtContactBatchSendListReq_ListOption["ListOptionParentBatchSendId"] = 6] = "ListOptionParentBatchSendId";
    Quan_GetExtContactBatchSendListReq_ListOption[Quan_GetExtContactBatchSendListReq_ListOption["ListOptionState"] = 7] = "ListOptionState";
  })(Quan_GetExtContactBatchSendListReq_ListOption || (Quan_GetExtContactBatchSendListReq_ListOption = {}));

  return Quan_GetExtContactBatchSendListReq_ListOption;
}(); // @desc: 同步范围枚举

export var Quan_SyncExtContactReq_SyncScope = function () {
  //__ENUM_IIFE__
  var Quan_SyncExtContactReq_SyncScope;

  (function (Quan_SyncExtContactReq_SyncScope) {
    Quan_SyncExtContactReq_SyncScope[Quan_SyncExtContactReq_SyncScope["SyncScopeNil"] = 0] = "SyncScopeNil";
    Quan_SyncExtContactReq_SyncScope[Quan_SyncExtContactReq_SyncScope["SyncScopeSearchByMember"] = 1] = "SyncScopeSearchByMember";
    Quan_SyncExtContactReq_SyncScope[Quan_SyncExtContactReq_SyncScope["SyncScopeAuthChange"] = 2] = "SyncScopeAuthChange";
  })(Quan_SyncExtContactReq_SyncScope || (Quan_SyncExtContactReq_SyncScope = {}));

  return Quan_SyncExtContactReq_SyncScope;
}();
export var Quan_GetExtContactBatchSendStaffListReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactBatchSendStaffListReq_Type;

  (function (Quan_GetExtContactBatchSendStaffListReq_Type) {
    Quan_GetExtContactBatchSendStaffListReq_Type[Quan_GetExtContactBatchSendStaffListReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_GetExtContactBatchSendStaffListReq_Type[Quan_GetExtContactBatchSendStaffListReq_Type["TypeAll"] = 1] = "TypeAll";
    Quan_GetExtContactBatchSendStaffListReq_Type[Quan_GetExtContactBatchSendStaffListReq_Type["TypeSent"] = 2] = "TypeSent";
    Quan_GetExtContactBatchSendStaffListReq_Type[Quan_GetExtContactBatchSendStaffListReq_Type["TypeUnsent"] = 3] = "TypeUnsent";
    Quan_GetExtContactBatchSendStaffListReq_Type[Quan_GetExtContactBatchSendStaffListReq_Type["TypeNoNeedToSend"] = 4] = "TypeNoNeedToSend";
  })(Quan_GetExtContactBatchSendStaffListReq_Type || (Quan_GetExtContactBatchSendStaffListReq_Type = {}));

  return Quan_GetExtContactBatchSendStaffListReq_Type;
}();
export var Quan_GetExtContactBatchSendStaffListReq_ReqCntType = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactBatchSendStaffListReq_ReqCntType;

  (function (Quan_GetExtContactBatchSendStaffListReq_ReqCntType) {
    Quan_GetExtContactBatchSendStaffListReq_ReqCntType[Quan_GetExtContactBatchSendStaffListReq_ReqCntType["ReqCntTypeNil"] = 0] = "ReqCntTypeNil";
    Quan_GetExtContactBatchSendStaffListReq_ReqCntType[Quan_GetExtContactBatchSendStaffListReq_ReqCntType["ReqCntTypeOne"] = 1] = "ReqCntTypeOne";
    Quan_GetExtContactBatchSendStaffListReq_ReqCntType[Quan_GetExtContactBatchSendStaffListReq_ReqCntType["ReqCntTypeGtOne"] = 2] = "ReqCntTypeGtOne";
  })(Quan_GetExtContactBatchSendStaffListReq_ReqCntType || (Quan_GetExtContactBatchSendStaffListReq_ReqCntType = {}));

  return Quan_GetExtContactBatchSendStaffListReq_ReqCntType;
}();
export var Quan_GetExtContactBatchSendStaffListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactBatchSendStaffListReq_ListOption;

  (function (Quan_GetExtContactBatchSendStaffListReq_ListOption) {
    Quan_GetExtContactBatchSendStaffListReq_ListOption[Quan_GetExtContactBatchSendStaffListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactBatchSendStaffListReq_ListOption[Quan_GetExtContactBatchSendStaffListReq_ListOption["ListOptionType"] = 1] = "ListOptionType";
    Quan_GetExtContactBatchSendStaffListReq_ListOption[Quan_GetExtContactBatchSendStaffListReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
    Quan_GetExtContactBatchSendStaffListReq_ListOption[Quan_GetExtContactBatchSendStaffListReq_ListOption["ListOptionReqCntType"] = 3] = "ListOptionReqCntType";
  })(Quan_GetExtContactBatchSendStaffListReq_ListOption || (Quan_GetExtContactBatchSendStaffListReq_ListOption = {}));

  return Quan_GetExtContactBatchSendStaffListReq_ListOption;
}();
export var Quan_GetExtContactBatchSendExtListReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactBatchSendExtListReq_Type;

  (function (Quan_GetExtContactBatchSendExtListReq_Type) {
    Quan_GetExtContactBatchSendExtListReq_Type[Quan_GetExtContactBatchSendExtListReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_GetExtContactBatchSendExtListReq_Type[Quan_GetExtContactBatchSendExtListReq_Type["TypeAll"] = 1] = "TypeAll";
    Quan_GetExtContactBatchSendExtListReq_Type[Quan_GetExtContactBatchSendExtListReq_Type["TypeSent"] = 2] = "TypeSent";
    Quan_GetExtContactBatchSendExtListReq_Type[Quan_GetExtContactBatchSendExtListReq_Type["TypeUnsent"] = 3] = "TypeUnsent";
    Quan_GetExtContactBatchSendExtListReq_Type[Quan_GetExtContactBatchSendExtListReq_Type["TypeNotFriend"] = 4] = "TypeNotFriend";
    Quan_GetExtContactBatchSendExtListReq_Type[Quan_GetExtContactBatchSendExtListReq_Type["TypeExceedLimit"] = 5] = "TypeExceedLimit";
  })(Quan_GetExtContactBatchSendExtListReq_Type || (Quan_GetExtContactBatchSendExtListReq_Type = {}));

  return Quan_GetExtContactBatchSendExtListReq_Type;
}();
export var Quan_GetExtContactBatchSendExtListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactBatchSendExtListReq_ListOption;

  (function (Quan_GetExtContactBatchSendExtListReq_ListOption) {
    Quan_GetExtContactBatchSendExtListReq_ListOption[Quan_GetExtContactBatchSendExtListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactBatchSendExtListReq_ListOption[Quan_GetExtContactBatchSendExtListReq_ListOption["ListOptionType"] = 1] = "ListOptionType";
    Quan_GetExtContactBatchSendExtListReq_ListOption[Quan_GetExtContactBatchSendExtListReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
    Quan_GetExtContactBatchSendExtListReq_ListOption[Quan_GetExtContactBatchSendExtListReq_ListOption["ListOptionInviteGroupId"] = 3] = "ListOptionInviteGroupId";
    Quan_GetExtContactBatchSendExtListReq_ListOption[Quan_GetExtContactBatchSendExtListReq_ListOption["ListOptionStaffUid"] = 4] = "ListOptionStaffUid";
    Quan_GetExtContactBatchSendExtListReq_ListOption[Quan_GetExtContactBatchSendExtListReq_ListOption["ListOptionEnterGroup"] = 5] = "ListOptionEnterGroup";
  })(Quan_GetExtContactBatchSendExtListReq_ListOption || (Quan_GetExtContactBatchSendExtListReq_ListOption = {}));

  return Quan_GetExtContactBatchSendExtListReq_ListOption;
}();
export var Quan_NotifyStaffExtContactBatchSendReq_NotifyType = function () {
  //__ENUM_IIFE__
  var Quan_NotifyStaffExtContactBatchSendReq_NotifyType;

  (function (Quan_NotifyStaffExtContactBatchSendReq_NotifyType) {
    Quan_NotifyStaffExtContactBatchSendReq_NotifyType[Quan_NotifyStaffExtContactBatchSendReq_NotifyType["NotifyTypeNil"] = 0] = "NotifyTypeNil";
    Quan_NotifyStaffExtContactBatchSendReq_NotifyType[Quan_NotifyStaffExtContactBatchSendReq_NotifyType["NotifyTypeAll"] = 1] = "NotifyTypeAll";
    Quan_NotifyStaffExtContactBatchSendReq_NotifyType[Quan_NotifyStaffExtContactBatchSendReq_NotifyType["NotifyTypeUidList"] = 2] = "NotifyTypeUidList";
  })(Quan_NotifyStaffExtContactBatchSendReq_NotifyType || (Quan_NotifyStaffExtContactBatchSendReq_NotifyType = {}));

  return Quan_NotifyStaffExtContactBatchSendReq_NotifyType;
}();
export var Quan_GetWxAdminLoginStateRsp_ScanStatus = function () {
  //__ENUM_IIFE__
  var Quan_GetWxAdminLoginStateRsp_ScanStatus;

  (function (Quan_GetWxAdminLoginStateRsp_ScanStatus) {
    Quan_GetWxAdminLoginStateRsp_ScanStatus[Quan_GetWxAdminLoginStateRsp_ScanStatus["ScanStatusNil"] = 0] = "ScanStatusNil";
    Quan_GetWxAdminLoginStateRsp_ScanStatus[Quan_GetWxAdminLoginStateRsp_ScanStatus["ScanStatusScanning"] = 1] = "ScanStatusScanning";
    Quan_GetWxAdminLoginStateRsp_ScanStatus[Quan_GetWxAdminLoginStateRsp_ScanStatus["ScanStatusSuccess"] = 2] = "ScanStatusSuccess";
  })(Quan_GetWxAdminLoginStateRsp_ScanStatus || (Quan_GetWxAdminLoginStateRsp_ScanStatus = {}));

  return Quan_GetWxAdminLoginStateRsp_ScanStatus;
}();
export var Quan_InitNonAuthAppReq_SelectedScope = function () {
  //__ENUM_IIFE__
  var Quan_InitNonAuthAppReq_SelectedScope;

  (function (Quan_InitNonAuthAppReq_SelectedScope) {
    Quan_InitNonAuthAppReq_SelectedScope[Quan_InitNonAuthAppReq_SelectedScope["SelectedScopeNil"] = 0] = "SelectedScopeNil";
    Quan_InitNonAuthAppReq_SelectedScope[Quan_InitNonAuthAppReq_SelectedScope["SelectedScopeAll"] = 1] = "SelectedScopeAll";
  })(Quan_InitNonAuthAppReq_SelectedScope || (Quan_InitNonAuthAppReq_SelectedScope = {}));

  return Quan_InitNonAuthAppReq_SelectedScope;
}();
export var Quan_GetGroupChatListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetGroupChatListReq_ListOption;

  (function (Quan_GetGroupChatListReq_ListOption) {
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionOwner"] = 1] = "ListOptionOwner";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionState"] = 3] = "ListOptionState";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionIdList"] = 4] = "ListOptionIdList";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionGroupCreateAt"] = 5] = "ListOptionGroupCreateAt";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionOwnerList"] = 6] = "ListOptionOwnerList";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionWithScopePerm"] = 7] = "ListOptionWithScopePerm";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionOrderByCreateGroupTimeDesc"] = 8] = "ListOptionOrderByCreateGroupTimeDesc";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionOrderByCreateGroupTimeAsc"] = 9] = "ListOptionOrderByCreateGroupTimeAsc";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionOrderByMemberCountDesc"] = 10] = "ListOptionOrderByMemberCountDesc";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionOrderByMemberCountAsc"] = 11] = "ListOptionOrderByMemberCountAsc";
    Quan_GetGroupChatListReq_ListOption[Quan_GetGroupChatListReq_ListOption["ListOptionLicenceActiveOrOnTrial"] = 12] = "ListOptionLicenceActiveOrOnTrial";
  })(Quan_GetGroupChatListReq_ListOption || (Quan_GetGroupChatListReq_ListOption = {}));

  return Quan_GetGroupChatListReq_ListOption;
}();
export var Quan_GetGroupChatOwnerListReq_AccountType = function () {
  //__ENUM_IIFE__
  var Quan_GetGroupChatOwnerListReq_AccountType;

  (function (Quan_GetGroupChatOwnerListReq_AccountType) {
    Quan_GetGroupChatOwnerListReq_AccountType[Quan_GetGroupChatOwnerListReq_AccountType["AccountTypeNil"] = 0] = "AccountTypeNil";
    Quan_GetGroupChatOwnerListReq_AccountType[Quan_GetGroupChatOwnerListReq_AccountType["AccountTypeAll"] = 1] = "AccountTypeAll";
    Quan_GetGroupChatOwnerListReq_AccountType[Quan_GetGroupChatOwnerListReq_AccountType["AccountTypeNormal"] = 2] = "AccountTypeNormal";
    Quan_GetGroupChatOwnerListReq_AccountType[Quan_GetGroupChatOwnerListReq_AccountType["AccountTypePlatform"] = 3] = "AccountTypePlatform";
    Quan_GetGroupChatOwnerListReq_AccountType[Quan_GetGroupChatOwnerListReq_AccountType["AccountTypeHostAccount"] = 4] = "AccountTypeHostAccount";
  })(Quan_GetGroupChatOwnerListReq_AccountType || (Quan_GetGroupChatOwnerListReq_AccountType = {}));

  return Quan_GetGroupChatOwnerListReq_AccountType;
}();
export var Quan_GetGroupChatOwnerListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetGroupChatOwnerListReq_ListOption;

  (function (Quan_GetGroupChatOwnerListReq_ListOption) {
    Quan_GetGroupChatOwnerListReq_ListOption[Quan_GetGroupChatOwnerListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetGroupChatOwnerListReq_ListOption[Quan_GetGroupChatOwnerListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetGroupChatOwnerListReq_ListOption[Quan_GetGroupChatOwnerListReq_ListOption["ListOptionAccountType"] = 2] = "ListOptionAccountType";
    Quan_GetGroupChatOwnerListReq_ListOption[Quan_GetGroupChatOwnerListReq_ListOption["ListOptionHasActiveLicenceOrOnTrial"] = 3] = "ListOptionHasActiveLicenceOrOnTrial";
  })(Quan_GetGroupChatOwnerListReq_ListOption || (Quan_GetGroupChatOwnerListReq_ListOption = {}));

  return Quan_GetGroupChatOwnerListReq_ListOption;
}();
export var Quan_GetChannelListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetChannelListReq_ListOption;

  (function (Quan_GetChannelListReq_ListOption) {
    Quan_GetChannelListReq_ListOption[Quan_GetChannelListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetChannelListReq_ListOption[Quan_GetChannelListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetChannelListReq_ListOption[Quan_GetChannelListReq_ListOption["ListOptionCreator"] = 2] = "ListOptionCreator";
    Quan_GetChannelListReq_ListOption[Quan_GetChannelListReq_ListOption["ListOptionChannelLiveCodeId"] = 3] = "ListOptionChannelLiveCodeId";
    Quan_GetChannelListReq_ListOption[Quan_GetChannelListReq_ListOption["ListOptionCreateFromApi"] = 4] = "ListOptionCreateFromApi";
    Quan_GetChannelListReq_ListOption[Quan_GetChannelListReq_ListOption["ListOptionChannelIdList"] = 5] = "ListOptionChannelIdList";
  })(Quan_GetChannelListReq_ListOption || (Quan_GetChannelListReq_ListOption = {}));

  return Quan_GetChannelListReq_ListOption;
}();
export var Quan_GetChannelLiveCodeListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetChannelLiveCodeListReq_ListOption;

  (function (Quan_GetChannelLiveCodeListReq_ListOption) {
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionChannelIdList"] = 2] = "ListOptionChannelIdList";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionType"] = 3] = "ListOptionType";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionUidList"] = 4] = "ListOptionUidList";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionParentId"] = 5] = "ListOptionParentId";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionIdList"] = 6] = "ListOptionIdList";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionCreatedAtEnd"] = 7] = "ListOptionCreatedAtEnd";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionLiveCodeStateList"] = 8] = "ListOptionLiveCodeStateList";
    Quan_GetChannelLiveCodeListReq_ListOption[Quan_GetChannelLiveCodeListReq_ListOption["ListOptionCreateFromApi"] = 9] = "ListOptionCreateFromApi";
  })(Quan_GetChannelLiveCodeListReq_ListOption || (Quan_GetChannelLiveCodeListReq_ListOption = {}));

  return Quan_GetChannelLiveCodeListReq_ListOption;
}();
export var Quan_GetExtContactBatchSendGroupListReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactBatchSendGroupListReq_Type;

  (function (Quan_GetExtContactBatchSendGroupListReq_Type) {
    Quan_GetExtContactBatchSendGroupListReq_Type[Quan_GetExtContactBatchSendGroupListReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_GetExtContactBatchSendGroupListReq_Type[Quan_GetExtContactBatchSendGroupListReq_Type["TypeAll"] = 1] = "TypeAll";
    Quan_GetExtContactBatchSendGroupListReq_Type[Quan_GetExtContactBatchSendGroupListReq_Type["TypeSent"] = 2] = "TypeSent";
    Quan_GetExtContactBatchSendGroupListReq_Type[Quan_GetExtContactBatchSendGroupListReq_Type["TypeUnsent"] = 3] = "TypeUnsent";
    Quan_GetExtContactBatchSendGroupListReq_Type[Quan_GetExtContactBatchSendGroupListReq_Type["TypeSendErr"] = 4] = "TypeSendErr";
  })(Quan_GetExtContactBatchSendGroupListReq_Type || (Quan_GetExtContactBatchSendGroupListReq_Type = {}));

  return Quan_GetExtContactBatchSendGroupListReq_Type;
}();
export var Quan_GetExtContactBatchSendGroupListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactBatchSendGroupListReq_ListOption;

  (function (Quan_GetExtContactBatchSendGroupListReq_ListOption) {
    Quan_GetExtContactBatchSendGroupListReq_ListOption[Quan_GetExtContactBatchSendGroupListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactBatchSendGroupListReq_ListOption[Quan_GetExtContactBatchSendGroupListReq_ListOption["ListOptionType"] = 1] = "ListOptionType";
    Quan_GetExtContactBatchSendGroupListReq_ListOption[Quan_GetExtContactBatchSendGroupListReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
    Quan_GetExtContactBatchSendGroupListReq_ListOption[Quan_GetExtContactBatchSendGroupListReq_ListOption["ListOptionOwnerUid"] = 3] = "ListOptionOwnerUid";
  })(Quan_GetExtContactBatchSendGroupListReq_ListOption || (Quan_GetExtContactBatchSendGroupListReq_ListOption = {}));

  return Quan_GetExtContactBatchSendGroupListReq_ListOption;
}();
export var Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState = function () {
  //__ENUM_IIFE__
  var Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState;

  (function (Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState) {
    Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState[Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState["CorpInstallStateNil"] = 0] = "CorpInstallStateNil";
    Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState[Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState["CorpInstallStateInstalling"] = 1] = "CorpInstallStateInstalling";
    Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState[Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState["CorpInstallStateSuccess"] = 2] = "CorpInstallStateSuccess";
  })(Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState || (Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState = {}));

  return Quan_CheckAuthRegisterQrRsp_CorpStatusDTO_CorpInstallState;
}();
export var Quan_ApplyState = function () {
  //__ENUM_IIFE__
  var Quan_ApplyState;

  (function (Quan_ApplyState) {
    Quan_ApplyState[Quan_ApplyState["ApplyStateNil"] = 0] = "ApplyStateNil";
    Quan_ApplyState[Quan_ApplyState["ApplyStateWait"] = 1] = "ApplyStateWait";
    Quan_ApplyState[Quan_ApplyState["ApplyStateReject"] = 2] = "ApplyStateReject";
    Quan_ApplyState[Quan_ApplyState["ApplyStatePass"] = 3] = "ApplyStatePass";
  })(Quan_ApplyState || (Quan_ApplyState = {}));

  return Quan_ApplyState;
}();
export var Quan_GetInviteGroupByTagListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetInviteGroupByTagListReq_ListOption;

  (function (Quan_GetInviteGroupByTagListReq_ListOption) {
    Quan_GetInviteGroupByTagListReq_ListOption[Quan_GetInviteGroupByTagListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetInviteGroupByTagListReq_ListOption[Quan_GetInviteGroupByTagListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
  })(Quan_GetInviteGroupByTagListReq_ListOption || (Quan_GetInviteGroupByTagListReq_ListOption = {}));

  return Quan_GetInviteGroupByTagListReq_ListOption;
}();
export var Quan_GetApplyInstallListAdminReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetApplyInstallListAdminReq_ListOption;

  (function (Quan_GetApplyInstallListAdminReq_ListOption) {
    Quan_GetApplyInstallListAdminReq_ListOption[Quan_GetApplyInstallListAdminReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetApplyInstallListAdminReq_ListOption[Quan_GetApplyInstallListAdminReq_ListOption["ListOptionPhone"] = 1] = "ListOptionPhone";
    Quan_GetApplyInstallListAdminReq_ListOption[Quan_GetApplyInstallListAdminReq_ListOption["ListOptionCompanyName"] = 2] = "ListOptionCompanyName";
  })(Quan_GetApplyInstallListAdminReq_ListOption || (Quan_GetApplyInstallListAdminReq_ListOption = {}));

  return Quan_GetApplyInstallListAdminReq_ListOption;
}();
export var Quan_GetWelcomeMsgListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetWelcomeMsgListReq_ListOption;

  (function (Quan_GetWelcomeMsgListReq_ListOption) {
    Quan_GetWelcomeMsgListReq_ListOption[Quan_GetWelcomeMsgListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetWelcomeMsgListReq_ListOption[Quan_GetWelcomeMsgListReq_ListOption["ListOptionTitle"] = 1] = "ListOptionTitle";
    Quan_GetWelcomeMsgListReq_ListOption[Quan_GetWelcomeMsgListReq_ListOption["ListOptionCreatedAt"] = 2] = "ListOptionCreatedAt";
  })(Quan_GetWelcomeMsgListReq_ListOption || (Quan_GetWelcomeMsgListReq_ListOption = {}));

  return Quan_GetWelcomeMsgListReq_ListOption;
}();
export var Quan_GetUserFeedbackListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetUserFeedbackListReq_ListOption;

  (function (Quan_GetUserFeedbackListReq_ListOption) {
    Quan_GetUserFeedbackListReq_ListOption[Quan_GetUserFeedbackListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetUserFeedbackListReq_ListOption[Quan_GetUserFeedbackListReq_ListOption["ListOptionCorpId"] = 1] = "ListOptionCorpId";
    Quan_GetUserFeedbackListReq_ListOption[Quan_GetUserFeedbackListReq_ListOption["ListOptionAppId"] = 2] = "ListOptionAppId";
  })(Quan_GetUserFeedbackListReq_ListOption || (Quan_GetUserFeedbackListReq_ListOption = {}));

  return Quan_GetUserFeedbackListReq_ListOption;
}();
export var Quan_GetAsyncTaskStateRsp_State = function () {
  //__ENUM_IIFE__
  var Quan_GetAsyncTaskStateRsp_State;

  (function (Quan_GetAsyncTaskStateRsp_State) {
    Quan_GetAsyncTaskStateRsp_State[Quan_GetAsyncTaskStateRsp_State["StateNil"] = 0] = "StateNil";
    Quan_GetAsyncTaskStateRsp_State[Quan_GetAsyncTaskStateRsp_State["StateInProgress"] = 1] = "StateInProgress";
    Quan_GetAsyncTaskStateRsp_State[Quan_GetAsyncTaskStateRsp_State["StateSuccess"] = 2] = "StateSuccess";
    Quan_GetAsyncTaskStateRsp_State[Quan_GetAsyncTaskStateRsp_State["StateFailure"] = 3] = "StateFailure";
  })(Quan_GetAsyncTaskStateRsp_State || (Quan_GetAsyncTaskStateRsp_State = {}));

  return Quan_GetAsyncTaskStateRsp_State;
}();
export var Quan_GetHelpDocListStaffReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetHelpDocListStaffReq_ListOption;

  (function (Quan_GetHelpDocListStaffReq_ListOption) {
    Quan_GetHelpDocListStaffReq_ListOption[Quan_GetHelpDocListStaffReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetHelpDocListStaffReq_ListOption[Quan_GetHelpDocListStaffReq_ListOption["ListOptionTitle"] = 1] = "ListOptionTitle";
    Quan_GetHelpDocListStaffReq_ListOption[Quan_GetHelpDocListStaffReq_ListOption["ListOptionIsHide"] = 2] = "ListOptionIsHide";
  })(Quan_GetHelpDocListStaffReq_ListOption || (Quan_GetHelpDocListStaffReq_ListOption = {}));

  return Quan_GetHelpDocListStaffReq_ListOption;
}();
export var Quan_GetChangeLogListStaffReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetChangeLogListStaffReq_ListOption;

  (function (Quan_GetChangeLogListStaffReq_ListOption) {
    Quan_GetChangeLogListStaffReq_ListOption[Quan_GetChangeLogListStaffReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetChangeLogListStaffReq_ListOption[Quan_GetChangeLogListStaffReq_ListOption["ListOptionTitle"] = 1] = "ListOptionTitle";
    Quan_GetChangeLogListStaffReq_ListOption[Quan_GetChangeLogListStaffReq_ListOption["ListOptionIsHide"] = 2] = "ListOptionIsHide";
  })(Quan_GetChangeLogListStaffReq_ListOption || (Quan_GetChangeLogListStaffReq_ListOption = {}));

  return Quan_GetChangeLogListStaffReq_ListOption;
}();
export var Quan_SendVerifyCodeReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_SendVerifyCodeReq_Type;

  (function (Quan_SendVerifyCodeReq_Type) {
    Quan_SendVerifyCodeReq_Type[Quan_SendVerifyCodeReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_SendVerifyCodeReq_Type[Quan_SendVerifyCodeReq_Type["TypeAuthPhone"] = 1] = "TypeAuthPhone";
  })(Quan_SendVerifyCodeReq_Type || (Quan_SendVerifyCodeReq_Type = {}));

  return Quan_SendVerifyCodeReq_Type;
}();
export var Quan_ExportExtContactFollowListReq_Field = function () {
  //__ENUM_IIFE__
  var Quan_ExportExtContactFollowListReq_Field;

  (function (Quan_ExportExtContactFollowListReq_Field) {
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldNil"] = 0] = "FieldNil";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldExtContactName"] = 1] = "FieldExtContactName";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldExtUserId"] = 2] = "FieldExtUserId";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldRemark"] = 3] = "FieldRemark";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldDesc"] = 4] = "FieldDesc";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldPhone"] = 5] = "FieldPhone";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldLossState"] = 6] = "FieldLossState";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldCorpName"] = 7] = "FieldCorpName";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldGender"] = 8] = "FieldGender";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldCorpTag"] = 9] = "FieldCorpTag";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldPersonalTag"] = 10] = "FieldPersonalTag";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldUserName"] = 11] = "FieldUserName";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldWwUserId"] = 12] = "FieldWwUserId";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldAddWay"] = 13] = "FieldAddWay";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldAddTime"] = 14] = "FieldAddTime";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldGroupName"] = 15] = "FieldGroupName";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldGroupJoinAt"] = 16] = "FieldGroupJoinAt";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldGroupNum"] = 17] = "FieldGroupNum";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldCustom"] = 18] = "FieldCustom";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldExtUnionid"] = 19] = "FieldExtUnionid";
    Quan_ExportExtContactFollowListReq_Field[Quan_ExportExtContactFollowListReq_Field["FieldUserDeletedAt"] = 20] = "FieldUserDeletedAt";
  })(Quan_ExportExtContactFollowListReq_Field || (Quan_ExportExtContactFollowListReq_Field = {}));

  return Quan_ExportExtContactFollowListReq_Field;
}();
export var Quan_GetCustomizedCustomerClueListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetCustomizedCustomerClueListReq_ListOption;

  (function (Quan_GetCustomizedCustomerClueListReq_ListOption) {
    Quan_GetCustomizedCustomerClueListReq_ListOption[Quan_GetCustomizedCustomerClueListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetCustomizedCustomerClueListReq_ListOption[Quan_GetCustomizedCustomerClueListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetCustomizedCustomerClueListReq_ListOption[Quan_GetCustomizedCustomerClueListReq_ListOption["ListOptionNote"] = 2] = "ListOptionNote";
    Quan_GetCustomizedCustomerClueListReq_ListOption[Quan_GetCustomizedCustomerClueListReq_ListOption["ListOptionState"] = 3] = "ListOptionState";
    Quan_GetCustomizedCustomerClueListReq_ListOption[Quan_GetCustomizedCustomerClueListReq_ListOption["ListOptionCreatedAt"] = 4] = "ListOptionCreatedAt";
  })(Quan_GetCustomizedCustomerClueListReq_ListOption || (Quan_GetCustomizedCustomerClueListReq_ListOption = {}));

  return Quan_GetCustomizedCustomerClueListReq_ListOption;
}();
export var Quan_UpdateCustomizedCustomerClueReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_UpdateCustomizedCustomerClueReq_Type;

  (function (Quan_UpdateCustomizedCustomerClueReq_Type) {
    Quan_UpdateCustomizedCustomerClueReq_Type[Quan_UpdateCustomizedCustomerClueReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_UpdateCustomizedCustomerClueReq_Type[Quan_UpdateCustomizedCustomerClueReq_Type["TypeState"] = 1] = "TypeState";
    Quan_UpdateCustomizedCustomerClueReq_Type[Quan_UpdateCustomizedCustomerClueReq_Type["TypeNote"] = 2] = "TypeNote";
  })(Quan_UpdateCustomizedCustomerClueReq_Type || (Quan_UpdateCustomizedCustomerClueReq_Type = {}));

  return Quan_UpdateCustomizedCustomerClueReq_Type;
}();
export var Quan_WsMsgWrapper_MsgType = function () {
  //__ENUM_IIFE__
  var Quan_WsMsgWrapper_MsgType;

  (function (Quan_WsMsgWrapper_MsgType) {
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeNil"] = 0] = "MsgTypeNil";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeAppConfigError"] = 1] = "MsgTypeAppConfigError";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeUserRoleChange"] = 2] = "MsgTypeUserRoleChange";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeCorpCancelAuth"] = 3] = "MsgTypeCorpCancelAuth";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypePaidNewQrobotOrder"] = 4] = "MsgTypePaidNewQrobotOrder";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeQRobotSyncGroupResult"] = 5] = "MsgTypeQRobotSyncGroupResult";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeAppScopeChanged"] = 6] = "MsgTypeAppScopeChanged";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeDelUserDistribute"] = 7] = "MsgTypeDelUserDistribute";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeQWhaleSyncGroupResult"] = 8] = "MsgTypeQWhaleSyncGroupResult";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeAsyncTaskResult"] = 9] = "MsgTypeAsyncTaskResult";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeDelUserRole"] = 10] = "MsgTypeDelUserRole";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeNewPlatNotice"] = 11] = "MsgTypeNewPlatNotice";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeSyncChannelMsgResult"] = 12] = "MsgTypeSyncChannelMsgResult";
    Quan_WsMsgWrapper_MsgType[Quan_WsMsgWrapper_MsgType["MsgTypeSyncChannelLiveMsgResult"] = 13] = "MsgTypeSyncChannelLiveMsgResult";
  })(Quan_WsMsgWrapper_MsgType || (Quan_WsMsgWrapper_MsgType = {}));

  return Quan_WsMsgWrapper_MsgType;
}();
export var Quan_GetDeptAndUserListStateRsp_State = function () {
  //__ENUM_IIFE__
  var Quan_GetDeptAndUserListStateRsp_State;

  (function (Quan_GetDeptAndUserListStateRsp_State) {
    Quan_GetDeptAndUserListStateRsp_State[Quan_GetDeptAndUserListStateRsp_State["StateNil"] = 0] = "StateNil";
    Quan_GetDeptAndUserListStateRsp_State[Quan_GetDeptAndUserListStateRsp_State["StateInProgress"] = 1] = "StateInProgress";
    Quan_GetDeptAndUserListStateRsp_State[Quan_GetDeptAndUserListStateRsp_State["StateSuccess"] = 2] = "StateSuccess";
    Quan_GetDeptAndUserListStateRsp_State[Quan_GetDeptAndUserListStateRsp_State["StateFailure"] = 3] = "StateFailure";
  })(Quan_GetDeptAndUserListStateRsp_State || (Quan_GetDeptAndUserListStateRsp_State = {}));

  return Quan_GetDeptAndUserListStateRsp_State;
}();
export var Quan_GetMaterialListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMaterialListReq_ListOption;

  (function (Quan_GetMaterialListReq_ListOption) {
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionContent"] = 1] = "ListOptionContent";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionKeyword"] = 2] = "ListOptionKeyword";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionCreator"] = 3] = "ListOptionCreator";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionCategory"] = 4] = "ListOptionCategory";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionTypeList"] = 5] = "ListOptionTypeList";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionHasCreator"] = 6] = "ListOptionHasCreator";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionHasYcPagePathList"] = 7] = "ListOptionHasYcPagePathList";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionSearchBox"] = 8] = "ListOptionSearchBox";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionIds"] = 9] = "ListOptionIds";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionNotLive"] = 10] = "ListOptionNotLive";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionUid"] = 11] = "ListOptionUid";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionSidebarTabType"] = 12] = "ListOptionSidebarTabType";
    Quan_GetMaterialListReq_ListOption[Quan_GetMaterialListReq_ListOption["ListOptionIsAll"] = 13] = "ListOptionIsAll";
  })(Quan_GetMaterialListReq_ListOption || (Quan_GetMaterialListReq_ListOption = {}));

  return Quan_GetMaterialListReq_ListOption;
}();
export var Quan_GetMaterialCategoryListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMaterialCategoryListReq_ListOption;

  (function (Quan_GetMaterialCategoryListReq_ListOption) {
    Quan_GetMaterialCategoryListReq_ListOption[Quan_GetMaterialCategoryListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMaterialCategoryListReq_ListOption[Quan_GetMaterialCategoryListReq_ListOption["ListOptionCategoryId"] = 1] = "ListOptionCategoryId";
    Quan_GetMaterialCategoryListReq_ListOption[Quan_GetMaterialCategoryListReq_ListOption["ListOptionCategoryName"] = 2] = "ListOptionCategoryName";
    Quan_GetMaterialCategoryListReq_ListOption[Quan_GetMaterialCategoryListReq_ListOption["ListOptionUid"] = 3] = "ListOptionUid";
    Quan_GetMaterialCategoryListReq_ListOption[Quan_GetMaterialCategoryListReq_ListOption["ListOptionSidebarTabType"] = 4] = "ListOptionSidebarTabType";
  })(Quan_GetMaterialCategoryListReq_ListOption || (Quan_GetMaterialCategoryListReq_ListOption = {}));

  return Quan_GetMaterialCategoryListReq_ListOption;
}();
export var Quan_GetCorpListStaffReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetCorpListStaffReq_ListOption;

  (function (Quan_GetCorpListStaffReq_ListOption) {
    Quan_GetCorpListStaffReq_ListOption[Quan_GetCorpListStaffReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetCorpListStaffReq_ListOption[Quan_GetCorpListStaffReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetCorpListStaffReq_ListOption[Quan_GetCorpListStaffReq_ListOption["ListOptionCorpId"] = 2] = "ListOptionCorpId";
    Quan_GetCorpListStaffReq_ListOption[Quan_GetCorpListStaffReq_ListOption["ListOptionAppId"] = 3] = "ListOptionAppId";
    Quan_GetCorpListStaffReq_ListOption[Quan_GetCorpListStaffReq_ListOption["ListOptionCorpIdList"] = 4] = "ListOptionCorpIdList";
    Quan_GetCorpListStaffReq_ListOption[Quan_GetCorpListStaffReq_ListOption["ListOptionNoInCorpIdList"] = 5] = "ListOptionNoInCorpIdList";
    Quan_GetCorpListStaffReq_ListOption[Quan_GetCorpListStaffReq_ListOption["ListOptionAccountOn"] = 6] = "ListOptionAccountOn";
  })(Quan_GetCorpListStaffReq_ListOption || (Quan_GetCorpListStaffReq_ListOption = {}));

  return Quan_GetCorpListStaffReq_ListOption;
}();
export var Quan_GetSpeechcraftListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetSpeechcraftListReq_ListOption;

  (function (Quan_GetSpeechcraftListReq_ListOption) {
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionContent"] = 1] = "ListOptionContent";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionKeyword"] = 2] = "ListOptionKeyword";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionCreator"] = 3] = "ListOptionCreator";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionCategory"] = 4] = "ListOptionCategory";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionIsPersonal"] = 5] = "ListOptionIsPersonal";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionKeywordIdList"] = 6] = "ListOptionKeywordIdList";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionQuestionOrContent"] = 7] = "ListOptionQuestionOrContent";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionQuestionOrContentOrKeyword"] = 8] = "ListOptionQuestionOrContentOrKeyword";
    Quan_GetSpeechcraftListReq_ListOption[Quan_GetSpeechcraftListReq_ListOption["ListOptionTitle"] = 9] = "ListOptionTitle";
  })(Quan_GetSpeechcraftListReq_ListOption || (Quan_GetSpeechcraftListReq_ListOption = {}));

  return Quan_GetSpeechcraftListReq_ListOption;
}();
export var Quan_ModelResignedStaff_Type = function () {
  //__ENUM_IIFE__
  var Quan_ModelResignedStaff_Type;

  (function (Quan_ModelResignedStaff_Type) {
    Quan_ModelResignedStaff_Type[Quan_ModelResignedStaff_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ModelResignedStaff_Type[Quan_ModelResignedStaff_Type["TypeScrm"] = 1] = "TypeScrm";
    Quan_ModelResignedStaff_Type[Quan_ModelResignedStaff_Type["TypeQrobot"] = 2] = "TypeQrobot";
  })(Quan_ModelResignedStaff_Type || (Quan_ModelResignedStaff_Type = {}));

  return Quan_ModelResignedStaff_Type;
}();
export var Quan_ModelResignedStaff_State = function () {
  //__ENUM_IIFE__
  var Quan_ModelResignedStaff_State;

  (function (Quan_ModelResignedStaff_State) {
    Quan_ModelResignedStaff_State[Quan_ModelResignedStaff_State["StateNil"] = 0] = "StateNil";
    Quan_ModelResignedStaff_State[Quan_ModelResignedStaff_State["StateUndistributed"] = 1] = "StateUndistributed";
    Quan_ModelResignedStaff_State[Quan_ModelResignedStaff_State["StateAssigned"] = 2] = "StateAssigned";
    Quan_ModelResignedStaff_State[Quan_ModelResignedStaff_State["StateDistributing"] = 3] = "StateDistributing";
  })(Quan_ModelResignedStaff_State || (Quan_ModelResignedStaff_State = {}));

  return Quan_ModelResignedStaff_State;
}();
export var Quan_ModelResignedStaffExtContact_HandoverState = function () {
  //__ENUM_IIFE__
  var Quan_ModelResignedStaffExtContact_HandoverState;

  (function (Quan_ModelResignedStaffExtContact_HandoverState) {
    Quan_ModelResignedStaffExtContact_HandoverState[Quan_ModelResignedStaffExtContact_HandoverState["HandoverStateNil"] = 0] = "HandoverStateNil";
    Quan_ModelResignedStaffExtContact_HandoverState[Quan_ModelResignedStaffExtContact_HandoverState["HandoverStateWaitHandover"] = 1] = "HandoverStateWaitHandover";
    Quan_ModelResignedStaffExtContact_HandoverState[Quan_ModelResignedStaffExtContact_HandoverState["HandoverStateHandoverCompleted"] = 2] = "HandoverStateHandoverCompleted";
    Quan_ModelResignedStaffExtContact_HandoverState[Quan_ModelResignedStaffExtContact_HandoverState["HandoverStateCustomeRejected"] = 3] = "HandoverStateCustomeRejected";
    Quan_ModelResignedStaffExtContact_HandoverState[Quan_ModelResignedStaffExtContact_HandoverState["HandoverStateMaximumLimit"] = 4] = "HandoverStateMaximumLimit";
    Quan_ModelResignedStaffExtContact_HandoverState[Quan_ModelResignedStaffExtContact_HandoverState["HandoverStateNoReplacementRecord"] = 5] = "HandoverStateNoReplacementRecord";
    Quan_ModelResignedStaffExtContact_HandoverState[Quan_ModelResignedStaffExtContact_HandoverState["HandoverStateHandOverFail"] = 6] = "HandoverStateHandOverFail";
  })(Quan_ModelResignedStaffExtContact_HandoverState || (Quan_ModelResignedStaffExtContact_HandoverState = {}));

  return Quan_ModelResignedStaffExtContact_HandoverState;
}();
export var Quan_ModelResignedStaffGroupChat_HandoverState = function () {
  //__ENUM_IIFE__
  var Quan_ModelResignedStaffGroupChat_HandoverState;

  (function (Quan_ModelResignedStaffGroupChat_HandoverState) {
    Quan_ModelResignedStaffGroupChat_HandoverState[Quan_ModelResignedStaffGroupChat_HandoverState["HandoverStateNil"] = 0] = "HandoverStateNil";
    Quan_ModelResignedStaffGroupChat_HandoverState[Quan_ModelResignedStaffGroupChat_HandoverState["HandoverStateHandoverCompleted"] = 1] = "HandoverStateHandoverCompleted";
    Quan_ModelResignedStaffGroupChat_HandoverState[Quan_ModelResignedStaffGroupChat_HandoverState["HandoverStateHandoverFailed"] = 2] = "HandoverStateHandoverFailed";
  })(Quan_ModelResignedStaffGroupChat_HandoverState || (Quan_ModelResignedStaffGroupChat_HandoverState = {}));

  return Quan_ModelResignedStaffGroupChat_HandoverState;
}();
export var Quan_GetExtContactDetailStatReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactDetailStatReq_ListOption;

  (function (Quan_GetExtContactDetailStatReq_ListOption) {
    Quan_GetExtContactDetailStatReq_ListOption[Quan_GetExtContactDetailStatReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactDetailStatReq_ListOption[Quan_GetExtContactDetailStatReq_ListOption["ListOptionUidList"] = 1] = "ListOptionUidList";
    Quan_GetExtContactDetailStatReq_ListOption[Quan_GetExtContactDetailStatReq_ListOption["ListOptionFilterType"] = 4] = "ListOptionFilterType";
  })(Quan_GetExtContactDetailStatReq_ListOption || (Quan_GetExtContactDetailStatReq_ListOption = {}));

  return Quan_GetExtContactDetailStatReq_ListOption;
}();
export var Quan_PayOrderReq_PayChannel = function () {
  //__ENUM_IIFE__
  var Quan_PayOrderReq_PayChannel;

  (function (Quan_PayOrderReq_PayChannel) {
    Quan_PayOrderReq_PayChannel[Quan_PayOrderReq_PayChannel["PayChannelNil"] = 0] = "PayChannelNil";
    Quan_PayOrderReq_PayChannel[Quan_PayOrderReq_PayChannel["PayChannelAlipay"] = 3] = "PayChannelAlipay";
  })(Quan_PayOrderReq_PayChannel || (Quan_PayOrderReq_PayChannel = {}));

  return Quan_PayOrderReq_PayChannel;
}();
export var Quan_GetOrderListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetOrderListReq_ListOption;

  (function (Quan_GetOrderListReq_ListOption) {
    Quan_GetOrderListReq_ListOption[Quan_GetOrderListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetOrderListReq_ListOption[Quan_GetOrderListReq_ListOption["ListOptionOrderType"] = 1] = "ListOptionOrderType";
    Quan_GetOrderListReq_ListOption[Quan_GetOrderListReq_ListOption["ListOptionState"] = 2] = "ListOptionState";
    Quan_GetOrderListReq_ListOption[Quan_GetOrderListReq_ListOption["ListOptionCreateAt"] = 3] = "ListOptionCreateAt";
    Quan_GetOrderListReq_ListOption[Quan_GetOrderListReq_ListOption["ListOptionHasInvoiced"] = 4] = "ListOptionHasInvoiced";
  })(Quan_GetOrderListReq_ListOption || (Quan_GetOrderListReq_ListOption = {}));

  return Quan_GetOrderListReq_ListOption;
}();
export var Quan_GetOrderListStaffReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetOrderListStaffReq_ListOption;

  (function (Quan_GetOrderListStaffReq_ListOption) {
    Quan_GetOrderListStaffReq_ListOption[Quan_GetOrderListStaffReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetOrderListStaffReq_ListOption[Quan_GetOrderListStaffReq_ListOption["ListOptionId"] = 1] = "ListOptionId";
  })(Quan_GetOrderListStaffReq_ListOption || (Quan_GetOrderListStaffReq_ListOption = {}));

  return Quan_GetOrderListStaffReq_ListOption;
}();
export var Quan_SetInvoiceReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_SetInvoiceReq_Type;

  (function (Quan_SetInvoiceReq_Type) {
    Quan_SetInvoiceReq_Type[Quan_SetInvoiceReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_SetInvoiceReq_Type[Quan_SetInvoiceReq_Type["TypeCancel"] = 1] = "TypeCancel";
  })(Quan_SetInvoiceReq_Type || (Quan_SetInvoiceReq_Type = {}));

  return Quan_SetInvoiceReq_Type;
}();
export var Quan_GetInvoiceListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetInvoiceListReq_ListOption;

  (function (Quan_GetInvoiceListReq_ListOption) {
    Quan_GetInvoiceListReq_ListOption[Quan_GetInvoiceListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetInvoiceListReq_ListOption[Quan_GetInvoiceListReq_ListOption["ListOptionInvoiceType"] = 1] = "ListOptionInvoiceType";
    Quan_GetInvoiceListReq_ListOption[Quan_GetInvoiceListReq_ListOption["ListOptionState"] = 2] = "ListOptionState";
    Quan_GetInvoiceListReq_ListOption[Quan_GetInvoiceListReq_ListOption["ListOptionCreatedAt"] = 3] = "ListOptionCreatedAt";
  })(Quan_GetInvoiceListReq_ListOption || (Quan_GetInvoiceListReq_ListOption = {}));

  return Quan_GetInvoiceListReq_ListOption;
}();
export var Quan_GetInvoiceListStaffReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetInvoiceListStaffReq_ListOption;

  (function (Quan_GetInvoiceListStaffReq_ListOption) {
    Quan_GetInvoiceListStaffReq_ListOption[Quan_GetInvoiceListStaffReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetInvoiceListStaffReq_ListOption[Quan_GetInvoiceListStaffReq_ListOption["ListOptionContactPhone"] = 1] = "ListOptionContactPhone";
    Quan_GetInvoiceListStaffReq_ListOption[Quan_GetInvoiceListStaffReq_ListOption["ListOptionState"] = 2] = "ListOptionState";
    Quan_GetInvoiceListStaffReq_ListOption[Quan_GetInvoiceListStaffReq_ListOption["ListOptionCreatedAt"] = 3] = "ListOptionCreatedAt";
  })(Quan_GetInvoiceListStaffReq_ListOption || (Quan_GetInvoiceListStaffReq_ListOption = {}));

  return Quan_GetInvoiceListStaffReq_ListOption;
}();
export var Quan_SetInvoiceStaffReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_SetInvoiceStaffReq_Type;

  (function (Quan_SetInvoiceStaffReq_Type) {
    Quan_SetInvoiceStaffReq_Type[Quan_SetInvoiceStaffReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_SetInvoiceStaffReq_Type[Quan_SetInvoiceStaffReq_Type["TypeAudit"] = 1] = "TypeAudit";
    Quan_SetInvoiceStaffReq_Type[Quan_SetInvoiceStaffReq_Type["TypeIssuedInvoice"] = 2] = "TypeIssuedInvoice";
    Quan_SetInvoiceStaffReq_Type[Quan_SetInvoiceStaffReq_Type["TypeShippedInvoice"] = 3] = "TypeShippedInvoice";
    Quan_SetInvoiceStaffReq_Type[Quan_SetInvoiceStaffReq_Type["TypeChangeInfo"] = 4] = "TypeChangeInfo";
  })(Quan_SetInvoiceStaffReq_Type || (Quan_SetInvoiceStaffReq_Type = {}));

  return Quan_SetInvoiceStaffReq_Type;
}();
export var Quan_GetSpeechcraftCategoryListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetSpeechcraftCategoryListReq_ListOption;

  (function (Quan_GetSpeechcraftCategoryListReq_ListOption) {
    Quan_GetSpeechcraftCategoryListReq_ListOption[Quan_GetSpeechcraftCategoryListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetSpeechcraftCategoryListReq_ListOption[Quan_GetSpeechcraftCategoryListReq_ListOption["ListOptionIsPersonal"] = 1] = "ListOptionIsPersonal";
    Quan_GetSpeechcraftCategoryListReq_ListOption[Quan_GetSpeechcraftCategoryListReq_ListOption["ListOptionWithSoftDeleted"] = 2] = "ListOptionWithSoftDeleted";
  })(Quan_GetSpeechcraftCategoryListReq_ListOption || (Quan_GetSpeechcraftCategoryListReq_ListOption = {}));

  return Quan_GetSpeechcraftCategoryListReq_ListOption;
}();
export var Quan_MockWxDeptAndUserListStateRsp_State = function () {
  //__ENUM_IIFE__
  var Quan_MockWxDeptAndUserListStateRsp_State;

  (function (Quan_MockWxDeptAndUserListStateRsp_State) {
    Quan_MockWxDeptAndUserListStateRsp_State[Quan_MockWxDeptAndUserListStateRsp_State["StateNil"] = 0] = "StateNil";
    Quan_MockWxDeptAndUserListStateRsp_State[Quan_MockWxDeptAndUserListStateRsp_State["StateInProgress"] = 1] = "StateInProgress";
    Quan_MockWxDeptAndUserListStateRsp_State[Quan_MockWxDeptAndUserListStateRsp_State["StateSuccess"] = 2] = "StateSuccess";
    Quan_MockWxDeptAndUserListStateRsp_State[Quan_MockWxDeptAndUserListStateRsp_State["StateFailure"] = 3] = "StateFailure";
  })(Quan_MockWxDeptAndUserListStateRsp_State || (Quan_MockWxDeptAndUserListStateRsp_State = {}));

  return Quan_MockWxDeptAndUserListStateRsp_State;
}();
export var Quan_GetCorpListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetCorpListReq_ListOption;

  (function (Quan_GetCorpListReq_ListOption) {
    Quan_GetCorpListReq_ListOption[Quan_GetCorpListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetCorpListReq_ListOption[Quan_GetCorpListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetCorpListReq_ListOption[Quan_GetCorpListReq_ListOption["ListOptionWwCorpId"] = 2] = "ListOptionWwCorpId";
    Quan_GetCorpListReq_ListOption[Quan_GetCorpListReq_ListOption["ListOptionWwInnerCorpId"] = 3] = "ListOptionWwInnerCorpId";
    Quan_GetCorpListReq_ListOption[Quan_GetCorpListReq_ListOption["ListOptionCorpId"] = 4] = "ListOptionCorpId";
    Quan_GetCorpListReq_ListOption[Quan_GetCorpListReq_ListOption["ListOptionCorpIdList"] = 5] = "ListOptionCorpIdList";
    Quan_GetCorpListReq_ListOption[Quan_GetCorpListReq_ListOption["ListOptionCreatedAtRange"] = 6] = "ListOptionCreatedAtRange";
  })(Quan_GetCorpListReq_ListOption || (Quan_GetCorpListReq_ListOption = {}));

  return Quan_GetCorpListReq_ListOption;
}();
export var Quan_SortSpeechcraftReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_SortSpeechcraftReq_Type;

  (function (Quan_SortSpeechcraftReq_Type) {
    Quan_SortSpeechcraftReq_Type[Quan_SortSpeechcraftReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_SortSpeechcraftReq_Type[Quan_SortSpeechcraftReq_Type["TypeUp"] = 1] = "TypeUp";
    Quan_SortSpeechcraftReq_Type[Quan_SortSpeechcraftReq_Type["TypeDown"] = 2] = "TypeDown";
    Quan_SortSpeechcraftReq_Type[Quan_SortSpeechcraftReq_Type["TypeUpper"] = 3] = "TypeUpper";
  })(Quan_SortSpeechcraftReq_Type || (Quan_SortSpeechcraftReq_Type = {}));

  return Quan_SortSpeechcraftReq_Type;
}();
export var Quan_GetCorpVersionListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetCorpVersionListReq_ListOption;

  (function (Quan_GetCorpVersionListReq_ListOption) {
    Quan_GetCorpVersionListReq_ListOption[Quan_GetCorpVersionListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetCorpVersionListReq_ListOption[Quan_GetCorpVersionListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetCorpVersionListReq_ListOption[Quan_GetCorpVersionListReq_ListOption["ListOptionSpuId"] = 2] = "ListOptionSpuId";
    Quan_GetCorpVersionListReq_ListOption[Quan_GetCorpVersionListReq_ListOption["ListOptionExpiredTime"] = 3] = "ListOptionExpiredTime";
    Quan_GetCorpVersionListReq_ListOption[Quan_GetCorpVersionListReq_ListOption["ListOptionIsExpired"] = 4] = "ListOptionIsExpired";
    Quan_GetCorpVersionListReq_ListOption[Quan_GetCorpVersionListReq_ListOption["ListOptionTrialOpenAt"] = 5] = "ListOptionTrialOpenAt";
    Quan_GetCorpVersionListReq_ListOption[Quan_GetCorpVersionListReq_ListOption["ListOptionAdvanceOpenAt"] = 6] = "ListOptionAdvanceOpenAt";
    Quan_GetCorpVersionListReq_ListOption[Quan_GetCorpVersionListReq_ListOption["ListOptionCreatedAt"] = 7] = "ListOptionCreatedAt";
  })(Quan_GetCorpVersionListReq_ListOption || (Quan_GetCorpVersionListReq_ListOption = {}));

  return Quan_GetCorpVersionListReq_ListOption;
}();
export var Quan_GetResignedStaffListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetResignedStaffListReq_ListOption;

  (function (Quan_GetResignedStaffListReq_ListOption) {
    Quan_GetResignedStaffListReq_ListOption[Quan_GetResignedStaffListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetResignedStaffListReq_ListOption[Quan_GetResignedStaffListReq_ListOption["ListOptionStaffName"] = 1] = "ListOptionStaffName";
    Quan_GetResignedStaffListReq_ListOption[Quan_GetResignedStaffListReq_ListOption["ListOptionType"] = 2] = "ListOptionType";
    Quan_GetResignedStaffListReq_ListOption[Quan_GetResignedStaffListReq_ListOption["ListOptionLeaveAt"] = 3] = "ListOptionLeaveAt";
    Quan_GetResignedStaffListReq_ListOption[Quan_GetResignedStaffListReq_ListOption["ListOptionState"] = 4] = "ListOptionState";
  })(Quan_GetResignedStaffListReq_ListOption || (Quan_GetResignedStaffListReq_ListOption = {}));

  return Quan_GetResignedStaffListReq_ListOption;
}();
export var Quan_GetResignedStaffExtContactListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetResignedStaffExtContactListReq_ListOption;

  (function (Quan_GetResignedStaffExtContactListReq_ListOption) {
    Quan_GetResignedStaffExtContactListReq_ListOption[Quan_GetResignedStaffExtContactListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetResignedStaffExtContactListReq_ListOption[Quan_GetResignedStaffExtContactListReq_ListOption["ListOptionState"] = 1] = "ListOptionState";
    Quan_GetResignedStaffExtContactListReq_ListOption[Quan_GetResignedStaffExtContactListReq_ListOption["ListOptionStaffUid"] = 2] = "ListOptionStaffUid";
    Quan_GetResignedStaffExtContactListReq_ListOption[Quan_GetResignedStaffExtContactListReq_ListOption["ListOptionStaffId"] = 3] = "ListOptionStaffId";
    Quan_GetResignedStaffExtContactListReq_ListOption[Quan_GetResignedStaffExtContactListReq_ListOption["ListOptionName"] = 4] = "ListOptionName";
  })(Quan_GetResignedStaffExtContactListReq_ListOption || (Quan_GetResignedStaffExtContactListReq_ListOption = {}));

  return Quan_GetResignedStaffExtContactListReq_ListOption;
}();
export var Quan_GetResignedStaffGroupChatListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetResignedStaffGroupChatListReq_ListOption;

  (function (Quan_GetResignedStaffGroupChatListReq_ListOption) {
    Quan_GetResignedStaffGroupChatListReq_ListOption[Quan_GetResignedStaffGroupChatListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetResignedStaffGroupChatListReq_ListOption[Quan_GetResignedStaffGroupChatListReq_ListOption["ListOptionType"] = 1] = "ListOptionType";
    Quan_GetResignedStaffGroupChatListReq_ListOption[Quan_GetResignedStaffGroupChatListReq_ListOption["ListOptionOwnerUid"] = 2] = "ListOptionOwnerUid";
    Quan_GetResignedStaffGroupChatListReq_ListOption[Quan_GetResignedStaffGroupChatListReq_ListOption["ListOptionStaffId"] = 3] = "ListOptionStaffId";
    Quan_GetResignedStaffGroupChatListReq_ListOption[Quan_GetResignedStaffGroupChatListReq_ListOption["ListOptionName"] = 4] = "ListOptionName";
  })(Quan_GetResignedStaffGroupChatListReq_ListOption || (Quan_GetResignedStaffGroupChatListReq_ListOption = {}));

  return Quan_GetResignedStaffGroupChatListReq_ListOption;
}();
export var Quan_GetWwAdminLoginStateRsp_TenantScanState = function () {
  //__ENUM_IIFE__
  var Quan_GetWwAdminLoginStateRsp_TenantScanState;

  (function (Quan_GetWwAdminLoginStateRsp_TenantScanState) {
    Quan_GetWwAdminLoginStateRsp_TenantScanState[Quan_GetWwAdminLoginStateRsp_TenantScanState["TenantScanStateNil"] = 0] = "TenantScanStateNil";
    Quan_GetWwAdminLoginStateRsp_TenantScanState[Quan_GetWwAdminLoginStateRsp_TenantScanState["TenantScanStateScanning"] = 1] = "TenantScanStateScanning";
    Quan_GetWwAdminLoginStateRsp_TenantScanState[Quan_GetWwAdminLoginStateRsp_TenantScanState["TenantScanStateFinished"] = 2] = "TenantScanStateFinished";
  })(Quan_GetWwAdminLoginStateRsp_TenantScanState || (Quan_GetWwAdminLoginStateRsp_TenantScanState = {}));

  return Quan_GetWwAdminLoginStateRsp_TenantScanState;
}();
export var Quan_GetGroupChatListSysReq_IsMatch = function () {
  //__ENUM_IIFE__
  var Quan_GetGroupChatListSysReq_IsMatch;

  (function (Quan_GetGroupChatListSysReq_IsMatch) {
    Quan_GetGroupChatListSysReq_IsMatch[Quan_GetGroupChatListSysReq_IsMatch["IsMatchNil"] = 0] = "IsMatchNil";
    Quan_GetGroupChatListSysReq_IsMatch[Quan_GetGroupChatListSysReq_IsMatch["IsMatched"] = 1] = "IsMatched";
    Quan_GetGroupChatListSysReq_IsMatch[Quan_GetGroupChatListSysReq_IsMatch["IsMatchNot"] = 2] = "IsMatchNot";
  })(Quan_GetGroupChatListSysReq_IsMatch || (Quan_GetGroupChatListSysReq_IsMatch = {}));

  return Quan_GetGroupChatListSysReq_IsMatch;
}();
export var Quan_GetGroupChatListSysReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetGroupChatListSysReq_ListOption;

  (function (Quan_GetGroupChatListSysReq_ListOption) {
    Quan_GetGroupChatListSysReq_ListOption[Quan_GetGroupChatListSysReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetGroupChatListSysReq_ListOption[Quan_GetGroupChatListSysReq_ListOption["ListOptionId"] = 1] = "ListOptionId";
    Quan_GetGroupChatListSysReq_ListOption[Quan_GetGroupChatListSysReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
    Quan_GetGroupChatListSysReq_ListOption[Quan_GetGroupChatListSysReq_ListOption["ListOptionIsMatch"] = 3] = "ListOptionIsMatch";
    Quan_GetGroupChatListSysReq_ListOption[Quan_GetGroupChatListSysReq_ListOption["ListOptionOwnerUid"] = 4] = "ListOptionOwnerUid";
    Quan_GetGroupChatListSysReq_ListOption[Quan_GetGroupChatListSysReq_ListOption["ListOptionNames"] = 5] = "ListOptionNames";
  })(Quan_GetGroupChatListSysReq_ListOption || (Quan_GetGroupChatListSysReq_ListOption = {}));

  return Quan_GetGroupChatListSysReq_ListOption;
}();
export var Quan_GetRobotStaffListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetRobotStaffListReq_ListOption;

  (function (Quan_GetRobotStaffListReq_ListOption) {
    Quan_GetRobotStaffListReq_ListOption[Quan_GetRobotStaffListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetRobotStaffListReq_ListOption[Quan_GetRobotStaffListReq_ListOption["ListOptionWwUserName"] = 1] = "ListOptionWwUserName";
  })(Quan_GetRobotStaffListReq_ListOption || (Quan_GetRobotStaffListReq_ListOption = {}));

  return Quan_GetRobotStaffListReq_ListOption;
}();
export var Quan_UserUpdatedMqMsg_UpdateSource = function () {
  //__ENUM_IIFE__
  var Quan_UserUpdatedMqMsg_UpdateSource;

  (function (Quan_UserUpdatedMqMsg_UpdateSource) {
    Quan_UserUpdatedMqMsg_UpdateSource[Quan_UserUpdatedMqMsg_UpdateSource["UpdateSourceNil"] = 0] = "UpdateSourceNil";
    Quan_UserUpdatedMqMsg_UpdateSource[Quan_UserUpdatedMqMsg_UpdateSource["UpdateSourceWeworkApp"] = 1] = "UpdateSourceWeworkApp";
    Quan_UserUpdatedMqMsg_UpdateSource[Quan_UserUpdatedMqMsg_UpdateSource["UpdateSourceWeworkAuthApp"] = 2] = "UpdateSourceWeworkAuthApp";
  })(Quan_UserUpdatedMqMsg_UpdateSource || (Quan_UserUpdatedMqMsg_UpdateSource = {}));

  return Quan_UserUpdatedMqMsg_UpdateSource;
}();
export var Quan_PartyUpdatedMqMsg_UpdateSource = function () {
  //__ENUM_IIFE__
  var Quan_PartyUpdatedMqMsg_UpdateSource;

  (function (Quan_PartyUpdatedMqMsg_UpdateSource) {
    Quan_PartyUpdatedMqMsg_UpdateSource[Quan_PartyUpdatedMqMsg_UpdateSource["UpdateSourceNil"] = 0] = "UpdateSourceNil";
    Quan_PartyUpdatedMqMsg_UpdateSource[Quan_PartyUpdatedMqMsg_UpdateSource["UpdateSourceWeworkApp"] = 1] = "UpdateSourceWeworkApp";
    Quan_PartyUpdatedMqMsg_UpdateSource[Quan_PartyUpdatedMqMsg_UpdateSource["UpdateSourceWeworkAuthApp"] = 2] = "UpdateSourceWeworkAuthApp";
  })(Quan_PartyUpdatedMqMsg_UpdateSource || (Quan_PartyUpdatedMqMsg_UpdateSource = {}));

  return Quan_PartyUpdatedMqMsg_UpdateSource;
}();
export var Quan_GetMiniProgramListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMiniProgramListReq_ListOption;

  (function (Quan_GetMiniProgramListReq_ListOption) {
    Quan_GetMiniProgramListReq_ListOption[Quan_GetMiniProgramListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMiniProgramListReq_ListOption[Quan_GetMiniProgramListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
  })(Quan_GetMiniProgramListReq_ListOption || (Quan_GetMiniProgramListReq_ListOption = {}));

  return Quan_GetMiniProgramListReq_ListOption;
}();
export var Quan_AddYcMiniProgramSysReq_UserType = function () {
  //__ENUM_IIFE__
  var Quan_AddYcMiniProgramSysReq_UserType;

  (function (Quan_AddYcMiniProgramSysReq_UserType) {
    Quan_AddYcMiniProgramSysReq_UserType[Quan_AddYcMiniProgramSysReq_UserType["UserTypeNil"] = 0] = "UserTypeNil";
    Quan_AddYcMiniProgramSysReq_UserType[Quan_AddYcMiniProgramSysReq_UserType["UserTypeQwhale"] = 1] = "UserTypeQwhale";
  })(Quan_AddYcMiniProgramSysReq_UserType || (Quan_AddYcMiniProgramSysReq_UserType = {}));

  return Quan_AddYcMiniProgramSysReq_UserType;
}();
export var Quan_GetMessageAuditorConfigListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMessageAuditorConfigListReq_ListOption;

  (function (Quan_GetMessageAuditorConfigListReq_ListOption) {
    Quan_GetMessageAuditorConfigListReq_ListOption[Quan_GetMessageAuditorConfigListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMessageAuditorConfigListReq_ListOption[Quan_GetMessageAuditorConfigListReq_ListOption["ListOptionAuditorName"] = 1] = "ListOptionAuditorName";
  })(Quan_GetMessageAuditorConfigListReq_ListOption || (Quan_GetMessageAuditorConfigListReq_ListOption = {}));

  return Quan_GetMessageAuditorConfigListReq_ListOption;
}();
export var Quan_GetMessageAuditListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMessageAuditListReq_ListOption;

  (function (Quan_GetMessageAuditListReq_ListOption) {
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionTitle"] = 1] = "ListOptionTitle";
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionSubType"] = 2] = "ListOptionSubType";
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionState"] = 3] = "ListOptionState";
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionCreatorUid"] = 4] = "ListOptionCreatorUid";
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionAuditorUid"] = 5] = "ListOptionAuditorUid";
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionType"] = 6] = "ListOptionType";
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionPlanExecAtAsc"] = 7] = "ListOptionPlanExecAtAsc";
    Quan_GetMessageAuditListReq_ListOption[Quan_GetMessageAuditListReq_ListOption["ListOptionCreatedAtAsc"] = 8] = "ListOptionCreatedAtAsc";
  })(Quan_GetMessageAuditListReq_ListOption || (Quan_GetMessageAuditListReq_ListOption = {}));

  return Quan_GetMessageAuditListReq_ListOption;
}();
export var Quan_GetRoleListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetRoleListReq_ListOption;

  (function (Quan_GetRoleListReq_ListOption) {
    Quan_GetRoleListReq_ListOption[Quan_GetRoleListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetRoleListReq_ListOption[Quan_GetRoleListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetRoleListReq_ListOption[Quan_GetRoleListReq_ListOption["ListOptionIncludeCreator"] = 2] = "ListOptionIncludeCreator";
    Quan_GetRoleListReq_ListOption[Quan_GetRoleListReq_ListOption["ListOptionType"] = 3] = "ListOptionType";
  })(Quan_GetRoleListReq_ListOption || (Quan_GetRoleListReq_ListOption = {}));

  return Quan_GetRoleListReq_ListOption;
}();
export var Quan_GetPermissionListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetPermissionListReq_ListOption;

  (function (Quan_GetPermissionListReq_ListOption) {
    Quan_GetPermissionListReq_ListOption[Quan_GetPermissionListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetPermissionListReq_ListOption[Quan_GetPermissionListReq_ListOption["ListOptionServiceType"] = 1] = "ListOptionServiceType";
  })(Quan_GetPermissionListReq_ListOption || (Quan_GetPermissionListReq_ListOption = {}));

  return Quan_GetPermissionListReq_ListOption;
}();
export var Quan_GetWechatListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetWechatListReq_ListOption;

  (function (Quan_GetWechatListReq_ListOption) {
    Quan_GetWechatListReq_ListOption[Quan_GetWechatListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetWechatListReq_ListOption[Quan_GetWechatListReq_ListOption["ListOptionCorpId"] = 1] = "ListOptionCorpId";
    Quan_GetWechatListReq_ListOption[Quan_GetWechatListReq_ListOption["ListOptionAppId"] = 2] = "ListOptionAppId";
    Quan_GetWechatListReq_ListOption[Quan_GetWechatListReq_ListOption["ListOptionPayConfigIdList"] = 3] = "ListOptionPayConfigIdList";
    Quan_GetWechatListReq_ListOption[Quan_GetWechatListReq_ListOption["ListOptionAppType"] = 4] = "ListOptionAppType";
  })(Quan_GetWechatListReq_ListOption || (Quan_GetWechatListReq_ListOption = {}));

  return Quan_GetWechatListReq_ListOption;
}();
export var Quan_BatchSetCorpTag2AllFollowReq_ActionType = function () {
  //__ENUM_IIFE__
  var Quan_BatchSetCorpTag2AllFollowReq_ActionType;

  (function (Quan_BatchSetCorpTag2AllFollowReq_ActionType) {
    Quan_BatchSetCorpTag2AllFollowReq_ActionType[Quan_BatchSetCorpTag2AllFollowReq_ActionType["ActionTypeAddTag"] = 0] = "ActionTypeAddTag";
    Quan_BatchSetCorpTag2AllFollowReq_ActionType[Quan_BatchSetCorpTag2AllFollowReq_ActionType["ActionTypeDelTag"] = 1] = "ActionTypeDelTag";
  })(Quan_BatchSetCorpTag2AllFollowReq_ActionType || (Quan_BatchSetCorpTag2AllFollowReq_ActionType = {}));

  return Quan_BatchSetCorpTag2AllFollowReq_ActionType;
}();
export var Quan_GetBaseAccountInfoRsp_AccountVersion = function () {
  //__ENUM_IIFE__
  var Quan_GetBaseAccountInfoRsp_AccountVersion;

  (function (Quan_GetBaseAccountInfoRsp_AccountVersion) {
    Quan_GetBaseAccountInfoRsp_AccountVersion[Quan_GetBaseAccountInfoRsp_AccountVersion["AccountVersionNil"] = 0] = "AccountVersionNil";
    Quan_GetBaseAccountInfoRsp_AccountVersion[Quan_GetBaseAccountInfoRsp_AccountVersion["AccountVersionV1"] = 1] = "AccountVersionV1";
    Quan_GetBaseAccountInfoRsp_AccountVersion[Quan_GetBaseAccountInfoRsp_AccountVersion["AccountVersionV2"] = 2] = "AccountVersionV2";
  })(Quan_GetBaseAccountInfoRsp_AccountVersion || (Quan_GetBaseAccountInfoRsp_AccountVersion = {}));

  return Quan_GetBaseAccountInfoRsp_AccountVersion;
}();
export var Quan_GetWxAdminLoginStateV2Rsp_ScanStatus = function () {
  //__ENUM_IIFE__
  var Quan_GetWxAdminLoginStateV2Rsp_ScanStatus;

  (function (Quan_GetWxAdminLoginStateV2Rsp_ScanStatus) {
    Quan_GetWxAdminLoginStateV2Rsp_ScanStatus[Quan_GetWxAdminLoginStateV2Rsp_ScanStatus["ScanStatusNil"] = 0] = "ScanStatusNil";
    Quan_GetWxAdminLoginStateV2Rsp_ScanStatus[Quan_GetWxAdminLoginStateV2Rsp_ScanStatus["ScanStatusScanning"] = 1] = "ScanStatusScanning";
    Quan_GetWxAdminLoginStateV2Rsp_ScanStatus[Quan_GetWxAdminLoginStateV2Rsp_ScanStatus["ScanStatusSuccess"] = 2] = "ScanStatusSuccess";
  })(Quan_GetWxAdminLoginStateV2Rsp_ScanStatus || (Quan_GetWxAdminLoginStateV2Rsp_ScanStatus = {}));

  return Quan_GetWxAdminLoginStateV2Rsp_ScanStatus;
}();
export var Quan_GetCorpDeptListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetCorpDeptListReq_ListOption;

  (function (Quan_GetCorpDeptListReq_ListOption) {
    Quan_GetCorpDeptListReq_ListOption[Quan_GetCorpDeptListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetCorpDeptListReq_ListOption[Quan_GetCorpDeptListReq_ListOption["ListOptionWwDeptParentId"] = 1] = "ListOptionWwDeptParentId";
    Quan_GetCorpDeptListReq_ListOption[Quan_GetCorpDeptListReq_ListOption["ListOptionDeptName"] = 2] = "ListOptionDeptName";
  })(Quan_GetCorpDeptListReq_ListOption || (Quan_GetCorpDeptListReq_ListOption = {}));

  return Quan_GetCorpDeptListReq_ListOption;
}();
export var Quan_GetMenuListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMenuListReq_ListOption;

  (function (Quan_GetMenuListReq_ListOption) {
    Quan_GetMenuListReq_ListOption[Quan_GetMenuListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMenuListReq_ListOption[Quan_GetMenuListReq_ListOption["ListOptionAppType"] = 1] = "ListOptionAppType";
  })(Quan_GetMenuListReq_ListOption || (Quan_GetMenuListReq_ListOption = {}));

  return Quan_GetMenuListReq_ListOption;
}();
export var Quan_GetAccountListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetAccountListReq_ListOption;

  (function (Quan_GetAccountListReq_ListOption) {
    Quan_GetAccountListReq_ListOption[Quan_GetAccountListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetAccountListReq_ListOption[Quan_GetAccountListReq_ListOption["ListOptionCompanyName"] = 1] = "ListOptionCompanyName";
    Quan_GetAccountListReq_ListOption[Quan_GetAccountListReq_ListOption["ListOptionPhone"] = 2] = "ListOptionPhone";
    Quan_GetAccountListReq_ListOption[Quan_GetAccountListReq_ListOption["ListOptionRemark"] = 3] = "ListOptionRemark";
    Quan_GetAccountListReq_ListOption[Quan_GetAccountListReq_ListOption["ListOptionRegisteredDevice"] = 4] = "ListOptionRegisteredDevice";
    Quan_GetAccountListReq_ListOption[Quan_GetAccountListReq_ListOption["ListOptionOperatingSystem"] = 5] = "ListOptionOperatingSystem";
    Quan_GetAccountListReq_ListOption[Quan_GetAccountListReq_ListOption["ListOptionRegSource"] = 6] = "ListOptionRegSource";
    Quan_GetAccountListReq_ListOption[Quan_GetAccountListReq_ListOption["ListOptionAdParams"] = 7] = "ListOptionAdParams";
  })(Quan_GetAccountListReq_ListOption || (Quan_GetAccountListReq_ListOption = {}));

  return Quan_GetAccountListReq_ListOption;
}();
export var Quan_GetImportRecordListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetImportRecordListReq_ListOption;

  (function (Quan_GetImportRecordListReq_ListOption) {
    Quan_GetImportRecordListReq_ListOption[Quan_GetImportRecordListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetImportRecordListReq_ListOption[Quan_GetImportRecordListReq_ListOption["ListOptionTypeList"] = 1] = "ListOptionTypeList";
  })(Quan_GetImportRecordListReq_ListOption || (Quan_GetImportRecordListReq_ListOption = {}));

  return Quan_GetImportRecordListReq_ListOption;
}();
export var Quan_GetCorpGroupNumConfigReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetCorpGroupNumConfigReq_ListOption;

  (function (Quan_GetCorpGroupNumConfigReq_ListOption) {
    Quan_GetCorpGroupNumConfigReq_ListOption[Quan_GetCorpGroupNumConfigReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetCorpGroupNumConfigReq_ListOption[Quan_GetCorpGroupNumConfigReq_ListOption["ListOptionCorpId"] = 1] = "ListOptionCorpId";
    Quan_GetCorpGroupNumConfigReq_ListOption[Quan_GetCorpGroupNumConfigReq_ListOption["ListOptionAppId"] = 2] = "ListOptionAppId";
    Quan_GetCorpGroupNumConfigReq_ListOption[Quan_GetCorpGroupNumConfigReq_ListOption["ListOptionCorpName"] = 3] = "ListOptionCorpName";
  })(Quan_GetCorpGroupNumConfigReq_ListOption || (Quan_GetCorpGroupNumConfigReq_ListOption = {}));

  return Quan_GetCorpGroupNumConfigReq_ListOption;
}();
export var Quan_GetDupExtContactFollowListV2Req_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetDupExtContactFollowListV2Req_ListOption;

  (function (Quan_GetDupExtContactFollowListV2Req_ListOption) {
    Quan_GetDupExtContactFollowListV2Req_ListOption[Quan_GetDupExtContactFollowListV2Req_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetDupExtContactFollowListV2Req_ListOption[Quan_GetDupExtContactFollowListV2Req_ListOption["ListOptionSearchName"] = 1] = "ListOptionSearchName";
  })(Quan_GetDupExtContactFollowListV2Req_ListOption || (Quan_GetDupExtContactFollowListV2Req_ListOption = {}));

  return Quan_GetDupExtContactFollowListV2Req_ListOption;
}(); // @v: required

export var Quan_GetExtContactTransferCustomerRecordListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactTransferCustomerRecordListReq_ListOption;

  (function (Quan_GetExtContactTransferCustomerRecordListReq_ListOption) {
    Quan_GetExtContactTransferCustomerRecordListReq_ListOption[Quan_GetExtContactTransferCustomerRecordListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactTransferCustomerRecordListReq_ListOption[Quan_GetExtContactTransferCustomerRecordListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetExtContactTransferCustomerRecordListReq_ListOption[Quan_GetExtContactTransferCustomerRecordListReq_ListOption["ListOptionStatus"] = 2] = "ListOptionStatus";
    Quan_GetExtContactTransferCustomerRecordListReq_ListOption[Quan_GetExtContactTransferCustomerRecordListReq_ListOption["ListOptionCreatedAt"] = 3] = "ListOptionCreatedAt";
  })(Quan_GetExtContactTransferCustomerRecordListReq_ListOption || (Quan_GetExtContactTransferCustomerRecordListReq_ListOption = {}));

  return Quan_GetExtContactTransferCustomerRecordListReq_ListOption;
}();
export var Quan_GetExtContactFollowListPAccountReq_AccountType = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactFollowListPAccountReq_AccountType;

  (function (Quan_GetExtContactFollowListPAccountReq_AccountType) {
    Quan_GetExtContactFollowListPAccountReq_AccountType[Quan_GetExtContactFollowListPAccountReq_AccountType["AccountTypeNil"] = 0] = "AccountTypeNil";
    Quan_GetExtContactFollowListPAccountReq_AccountType[Quan_GetExtContactFollowListPAccountReq_AccountType["AccountTypeAll"] = 1] = "AccountTypeAll";
    Quan_GetExtContactFollowListPAccountReq_AccountType[Quan_GetExtContactFollowListPAccountReq_AccountType["AccountTypeNormal"] = 2] = "AccountTypeNormal";
    Quan_GetExtContactFollowListPAccountReq_AccountType[Quan_GetExtContactFollowListPAccountReq_AccountType["AccountTypePlatform"] = 3] = "AccountTypePlatform";
  })(Quan_GetExtContactFollowListPAccountReq_AccountType || (Quan_GetExtContactFollowListPAccountReq_AccountType = {}));

  return Quan_GetExtContactFollowListPAccountReq_AccountType;
}();
export var Quan_GetExtContactFollowListPAccountReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactFollowListPAccountReq_ListOption;

  (function (Quan_GetExtContactFollowListPAccountReq_ListOption) {
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionUid"] = 1] = "ListOptionUid";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionSearchName"] = 2] = "ListOptionSearchName";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionGender"] = 3] = "ListOptionGender";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionAddTime"] = 5] = "ListOptionAddTime";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionCorpTag"] = 6] = "ListOptionCorpTag";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionDeletedByStaff"] = 7] = "ListOptionDeletedByStaff";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionDeletedByExtContact"] = 8] = "ListOptionDeletedByExtContact";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionUserDeletedAt"] = 9] = "ListOptionUserDeletedAt";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionChannelId"] = 10] = "ListOptionChannelId";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionRemarkPhone"] = 11] = "ListOptionRemarkPhone";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionUidList"] = 12] = "ListOptionUidList";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionHasYcSerialNo"] = 13] = "ListOptionHasYcSerialNo";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionAccountType"] = 14] = "ListOptionAccountType";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionAddWay"] = 15] = "ListOptionAddWay";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionExtUidList"] = 16] = "ListOptionExtUidList";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionCorpTagIsUnion"] = 17] = "ListOptionCorpTagIsUnion";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionIdList"] = 18] = "ListOptionIdList";
    Quan_GetExtContactFollowListPAccountReq_ListOption[Quan_GetExtContactFollowListPAccountReq_ListOption["ListOptionGroupByExtUid"] = 19] = "ListOptionGroupByExtUid";
  })(Quan_GetExtContactFollowListPAccountReq_ListOption || (Quan_GetExtContactFollowListPAccountReq_ListOption = {}));

  return Quan_GetExtContactFollowListPAccountReq_ListOption;
}();
export var Quan_GetMaterialYcPagePathListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMaterialYcPagePathListReq_ListOption;

  (function (Quan_GetMaterialYcPagePathListReq_ListOption) {
    Quan_GetMaterialYcPagePathListReq_ListOption[Quan_GetMaterialYcPagePathListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMaterialYcPagePathListReq_ListOption[Quan_GetMaterialYcPagePathListReq_ListOption["ListOptionPath"] = 1] = "ListOptionPath";
    Quan_GetMaterialYcPagePathListReq_ListOption[Quan_GetMaterialYcPagePathListReq_ListOption["ListOptionKeyword"] = 2] = "ListOptionKeyword";
    Quan_GetMaterialYcPagePathListReq_ListOption[Quan_GetMaterialYcPagePathListReq_ListOption["ListOptionCreateAt"] = 3] = "ListOptionCreateAt";
    Quan_GetMaterialYcPagePathListReq_ListOption[Quan_GetMaterialYcPagePathListReq_ListOption["ListOptionSenderName"] = 4] = "ListOptionSenderName";
    Quan_GetMaterialYcPagePathListReq_ListOption[Quan_GetMaterialYcPagePathListReq_ListOption["ListOptionRecvName"] = 5] = "ListOptionRecvName";
    Quan_GetMaterialYcPagePathListReq_ListOption[Quan_GetMaterialYcPagePathListReq_ListOption["ListOptionUpdatedAt"] = 6] = "ListOptionUpdatedAt";
    Quan_GetMaterialYcPagePathListReq_ListOption[Quan_GetMaterialYcPagePathListReq_ListOption["ListOptionIds"] = 7] = "ListOptionIds";
  })(Quan_GetMaterialYcPagePathListReq_ListOption || (Quan_GetMaterialYcPagePathListReq_ListOption = {}));

  return Quan_GetMaterialYcPagePathListReq_ListOption;
}();
export var Quan_GetMaterialYcPagePathListSysReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMaterialYcPagePathListSysReq_ListOption;

  (function (Quan_GetMaterialYcPagePathListSysReq_ListOption) {
    Quan_GetMaterialYcPagePathListSysReq_ListOption[Quan_GetMaterialYcPagePathListSysReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMaterialYcPagePathListSysReq_ListOption[Quan_GetMaterialYcPagePathListSysReq_ListOption["ListOptionMaterialIdList"] = 1] = "ListOptionMaterialIdList";
  })(Quan_GetMaterialYcPagePathListSysReq_ListOption || (Quan_GetMaterialYcPagePathListSysReq_ListOption = {}));

  return Quan_GetMaterialYcPagePathListSysReq_ListOption;
}();
export var Quan_GetMiniProgramPagePathListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMiniProgramPagePathListReq_ListOption;

  (function (Quan_GetMiniProgramPagePathListReq_ListOption) {
    Quan_GetMiniProgramPagePathListReq_ListOption[Quan_GetMiniProgramPagePathListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMiniProgramPagePathListReq_ListOption[Quan_GetMiniProgramPagePathListReq_ListOption["ListOptionKeyword"] = 2] = "ListOptionKeyword";
    Quan_GetMiniProgramPagePathListReq_ListOption[Quan_GetMiniProgramPagePathListReq_ListOption["ListOptionCreateAt"] = 3] = "ListOptionCreateAt";
  })(Quan_GetMiniProgramPagePathListReq_ListOption || (Quan_GetMiniProgramPagePathListReq_ListOption = {}));

  return Quan_GetMiniProgramPagePathListReq_ListOption;
}();
export var Quan_GetDeDupChannelLiveCodeListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetDeDupChannelLiveCodeListReq_ListOption;

  (function (Quan_GetDeDupChannelLiveCodeListReq_ListOption) {
    Quan_GetDeDupChannelLiveCodeListReq_ListOption[Quan_GetDeDupChannelLiveCodeListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetDeDupChannelLiveCodeListReq_ListOption[Quan_GetDeDupChannelLiveCodeListReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetDeDupChannelLiveCodeListReq_ListOption[Quan_GetDeDupChannelLiveCodeListReq_ListOption["ListOptionUidList"] = 2] = "ListOptionUidList";
    Quan_GetDeDupChannelLiveCodeListReq_ListOption[Quan_GetDeDupChannelLiveCodeListReq_ListOption["ListOptionChannelIdList"] = 3] = "ListOptionChannelIdList";
    Quan_GetDeDupChannelLiveCodeListReq_ListOption[Quan_GetDeDupChannelLiveCodeListReq_ListOption["ListOptionLiveCodeStateList"] = 4] = "ListOptionLiveCodeStateList";
    Quan_GetDeDupChannelLiveCodeListReq_ListOption[Quan_GetDeDupChannelLiveCodeListReq_ListOption["ListOptionDeDupLiveCodeIdList"] = 5] = "ListOptionDeDupLiveCodeIdList";
    Quan_GetDeDupChannelLiveCodeListReq_ListOption[Quan_GetDeDupChannelLiveCodeListReq_ListOption["ListOptionWithOriginDataMap"] = 6] = "ListOptionWithOriginDataMap";
  })(Quan_GetDeDupChannelLiveCodeListReq_ListOption || (Quan_GetDeDupChannelLiveCodeListReq_ListOption = {}));

  return Quan_GetDeDupChannelLiveCodeListReq_ListOption;
}();
export var Quan_GetCombinedBusinessAppListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetCombinedBusinessAppListOption;

  (function (Quan_GetCombinedBusinessAppListOption) {
    Quan_GetCombinedBusinessAppListOption[Quan_GetCombinedBusinessAppListOption["GetCombinedBusinessAppListNil"] = 0] = "GetCombinedBusinessAppListNil";
    Quan_GetCombinedBusinessAppListOption[Quan_GetCombinedBusinessAppListOption["GetCombinedBusinessAppCode"] = 1] = "GetCombinedBusinessAppCode";
    Quan_GetCombinedBusinessAppListOption[Quan_GetCombinedBusinessAppListOption["GetCombinedBusinessAppName"] = 2] = "GetCombinedBusinessAppName";
    Quan_GetCombinedBusinessAppListOption[Quan_GetCombinedBusinessAppListOption["GetCombinedBusinessCorpId"] = 3] = "GetCombinedBusinessCorpId";
    Quan_GetCombinedBusinessAppListOption[Quan_GetCombinedBusinessAppListOption["GetCombinedBusinessSecretKey"] = 4] = "GetCombinedBusinessSecretKey";
    Quan_GetCombinedBusinessAppListOption[Quan_GetCombinedBusinessAppListOption["GetCombinedBusinessCreatedAtStart"] = 5] = "GetCombinedBusinessCreatedAtStart";
    Quan_GetCombinedBusinessAppListOption[Quan_GetCombinedBusinessAppListOption["GetCombinedBusinessCreatedAtEnd"] = 6] = "GetCombinedBusinessCreatedAtEnd";
  })(Quan_GetCombinedBusinessAppListOption || (Quan_GetCombinedBusinessAppListOption = {}));

  return Quan_GetCombinedBusinessAppListOption;
}();
export var Quan_GetAccountCategoryReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetAccountCategoryReq_ListOption;

  (function (Quan_GetAccountCategoryReq_ListOption) {
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionAccountType"] = 1] = "ListOptionAccountType";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionInAppScope"] = 3] = "ListOptionInAppScope";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionInAuthAppScope"] = 4] = "ListOptionInAuthAppScope";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionStatusList"] = 5] = "ListOptionStatusList";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionExcludeRoleId"] = 6] = "ListOptionExcludeRoleId";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionNotPermissionFilter"] = 7] = "ListOptionNotPermissionFilter";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionInUidList"] = 8] = "ListOptionInUidList";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionNotInUidList"] = 9] = "ListOptionNotInUidList";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionUnScope"] = 10] = "ListOptionUnScope";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionRobotSnList"] = 11] = "ListOptionRobotSnList";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionRobotIdList"] = 12] = "ListOptionRobotIdList";
    Quan_GetAccountCategoryReq_ListOption[Quan_GetAccountCategoryReq_ListOption["ListOptionAppTypeRole"] = 13] = "ListOptionAppTypeRole";
  })(Quan_GetAccountCategoryReq_ListOption || (Quan_GetAccountCategoryReq_ListOption = {}));

  return Quan_GetAccountCategoryReq_ListOption;
}();
export var Quan_GetUserListSysReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetUserListSysReq_ListOption;

  (function (Quan_GetUserListSysReq_ListOption) {
    Quan_GetUserListSysReq_ListOption[Quan_GetUserListSysReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetUserListSysReq_ListOption[Quan_GetUserListSysReq_ListOption["ListOptionUidList"] = 1] = "ListOptionUidList";
    Quan_GetUserListSysReq_ListOption[Quan_GetUserListSysReq_ListOption["ListOptionMobileList"] = 2] = "ListOptionMobileList";
    Quan_GetUserListSysReq_ListOption[Quan_GetUserListSysReq_ListOption["ListOptionName"] = 3] = "ListOptionName";
  })(Quan_GetUserListSysReq_ListOption || (Quan_GetUserListSysReq_ListOption = {}));

  return Quan_GetUserListSysReq_ListOption;
}();
export var Quan_SendVerifyCodeForBindPhoneNumberReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_SendVerifyCodeForBindPhoneNumberReq_Type;

  (function (Quan_SendVerifyCodeForBindPhoneNumberReq_Type) {
    Quan_SendVerifyCodeForBindPhoneNumberReq_Type[Quan_SendVerifyCodeForBindPhoneNumberReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_SendVerifyCodeForBindPhoneNumberReq_Type[Quan_SendVerifyCodeForBindPhoneNumberReq_Type["TypeVerifyOldPhone"] = 1] = "TypeVerifyOldPhone";
    Quan_SendVerifyCodeForBindPhoneNumberReq_Type[Quan_SendVerifyCodeForBindPhoneNumberReq_Type["TypeBindPhone"] = 2] = "TypeBindPhone";
  })(Quan_SendVerifyCodeForBindPhoneNumberReq_Type || (Quan_SendVerifyCodeForBindPhoneNumberReq_Type = {}));

  return Quan_SendVerifyCodeForBindPhoneNumberReq_Type;
}(); // @desc: 改绑/修改成员账号的手机号

export var Quan_SetUpUserPhoneType = function () {
  //__ENUM_IIFE__
  var Quan_SetUpUserPhoneType;

  (function (Quan_SetUpUserPhoneType) {
    Quan_SetUpUserPhoneType[Quan_SetUpUserPhoneType["SetUpUserPhoneTypeNil"] = 0] = "SetUpUserPhoneTypeNil";
    Quan_SetUpUserPhoneType[Quan_SetUpUserPhoneType["SetUpUserPhoneTypeUserList"] = 1] = "SetUpUserPhoneTypeUserList";
  })(Quan_SetUpUserPhoneType || (Quan_SetUpUserPhoneType = {}));

  return Quan_SetUpUserPhoneType;
}();
export var Quan_GetExtContactListV2Req_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactListV2Req_ListOption;

  (function (Quan_GetExtContactListV2Req_ListOption) {
    Quan_GetExtContactListV2Req_ListOption[Quan_GetExtContactListV2Req_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetExtContactListV2Req_ListOption[Quan_GetExtContactListV2Req_ListOption["ListOptionExtUidList"] = 1] = "ListOptionExtUidList";
    Quan_GetExtContactListV2Req_ListOption[Quan_GetExtContactListV2Req_ListOption["ListOptionYcSerialNoList"] = 2] = "ListOptionYcSerialNoList";
  })(Quan_GetExtContactListV2Req_ListOption || (Quan_GetExtContactListV2Req_ListOption = {}));

  return Quan_GetExtContactListV2Req_ListOption;
}();
export var Quan_GetExtContactFollowListV2Req_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactFollowListV2Req_ListOption;

  (function (Quan_GetExtContactFollowListV2Req_ListOption) {
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["Nil"] = 0] = "Nil";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["IdList"] = 1] = "IdList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["NotIdList"] = 2] = "NotIdList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["ExtUidList"] = 3] = "ExtUidList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["NotExtUidList"] = 4] = "NotExtUidList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["UidList"] = 5] = "UidList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["NotUidList"] = 6] = "NotUidList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["TagAndList"] = 7] = "TagAndList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["NotTagAndList"] = 8] = "NotTagAndList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["TagOrList"] = 9] = "TagOrList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["NotTagOrList"] = 10] = "NotTagOrList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["ChannelIdList"] = 11] = "ChannelIdList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["NotChannelIdList"] = 12] = "NotChannelIdList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["AddWayList"] = 13] = "AddWayList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["NotAddWayList"] = 14] = "NotAddWayList";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["Name"] = 15] = "Name";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["NameIsLike"] = 16] = "NameIsLike";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["Gender"] = 17] = "Gender";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["UserInScope"] = 18] = "UserInScope";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["DeletedByStaff"] = 19] = "DeletedByStaff";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["DeletedByExtContact"] = 20] = "DeletedByExtContact";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["RemarkPhone"] = 21] = "RemarkPhone";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["DeletedTimeRange"] = 22] = "DeletedTimeRange";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["AddTimeRange"] = 23] = "AddTimeRange";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["YcSerialNoIsExist"] = 24] = "YcSerialNoIsExist";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["QueryScript"] = 25] = "QueryScript";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["RemarkName"] = 26] = "RemarkName";
    Quan_GetExtContactFollowListV2Req_ListOption[Quan_GetExtContactFollowListV2Req_ListOption["RemarkNameLike"] = 27] = "RemarkNameLike";
  })(Quan_GetExtContactFollowListV2Req_ListOption || (Quan_GetExtContactFollowListV2Req_ListOption = {}));

  return Quan_GetExtContactFollowListV2Req_ListOption;
}();
export var Quan_GetSpeechcraftShareCodeListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetSpeechcraftShareCodeListReq_ListOption;

  (function (Quan_GetSpeechcraftShareCodeListReq_ListOption) {
    Quan_GetSpeechcraftShareCodeListReq_ListOption[Quan_GetSpeechcraftShareCodeListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetSpeechcraftShareCodeListReq_ListOption[Quan_GetSpeechcraftShareCodeListReq_ListOption["ListOptionIsExpired"] = 1] = "ListOptionIsExpired";
    Quan_GetSpeechcraftShareCodeListReq_ListOption[Quan_GetSpeechcraftShareCodeListReq_ListOption["ListOptionIsPersonal"] = 2] = "ListOptionIsPersonal";
  })(Quan_GetSpeechcraftShareCodeListReq_ListOption || (Quan_GetSpeechcraftShareCodeListReq_ListOption = {}));

  return Quan_GetSpeechcraftShareCodeListReq_ListOption;
}();
export var Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption;

  (function (Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption) {
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["Nil"] = 0] = "Nil";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["IdList"] = 1] = "IdList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NotIdList"] = 2] = "NotIdList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["ExtUidList"] = 3] = "ExtUidList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NotExtUidList"] = 4] = "NotExtUidList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["UidList"] = 5] = "UidList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NotUidList"] = 6] = "NotUidList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["TagAndList"] = 7] = "TagAndList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NotTagAndList"] = 8] = "NotTagAndList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["TagOrList"] = 9] = "TagOrList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NotTagOrList"] = 10] = "NotTagOrList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["ChannelIdList"] = 11] = "ChannelIdList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NotChannelIdList"] = 12] = "NotChannelIdList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["AddWayList"] = 13] = "AddWayList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NotAddWayList"] = 14] = "NotAddWayList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["Name"] = 15] = "Name";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NameIsLike"] = 16] = "NameIsLike";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["Gender"] = 17] = "Gender";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["UserInScope"] = 18] = "UserInScope";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["DeletedByStaff"] = 19] = "DeletedByStaff";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["DeletedByExtContact"] = 20] = "DeletedByExtContact";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["RemarkPhone"] = 21] = "RemarkPhone";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["DeletedTimeRange"] = 22] = "DeletedTimeRange";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["AddTimeRange"] = 23] = "AddTimeRange";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["YcSerialNoIsExist"] = 24] = "YcSerialNoIsExist";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["QueryScript"] = 25] = "QueryScript";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["RemarkName"] = 26] = "RemarkName";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["RemarkNameLike"] = 27] = "RemarkNameLike";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NameOrRemark"] = 28] = "NameOrRemark";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NameOrRemarkLike"] = 29] = "NameOrRemarkLike";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["RFMTagAndList"] = 31] = "RFMTagAndList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["RFMTagOrList"] = 33] = "RFMTagOrList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["NotRFMTagOrList"] = 34] = "NotRFMTagOrList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["ExceptGroupChatIdList"] = 100] = "ExceptGroupChatIdList";
    Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption[Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption["GroupChatIdList"] = 101] = "GroupChatIdList";
  })(Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption || (Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption = {}));

  return Quan_GetExtContactListKeyWithFilterAsyncReq_ListOption;
}();
export var Quan_GetPersonalSpeechcraftListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetPersonalSpeechcraftListReq_ListOption;

  (function (Quan_GetPersonalSpeechcraftListReq_ListOption) {
    Quan_GetPersonalSpeechcraftListReq_ListOption[Quan_GetPersonalSpeechcraftListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetPersonalSpeechcraftListReq_ListOption[Quan_GetPersonalSpeechcraftListReq_ListOption["ListOptionSearchContent"] = 2] = "ListOptionSearchContent";
    Quan_GetPersonalSpeechcraftListReq_ListOption[Quan_GetPersonalSpeechcraftListReq_ListOption["ListOptionCategory"] = 3] = "ListOptionCategory";
  })(Quan_GetPersonalSpeechcraftListReq_ListOption || (Quan_GetPersonalSpeechcraftListReq_ListOption = {}));

  return Quan_GetPersonalSpeechcraftListReq_ListOption;
}(); // @desc: 验证账号的用途
// 在分发凭证和验证凭证时用以区分

export var Quan_ValidateAccountUsage = function () {
  //__ENUM_IIFE__
  var Quan_ValidateAccountUsage;

  (function (Quan_ValidateAccountUsage) {
    Quan_ValidateAccountUsage[Quan_ValidateAccountUsage["ValidateAccountUsageNil"] = 0] = "ValidateAccountUsageNil";
    Quan_ValidateAccountUsage[Quan_ValidateAccountUsage["ValidateAccountUsageModifyPassword"] = 1] = "ValidateAccountUsageModifyPassword";
    Quan_ValidateAccountUsage[Quan_ValidateAccountUsage["ValidateAccountUsageModifyPhone"] = 2] = "ValidateAccountUsageModifyPhone";
  })(Quan_ValidateAccountUsage || (Quan_ValidateAccountUsage = {}));

  return Quan_ValidateAccountUsage;
}();
export var Quan_ValidateAccountReq_ValidateMethod = function () {
  //__ENUM_IIFE__
  var Quan_ValidateAccountReq_ValidateMethod;

  (function (Quan_ValidateAccountReq_ValidateMethod) {
    Quan_ValidateAccountReq_ValidateMethod[Quan_ValidateAccountReq_ValidateMethod["ValidateMethodNil"] = 0] = "ValidateMethodNil";
    Quan_ValidateAccountReq_ValidateMethod[Quan_ValidateAccountReq_ValidateMethod["ValidateMethodPassword"] = 1] = "ValidateMethodPassword";
    Quan_ValidateAccountReq_ValidateMethod[Quan_ValidateAccountReq_ValidateMethod["ValidateMethodVerifyCode"] = 2] = "ValidateMethodVerifyCode";
  })(Quan_ValidateAccountReq_ValidateMethod || (Quan_ValidateAccountReq_ValidateMethod = {}));

  return Quan_ValidateAccountReq_ValidateMethod;
}();
export var Quan_GetPlatNoticeListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetPlatNoticeListReq_ListOption;

  (function (Quan_GetPlatNoticeListReq_ListOption) {
    Quan_GetPlatNoticeListReq_ListOption[Quan_GetPlatNoticeListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetPlatNoticeListReq_ListOption[Quan_GetPlatNoticeListReq_ListOption["ListOptionSearchContent"] = 2] = "ListOptionSearchContent";
    Quan_GetPlatNoticeListReq_ListOption[Quan_GetPlatNoticeListReq_ListOption["ListOptionNoticeType"] = 3] = "ListOptionNoticeType";
  })(Quan_GetPlatNoticeListReq_ListOption || (Quan_GetPlatNoticeListReq_ListOption = {}));

  return Quan_GetPlatNoticeListReq_ListOption;
}();
export var Quan_NoticeRedPointRsp_NoticeRedPointType = function () {
  //__ENUM_IIFE__
  var Quan_NoticeRedPointRsp_NoticeRedPointType;

  (function (Quan_NoticeRedPointRsp_NoticeRedPointType) {
    Quan_NoticeRedPointRsp_NoticeRedPointType[Quan_NoticeRedPointRsp_NoticeRedPointType["NoticeRedPointTypeNil"] = 0] = "NoticeRedPointTypeNil";
    Quan_NoticeRedPointRsp_NoticeRedPointType[Quan_NoticeRedPointRsp_NoticeRedPointType["NoticeRedPointTypeCommon"] = 1] = "NoticeRedPointTypeCommon";
    Quan_NoticeRedPointRsp_NoticeRedPointType[Quan_NoticeRedPointRsp_NoticeRedPointType["NoticeRedPointTypeUpdate"] = 2] = "NoticeRedPointTypeUpdate";
  })(Quan_NoticeRedPointRsp_NoticeRedPointType || (Quan_NoticeRedPointRsp_NoticeRedPointType = {}));

  return Quan_NoticeRedPointRsp_NoticeRedPointType;
}();
export var Quan_SetCorpTag2FollowActionType = function () {
  //__ENUM_IIFE__
  var Quan_SetCorpTag2FollowActionType;

  (function (Quan_SetCorpTag2FollowActionType) {
    Quan_SetCorpTag2FollowActionType[Quan_SetCorpTag2FollowActionType["ActionTypeAddTag"] = 0] = "ActionTypeAddTag";
    Quan_SetCorpTag2FollowActionType[Quan_SetCorpTag2FollowActionType["ActionTypeDelTag"] = 1] = "ActionTypeDelTag";
  })(Quan_SetCorpTag2FollowActionType || (Quan_SetCorpTag2FollowActionType = {}));

  return Quan_SetCorpTag2FollowActionType;
}();
export var Quan_ExportExtContactBatchSendStaffListReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_ExportExtContactBatchSendStaffListReq_Type;

  (function (Quan_ExportExtContactBatchSendStaffListReq_Type) {
    Quan_ExportExtContactBatchSendStaffListReq_Type[Quan_ExportExtContactBatchSendStaffListReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ExportExtContactBatchSendStaffListReq_Type[Quan_ExportExtContactBatchSendStaffListReq_Type["TypeAll"] = 1] = "TypeAll";
    Quan_ExportExtContactBatchSendStaffListReq_Type[Quan_ExportExtContactBatchSendStaffListReq_Type["TypeSent"] = 2] = "TypeSent";
    Quan_ExportExtContactBatchSendStaffListReq_Type[Quan_ExportExtContactBatchSendStaffListReq_Type["TypeUnsent"] = 3] = "TypeUnsent";
    Quan_ExportExtContactBatchSendStaffListReq_Type[Quan_ExportExtContactBatchSendStaffListReq_Type["TypeNoNeedToSend"] = 4] = "TypeNoNeedToSend";
  })(Quan_ExportExtContactBatchSendStaffListReq_Type || (Quan_ExportExtContactBatchSendStaffListReq_Type = {}));

  return Quan_ExportExtContactBatchSendStaffListReq_Type;
}();
export var Quan_ExportExtContactBatchSendStaffListReq_ReqCntType = function () {
  //__ENUM_IIFE__
  var Quan_ExportExtContactBatchSendStaffListReq_ReqCntType;

  (function (Quan_ExportExtContactBatchSendStaffListReq_ReqCntType) {
    Quan_ExportExtContactBatchSendStaffListReq_ReqCntType[Quan_ExportExtContactBatchSendStaffListReq_ReqCntType["ReqCntTypeNil"] = 0] = "ReqCntTypeNil";
    Quan_ExportExtContactBatchSendStaffListReq_ReqCntType[Quan_ExportExtContactBatchSendStaffListReq_ReqCntType["ReqCntTypeOne"] = 1] = "ReqCntTypeOne";
    Quan_ExportExtContactBatchSendStaffListReq_ReqCntType[Quan_ExportExtContactBatchSendStaffListReq_ReqCntType["ReqCntTypeGtOne"] = 2] = "ReqCntTypeGtOne";
  })(Quan_ExportExtContactBatchSendStaffListReq_ReqCntType || (Quan_ExportExtContactBatchSendStaffListReq_ReqCntType = {}));

  return Quan_ExportExtContactBatchSendStaffListReq_ReqCntType;
}();
export var Quan_ExportExtContactBatchSendStaffListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_ExportExtContactBatchSendStaffListReq_ListOption;

  (function (Quan_ExportExtContactBatchSendStaffListReq_ListOption) {
    Quan_ExportExtContactBatchSendStaffListReq_ListOption[Quan_ExportExtContactBatchSendStaffListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_ExportExtContactBatchSendStaffListReq_ListOption[Quan_ExportExtContactBatchSendStaffListReq_ListOption["ListOptionType"] = 1] = "ListOptionType";
    Quan_ExportExtContactBatchSendStaffListReq_ListOption[Quan_ExportExtContactBatchSendStaffListReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
    Quan_ExportExtContactBatchSendStaffListReq_ListOption[Quan_ExportExtContactBatchSendStaffListReq_ListOption["ListOptionReqCntType"] = 3] = "ListOptionReqCntType";
  })(Quan_ExportExtContactBatchSendStaffListReq_ListOption || (Quan_ExportExtContactBatchSendStaffListReq_ListOption = {}));

  return Quan_ExportExtContactBatchSendStaffListReq_ListOption;
}();
export var Quan_ExportExtContactBatchSendExtListReq_Type = function () {
  //__ENUM_IIFE__
  var Quan_ExportExtContactBatchSendExtListReq_Type;

  (function (Quan_ExportExtContactBatchSendExtListReq_Type) {
    Quan_ExportExtContactBatchSendExtListReq_Type[Quan_ExportExtContactBatchSendExtListReq_Type["TypeNil"] = 0] = "TypeNil";
    Quan_ExportExtContactBatchSendExtListReq_Type[Quan_ExportExtContactBatchSendExtListReq_Type["TypeAll"] = 1] = "TypeAll";
    Quan_ExportExtContactBatchSendExtListReq_Type[Quan_ExportExtContactBatchSendExtListReq_Type["TypeSent"] = 2] = "TypeSent";
    Quan_ExportExtContactBatchSendExtListReq_Type[Quan_ExportExtContactBatchSendExtListReq_Type["TypeUnsent"] = 3] = "TypeUnsent";
    Quan_ExportExtContactBatchSendExtListReq_Type[Quan_ExportExtContactBatchSendExtListReq_Type["TypeNotFriend"] = 4] = "TypeNotFriend";
    Quan_ExportExtContactBatchSendExtListReq_Type[Quan_ExportExtContactBatchSendExtListReq_Type["TypeExceedLimit"] = 5] = "TypeExceedLimit";
  })(Quan_ExportExtContactBatchSendExtListReq_Type || (Quan_ExportExtContactBatchSendExtListReq_Type = {}));

  return Quan_ExportExtContactBatchSendExtListReq_Type;
}();
export var Quan_ExportExtContactBatchSendExtListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_ExportExtContactBatchSendExtListReq_ListOption;

  (function (Quan_ExportExtContactBatchSendExtListReq_ListOption) {
    Quan_ExportExtContactBatchSendExtListReq_ListOption[Quan_ExportExtContactBatchSendExtListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_ExportExtContactBatchSendExtListReq_ListOption[Quan_ExportExtContactBatchSendExtListReq_ListOption["ListOptionType"] = 1] = "ListOptionType";
    Quan_ExportExtContactBatchSendExtListReq_ListOption[Quan_ExportExtContactBatchSendExtListReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
    Quan_ExportExtContactBatchSendExtListReq_ListOption[Quan_ExportExtContactBatchSendExtListReq_ListOption["ListOptionInviteGroupId"] = 3] = "ListOptionInviteGroupId";
    Quan_ExportExtContactBatchSendExtListReq_ListOption[Quan_ExportExtContactBatchSendExtListReq_ListOption["ListOptionStaffUid"] = 4] = "ListOptionStaffUid";
    Quan_ExportExtContactBatchSendExtListReq_ListOption[Quan_ExportExtContactBatchSendExtListReq_ListOption["ListOptionEnterGroup"] = 5] = "ListOptionEnterGroup";
  })(Quan_ExportExtContactBatchSendExtListReq_ListOption || (Quan_ExportExtContactBatchSendExtListReq_ListOption = {}));

  return Quan_ExportExtContactBatchSendExtListReq_ListOption;
}();
export var Quan_GetNotLoginStyleRsp_Style = function () {
  //__ENUM_IIFE__
  var Quan_GetNotLoginStyleRsp_Style;

  (function (Quan_GetNotLoginStyleRsp_Style) {
    Quan_GetNotLoginStyleRsp_Style[Quan_GetNotLoginStyleRsp_Style["StyleDefault"] = 0] = "StyleDefault";
    Quan_GetNotLoginStyleRsp_Style[Quan_GetNotLoginStyleRsp_Style["StyleWarn"] = 1] = "StyleWarn";
  })(Quan_GetNotLoginStyleRsp_Style || (Quan_GetNotLoginStyleRsp_Style = {}));

  return Quan_GetNotLoginStyleRsp_Style;
}();
export var Quan_GetWebConfigReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetWebConfigReq_ListOption;

  (function (Quan_GetWebConfigReq_ListOption) {
    Quan_GetWebConfigReq_ListOption[Quan_GetWebConfigReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetWebConfigReq_ListOption[Quan_GetWebConfigReq_ListOption["ListOptionDomain"] = 1] = "ListOptionDomain";
    Quan_GetWebConfigReq_ListOption[Quan_GetWebConfigReq_ListOption["ListOptionWithoutConfigStr"] = 2] = "ListOptionWithoutConfigStr";
  })(Quan_GetWebConfigReq_ListOption || (Quan_GetWebConfigReq_ListOption = {}));

  return Quan_GetWebConfigReq_ListOption;
}();
export var Quan_ExportType = function () {
  //__ENUM_IIFE__
  var Quan_ExportType;

  (function (Quan_ExportType) {
    Quan_ExportType[Quan_ExportType["Nil"] = 0] = "Nil";
    Quan_ExportType[Quan_ExportType["ExtContactFollow"] = 1] = "ExtContactFollow";
    Quan_ExportType[Quan_ExportType["Form"] = 3] = "Form";
    Quan_ExportType[Quan_ExportType["Order"] = 4] = "Order";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Phone_Qwhale_Apply"] = 5] = "FriendBatchAdd_Phone_Qwhale_Apply";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Phone_Qrobot_Apply"] = 6] = "FriendBatchAdd_Phone_Qrobot_Apply";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Phone_Qwhale"] = 7] = "FriendBatchAdd_Phone_Qwhale";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Phone_Qrobot"] = 8] = "FriendBatchAdd_Phone_Qrobot";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Api_Qwhale"] = 9] = "FriendBatchAdd_Api_Qwhale";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Api_Qrobot"] = 10] = "FriendBatchAdd_Api_Qrobot";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Order_Qwhale"] = 11] = "FriendBatchAdd_Order_Qwhale";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Order_Qrobot"] = 12] = "FriendBatchAdd_Order_Qrobot";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Group_Qwhale"] = 13] = "FriendBatchAdd_Group_Qwhale";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Group_Qrobot"] = 14] = "FriendBatchAdd_Group_Qrobot";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Card_Qwhale"] = 15] = "FriendBatchAdd_Card_Qwhale";
    Quan_ExportType[Quan_ExportType["FriendBatchAdd_Card_Qrobot"] = 16] = "FriendBatchAdd_Card_Qrobot";
    Quan_ExportType[Quan_ExportType["GroupChatMember_Qwhale"] = 17] = "GroupChatMember_Qwhale";
    Quan_ExportType[Quan_ExportType["GroupChatMember_Qrobot"] = 18] = "GroupChatMember_Qrobot";
    Quan_ExportType[Quan_ExportType["PointsMallMemberOrder"] = 19] = "PointsMallMemberOrder";
    Quan_ExportType[Quan_ExportType["OrderConvertIntegral"] = 20] = "OrderConvertIntegral";
    Quan_ExportType[Quan_ExportType["IntegralStat"] = 21] = "IntegralStat";
    Quan_ExportType[Quan_ExportType["IntegralFlow"] = 22] = "IntegralFlow";
    Quan_ExportType[Quan_ExportType["RobotOptFailedRecord"] = 23] = "RobotOptFailedRecord";
    Quan_ExportType[Quan_ExportType["AttendanceRankingList"] = 24] = "AttendanceRankingList";
    Quan_ExportType[Quan_ExportType["AttendanceDailyMemberLogList"] = 25] = "AttendanceDailyMemberLogList";
  })(Quan_ExportType || (Quan_ExportType = {}));

  return Quan_ExportType;
}();
export var Quan_ExportState = function () {
  //__ENUM_IIFE__
  var Quan_ExportState;

  (function (Quan_ExportState) {
    Quan_ExportState[Quan_ExportState["ExportStateNil"] = 0] = "ExportStateNil";
    Quan_ExportState[Quan_ExportState["ExportStateImport"] = 1] = "ExportStateImport";
    Quan_ExportState[Quan_ExportState["ExportStateApply"] = 2] = "ExportStateApply";
    Quan_ExportState[Quan_ExportState["ExportStateAdded"] = 3] = "ExportStateAdded";
    Quan_ExportState[Quan_ExportState["ExportStateDeletedByStaff"] = 4] = "ExportStateDeletedByStaff";
    Quan_ExportState[Quan_ExportState["ExportStateDeletedByExtContact"] = 5] = "ExportStateDeletedByExtContact";
  })(Quan_ExportState || (Quan_ExportState = {}));

  return Quan_ExportState;
}();
export var Quan_GetSysVersionListStaffReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetSysVersionListStaffReq_ListOption;

  (function (Quan_GetSysVersionListStaffReq_ListOption) {
    Quan_GetSysVersionListStaffReq_ListOption[Quan_GetSysVersionListStaffReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetSysVersionListStaffReq_ListOption[Quan_GetSysVersionListStaffReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetSysVersionListStaffReq_ListOption[Quan_GetSysVersionListStaffReq_ListOption["ListOptionState"] = 2] = "ListOptionState";
  })(Quan_GetSysVersionListStaffReq_ListOption || (Quan_GetSysVersionListStaffReq_ListOption = {}));

  return Quan_GetSysVersionListStaffReq_ListOption;
}();
export var Quan_ModelWxAppBizUseInfo_BindBiz = function () {
  //__ENUM_IIFE__
  var Quan_ModelWxAppBizUseInfo_BindBiz;

  (function (Quan_ModelWxAppBizUseInfo_BindBiz) {
    Quan_ModelWxAppBizUseInfo_BindBiz[Quan_ModelWxAppBizUseInfo_BindBiz["BindBizNil"] = 0] = "BindBizNil";
    Quan_ModelWxAppBizUseInfo_BindBiz[Quan_ModelWxAppBizUseInfo_BindBiz["BindBizMember"] = 1] = "BindBizMember";
  })(Quan_ModelWxAppBizUseInfo_BindBiz || (Quan_ModelWxAppBizUseInfo_BindBiz = {}));

  return Quan_ModelWxAppBizUseInfo_BindBiz;
}();
export var Quan_ModelWatermarkSetting_Field = function () {
  //__ENUM_IIFE__
  var Quan_ModelWatermarkSetting_Field;

  (function (Quan_ModelWatermarkSetting_Field) {
    Quan_ModelWatermarkSetting_Field[Quan_ModelWatermarkSetting_Field["FieldNil"] = 0] = "FieldNil";
    Quan_ModelWatermarkSetting_Field[Quan_ModelWatermarkSetting_Field["FieldLoginAccountName"] = 1] = "FieldLoginAccountName";
    Quan_ModelWatermarkSetting_Field[Quan_ModelWatermarkSetting_Field["FieldLoginAccountNumber"] = 2] = "FieldLoginAccountNumber";
    Quan_ModelWatermarkSetting_Field[Quan_ModelWatermarkSetting_Field["FieldCorpNameAbbreviation"] = 3] = "FieldCorpNameAbbreviation";
    Quan_ModelWatermarkSetting_Field[Quan_ModelWatermarkSetting_Field["FieldDate"] = 4] = "FieldDate";
    Quan_ModelWatermarkSetting_Field[Quan_ModelWatermarkSetting_Field["FieldCustomContact"] = 5] = "FieldCustomContact";
  })(Quan_ModelWatermarkSetting_Field || (Quan_ModelWatermarkSetting_Field = {}));

  return Quan_ModelWatermarkSetting_Field;
}();
export var Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType = function () {
  //__ENUM_IIFE__
  var Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType;

  (function (Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType) {
    Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType[Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType["SideBarRoleTypeNil"] = 0] = "SideBarRoleTypeNil";
    Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType[Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType["SideBarRoleTypeAll"] = 1] = "SideBarRoleTypeAll";
    Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType[Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType["SideBarRoleTypeAssign"] = 2] = "SideBarRoleTypeAssign";
    Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType[Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType["SideBarRoleTypeSelf"] = 3] = "SideBarRoleTypeSelf";
  })(Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType || (Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType = {}));

  return Quan_BatchUpdateMaterialCategoryReq_SideBarRoleType;
}();
export var Quan_BatchSetDeDupChannelLiveCodeReq_OperationType = function () {
  //__ENUM_IIFE__
  var Quan_BatchSetDeDupChannelLiveCodeReq_OperationType;

  (function (Quan_BatchSetDeDupChannelLiveCodeReq_OperationType) {
    Quan_BatchSetDeDupChannelLiveCodeReq_OperationType[Quan_BatchSetDeDupChannelLiveCodeReq_OperationType["OperationTypeNil"] = 0] = "OperationTypeNil";
    Quan_BatchSetDeDupChannelLiveCodeReq_OperationType[Quan_BatchSetDeDupChannelLiveCodeReq_OperationType["OperationTypeAcceptSettings"] = 1] = "OperationTypeAcceptSettings";
    Quan_BatchSetDeDupChannelLiveCodeReq_OperationType[Quan_BatchSetDeDupChannelLiveCodeReq_OperationType["OperationTypeAcceptUser"] = 2] = "OperationTypeAcceptUser";
    Quan_BatchSetDeDupChannelLiveCodeReq_OperationType[Quan_BatchSetDeDupChannelLiveCodeReq_OperationType["OperationTypeAcceptWelcomeMsg"] = 3] = "OperationTypeAcceptWelcomeMsg";
  })(Quan_BatchSetDeDupChannelLiveCodeReq_OperationType || (Quan_BatchSetDeDupChannelLiveCodeReq_OperationType = {}));

  return Quan_BatchSetDeDupChannelLiveCodeReq_OperationType;
}();
export var Quan_GetDeDupChannelLiveCodeListSysReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetDeDupChannelLiveCodeListSysReq_ListOption;

  (function (Quan_GetDeDupChannelLiveCodeListSysReq_ListOption) {
    Quan_GetDeDupChannelLiveCodeListSysReq_ListOption[Quan_GetDeDupChannelLiveCodeListSysReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetDeDupChannelLiveCodeListSysReq_ListOption[Quan_GetDeDupChannelLiveCodeListSysReq_ListOption["ListOptionName"] = 1] = "ListOptionName";
    Quan_GetDeDupChannelLiveCodeListSysReq_ListOption[Quan_GetDeDupChannelLiveCodeListSysReq_ListOption["ListOptionUidList"] = 2] = "ListOptionUidList";
    Quan_GetDeDupChannelLiveCodeListSysReq_ListOption[Quan_GetDeDupChannelLiveCodeListSysReq_ListOption["ListOptionChannelIdList"] = 3] = "ListOptionChannelIdList";
    Quan_GetDeDupChannelLiveCodeListSysReq_ListOption[Quan_GetDeDupChannelLiveCodeListSysReq_ListOption["ListOptionLiveCodeStateList"] = 4] = "ListOptionLiveCodeStateList";
    Quan_GetDeDupChannelLiveCodeListSysReq_ListOption[Quan_GetDeDupChannelLiveCodeListSysReq_ListOption["ListOptionDeDupLiveCodeIdList"] = 5] = "ListOptionDeDupLiveCodeIdList";
  })(Quan_GetDeDupChannelLiveCodeListSysReq_ListOption || (Quan_GetDeDupChannelLiveCodeListSysReq_ListOption = {}));

  return Quan_GetDeDupChannelLiveCodeListSysReq_ListOption;
}();
export var Quan_ModelNotifyGroup_NotifyChannel = function () {
  //__ENUM_IIFE__
  var Quan_ModelNotifyGroup_NotifyChannel;

  (function (Quan_ModelNotifyGroup_NotifyChannel) {
    Quan_ModelNotifyGroup_NotifyChannel[Quan_ModelNotifyGroup_NotifyChannel["NotifyChannelNil"] = 0] = "NotifyChannelNil";
    Quan_ModelNotifyGroup_NotifyChannel[Quan_ModelNotifyGroup_NotifyChannel["NotifyChannelWxOfficialAccounts"] = 1] = "NotifyChannelWxOfficialAccounts";
    Quan_ModelNotifyGroup_NotifyChannel[Quan_ModelNotifyGroup_NotifyChannel["NotifyChannelApp"] = 2] = "NotifyChannelApp";
    Quan_ModelNotifyGroup_NotifyChannel[Quan_ModelNotifyGroup_NotifyChannel["NotifyChannelSms"] = 3] = "NotifyChannelSms";
    Quan_ModelNotifyGroup_NotifyChannel[Quan_ModelNotifyGroup_NotifyChannel["NotifyChannelEmail"] = 4] = "NotifyChannelEmail";
  })(Quan_ModelNotifyGroup_NotifyChannel || (Quan_ModelNotifyGroup_NotifyChannel = {}));

  return Quan_ModelNotifyGroup_NotifyChannel;
}();
export var Quan_ModelNotifyGroup_NotifyEvent = function () {
  //__ENUM_IIFE__
  var Quan_ModelNotifyGroup_NotifyEvent;

  (function (Quan_ModelNotifyGroup_NotifyEvent) {
    Quan_ModelNotifyGroup_NotifyEvent[Quan_ModelNotifyGroup_NotifyEvent["NotifyEventNil"] = 0] = "NotifyEventNil";
    Quan_ModelNotifyGroup_NotifyEvent[Quan_ModelNotifyGroup_NotifyEvent["NotifyEventContactCountLimit"] = 1] = "NotifyEventContactCountLimit";
    Quan_ModelNotifyGroup_NotifyEvent[Quan_ModelNotifyGroup_NotifyEvent["NotifyEventRobotLogout"] = 2] = "NotifyEventRobotLogout";
    Quan_ModelNotifyGroup_NotifyEvent[Quan_ModelNotifyGroup_NotifyEvent["NotifyEventRobotBeBan"] = 3] = "NotifyEventRobotBeBan";
    Quan_ModelNotifyGroup_NotifyEvent[Quan_ModelNotifyGroup_NotifyEvent["NotifyEventRobotCancelBan"] = 4] = "NotifyEventRobotCancelBan";
    Quan_ModelNotifyGroup_NotifyEvent[Quan_ModelNotifyGroup_NotifyEvent["NotifyEventFriendAddDelay"] = 5] = "NotifyEventFriendAddDelay";
    Quan_ModelNotifyGroup_NotifyEvent[Quan_ModelNotifyGroup_NotifyEvent["NotifyEventRobotLoginNeedVerifyQrcode"] = 6] = "NotifyEventRobotLoginNeedVerifyQrcode";
  })(Quan_ModelNotifyGroup_NotifyEvent || (Quan_ModelNotifyGroup_NotifyEvent = {}));

  return Quan_ModelNotifyGroup_NotifyEvent;
}();
export var Quan_ModelNotifyGroup_TriggerUserType = function () {
  //__ENUM_IIFE__
  var Quan_ModelNotifyGroup_TriggerUserType;

  (function (Quan_ModelNotifyGroup_TriggerUserType) {
    Quan_ModelNotifyGroup_TriggerUserType[Quan_ModelNotifyGroup_TriggerUserType["TriggerUserTypeNil"] = 0] = "TriggerUserTypeNil";
    Quan_ModelNotifyGroup_TriggerUserType[Quan_ModelNotifyGroup_TriggerUserType["TriggerUserTypeAll"] = 1] = "TriggerUserTypeAll";
    Quan_ModelNotifyGroup_TriggerUserType[Quan_ModelNotifyGroup_TriggerUserType["TriggerUserTypeSelf"] = 2] = "TriggerUserTypeSelf";
    Quan_ModelNotifyGroup_TriggerUserType[Quan_ModelNotifyGroup_TriggerUserType["TriggerUserTypePart"] = 3] = "TriggerUserTypePart";
  })(Quan_ModelNotifyGroup_TriggerUserType || (Quan_ModelNotifyGroup_TriggerUserType = {}));

  return Quan_ModelNotifyGroup_TriggerUserType;
}(); // @desc: 同步范围枚举

export var Quan_SyncLackExtContactReq_SyncScope = function () {
  //__ENUM_IIFE__
  var Quan_SyncLackExtContactReq_SyncScope;

  (function (Quan_SyncLackExtContactReq_SyncScope) {
    Quan_SyncLackExtContactReq_SyncScope[Quan_SyncLackExtContactReq_SyncScope["SyncScopeNil"] = 0] = "SyncScopeNil";
    Quan_SyncLackExtContactReq_SyncScope[Quan_SyncLackExtContactReq_SyncScope["SyncScopeSomeUser"] = 1] = "SyncScopeSomeUser";
    Quan_SyncLackExtContactReq_SyncScope[Quan_SyncLackExtContactReq_SyncScope["SyncScopeAuthChange"] = 2] = "SyncScopeAuthChange";
    Quan_SyncLackExtContactReq_SyncScope[Quan_SyncLackExtContactReq_SyncScope["SyncScopeAllUser"] = 3] = "SyncScopeAllUser";
  })(Quan_SyncLackExtContactReq_SyncScope || (Quan_SyncLackExtContactReq_SyncScope = {}));

  return Quan_SyncLackExtContactReq_SyncScope;
}(); // @desc: 同步范围枚举

export var Quan_SyncLackExtContactSysReq_SyncScope = function () {
  //__ENUM_IIFE__
  var Quan_SyncLackExtContactSysReq_SyncScope;

  (function (Quan_SyncLackExtContactSysReq_SyncScope) {
    Quan_SyncLackExtContactSysReq_SyncScope[Quan_SyncLackExtContactSysReq_SyncScope["SyncScopeNil"] = 0] = "SyncScopeNil";
    Quan_SyncLackExtContactSysReq_SyncScope[Quan_SyncLackExtContactSysReq_SyncScope["SyncScopeSomeUser"] = 1] = "SyncScopeSomeUser";
    Quan_SyncLackExtContactSysReq_SyncScope[Quan_SyncLackExtContactSysReq_SyncScope["SyncScopeAuthChange"] = 2] = "SyncScopeAuthChange";
    Quan_SyncLackExtContactSysReq_SyncScope[Quan_SyncLackExtContactSysReq_SyncScope["SyncScopeAllUser"] = 3] = "SyncScopeAllUser";
  })(Quan_SyncLackExtContactSysReq_SyncScope || (Quan_SyncLackExtContactSysReq_SyncScope = {}));

  return Quan_SyncLackExtContactSysReq_SyncScope;
}();
export var Quan_GetNotifyGroupContentListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetNotifyGroupContentListReq_ListOption;

  (function (Quan_GetNotifyGroupContentListReq_ListOption) {
    Quan_GetNotifyGroupContentListReq_ListOption[Quan_GetNotifyGroupContentListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetNotifyGroupContentListReq_ListOption[Quan_GetNotifyGroupContentListReq_ListOption["ListOptionNotifyEvent"] = 1] = "ListOptionNotifyEvent";
    Quan_GetNotifyGroupContentListReq_ListOption[Quan_GetNotifyGroupContentListReq_ListOption["ListOptionTime"] = 2] = "ListOptionTime";
  })(Quan_GetNotifyGroupContentListReq_ListOption || (Quan_GetNotifyGroupContentListReq_ListOption = {}));

  return Quan_GetNotifyGroupContentListReq_ListOption;
}();
export var Quan_GetMaterialCategoryListSysReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMaterialCategoryListSysReq_ListOption;

  (function (Quan_GetMaterialCategoryListSysReq_ListOption) {
    Quan_GetMaterialCategoryListSysReq_ListOption[Quan_GetMaterialCategoryListSysReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMaterialCategoryListSysReq_ListOption[Quan_GetMaterialCategoryListSysReq_ListOption["ListOptionIdList"] = 1] = "ListOptionIdList";
    Quan_GetMaterialCategoryListSysReq_ListOption[Quan_GetMaterialCategoryListSysReq_ListOption["ListOptionName"] = 2] = "ListOptionName";
  })(Quan_GetMaterialCategoryListSysReq_ListOption || (Quan_GetMaterialCategoryListSysReq_ListOption = {}));

  return Quan_GetMaterialCategoryListSysReq_ListOption;
}();
export var Quan_GetMaterialListSysReq_ListOption = function () {
  //__ENUM_IIFE__
  var Quan_GetMaterialListSysReq_ListOption;

  (function (Quan_GetMaterialListSysReq_ListOption) {
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionCreateUserName"] = 1] = "ListOptionCreateUserName";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionMaterialTypeList"] = 2] = "ListOptionMaterialTypeList";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionMaterialCategoryName"] = 3] = "ListOptionMaterialCategoryName";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionCreateUserIdList"] = 4] = "ListOptionCreateUserIdList";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionMaterialCategoryId"] = 5] = "ListOptionMaterialCategoryId";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionHasCreator"] = 6] = "ListOptionHasCreator";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionMaterialContent"] = 7] = "ListOptionMaterialContent";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionCreatedAt"] = 8] = "ListOptionCreatedAt";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionCreateUserId"] = 9] = "ListOptionCreateUserId";
    Quan_GetMaterialListSysReq_ListOption[Quan_GetMaterialListSysReq_ListOption["ListOptionMaterialType"] = 10] = "ListOptionMaterialType";
  })(Quan_GetMaterialListSysReq_ListOption || (Quan_GetMaterialListSysReq_ListOption = {}));

  return Quan_GetMaterialListSysReq_ListOption;
}();